/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AIDraftPayloadResponse } from '../models';
// @ts-ignore
import type { AIDraftPromptBody } from '../models';
// @ts-ignore
import type { AIDraftedJobsResponse } from '../models';
// @ts-ignore
import type { AIPromptAnalysisBody } from '../models';
// @ts-ignore
import type { AIPromptAnalysisResponse } from '../models';
// @ts-ignore
import type { AIRegenerateJDBody } from '../models';
// @ts-ignore
import type { AIScreeningQuestionsBody } from '../models';
// @ts-ignore
import type { AIScreeningQuestionsResponse } from '../models';
// @ts-ignore
import type { AITranslateBody } from '../models';
// @ts-ignore
import type { AITranslateResponse } from '../models';
// @ts-ignore
import type { ActiveJobBody } from '../models';
// @ts-ignore
import type { ActiveJobsResponse } from '../models';
// @ts-ignore
import type { AddApplicantMessageBody } from '../models';
// @ts-ignore
import type { AddApplicantMsgResponse } from '../models';
// @ts-ignore
import type { AddItemToCartResponse } from '../models';
// @ts-ignore
import type { AddReactionMessageBody } from '../models';
// @ts-ignore
import type { AddReactionMsgResponse } from '../models';
// @ts-ignore
import type { AdminGetAllSkillsResponse } from '../models';
// @ts-ignore
import type { AdminJobApplyBody } from '../models';
// @ts-ignore
import type { AdminUpdateJobBody } from '../models';
// @ts-ignore
import type { AllJobApplicantResponse } from '../models';
// @ts-ignore
import type { AnsweredQuestionResponse } from '../models';
// @ts-ignore
import type { ApplicantAiAccessStatusResponse } from '../models';
// @ts-ignore
import type { ApplicantAiUnlockResponse } from '../models';
// @ts-ignore
import type { ApplicantDetails } from '../models';
// @ts-ignore
import type { ApplicantDetailsPage } from '../models';
// @ts-ignore
import type { ApplicantListParam } from '../models';
// @ts-ignore
import type { ApplicantRating } from '../models';
// @ts-ignore
import type { ApplicantsJobRoleAutocompleteResponse } from '../models';
// @ts-ignore
import type { AppliedJobPopupDataBody } from '../models';
// @ts-ignore
import type { AppliedJobsSummaryResponse } from '../models';
// @ts-ignore
import type { AssessmentField } from '../models';
// @ts-ignore
import type { AssessmentResponseResponse } from '../models';
// @ts-ignore
import type { AssessmentScreeningFilter } from '../models';
// @ts-ignore
import type { BestJobResponse } from '../models';
// @ts-ignore
import type { BqAudienceCountResponse } from '../models';
// @ts-ignore
import type { BqAutocompleteResponse } from '../models';
// @ts-ignore
import type { BqFilterOptionsResponse } from '../models';
// @ts-ignore
import type { BqSendEmailsBody } from '../models';
// @ts-ignore
import type { BulkAddJobApplicantMessageBody } from '../models';
// @ts-ignore
import type { BulkAddJobItemToCartBody } from '../models';
// @ts-ignore
import type { BulkAnalysisResponse } from '../models';
// @ts-ignore
import type { BulkApplicantActionBody } from '../models';
// @ts-ignore
import type { BulkJobApplyBody } from '../models';
// @ts-ignore
import type { BulkJobApplyResponse } from '../models';
// @ts-ignore
import type { BulkStatusUpdateBody } from '../models';
// @ts-ignore
import type { CandidateBoardingBody } from '../models';
// @ts-ignore
import type { CandidateMetaDetails } from '../models';
// @ts-ignore
import type { CandidateShowcaseResponse } from '../models';
// @ts-ignore
import type { ChatForApplicant } from '../models';
// @ts-ignore
import type { ChatForEmployers } from '../models';
// @ts-ignore
import type { CheckDuplicateJobResponse } from '../models';
// @ts-ignore
import type { CompetitionData } from '../models';
// @ts-ignore
import type { CompetitionStatistics } from '../models';
// @ts-ignore
import type { CopyEvaluationQuestionsBody } from '../models';
// @ts-ignore
import type { CreateApplicantNoteBody } from '../models';
// @ts-ignore
import type { CreateAssessmentDuplicateBody } from '../models';
// @ts-ignore
import type { CreateAssessmentFieldBody } from '../models';
// @ts-ignore
import type { CreateAssessmentResponse } from '../models';
// @ts-ignore
import type { CreateAssessmentResponsedBody } from '../models';
// @ts-ignore
import type { CreateDegreeBody } from '../models';
// @ts-ignore
import type { CreateDegreeResponse } from '../models';
// @ts-ignore
import type { CreateJobBody } from '../models';
// @ts-ignore
import type { CreateSkillBody } from '../models';
// @ts-ignore
import type { CreateSpecializationBody } from '../models';
// @ts-ignore
import type { CreateSpecializationResponse } from '../models';
// @ts-ignore
import type { DbAccessStatusResponse } from '../models';
// @ts-ignore
import type { DbAccessUnlockResponse } from '../models';
// @ts-ignore
import type { DegreeAutocompleteResponse } from '../models';
// @ts-ignore
import type { DeleteJobApplicantBody } from '../models';
// @ts-ignore
import type { DeleteJobCompletelyResponse } from '../models';
// @ts-ignore
import type { EmployerBulkStatusUpdateBody } from '../models';
// @ts-ignore
import type { EnableAutoJobApplyResponse } from '../models';
// @ts-ignore
import type { EnhanceResumeBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { EvaluationQuestionSourcesResponse } from '../models';
// @ts-ignore
import type { EvaluationStatusBody } from '../models';
// @ts-ignore
import type { ExternalApplicationResponse } from '../models';
// @ts-ignore
import type { ExternalApplicationStatusBody } from '../models';
// @ts-ignore
import type { ExternalApplyBody } from '../models';
// @ts-ignore
import type { FixJobFormattingBody } from '../models';
// @ts-ignore
import type { FixJobFormattingResponse } from '../models';
// @ts-ignore
import type { GenerateAndAssociateJobChallengeQuestionsBody } from '../models';
// @ts-ignore
import type { GenerateQuestionsAndCreateJobCompetitionBody } from '../models';
// @ts-ignore
import type { GenerateRecruiterMessageBody } from '../models';
// @ts-ignore
import type { GetActivityDetailsResponse } from '../models';
// @ts-ignore
import type { GetActivityResponse } from '../models';
// @ts-ignore
import type { GetActivityTypeCountsResponse } from '../models';
// @ts-ignore
import type { GetAllJobStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAllJobSummaryResponse } from '../models';
// @ts-ignore
import type { GetApplicantChatResponse } from '../models';
// @ts-ignore
import type { GetAppliedJobResponse } from '../models';
// @ts-ignore
import type { GetAssessmentResponse } from '../models';
// @ts-ignore
import type { GetCandidateJourneyResponse } from '../models';
// @ts-ignore
import type { GetDegreesResponse } from '../models';
// @ts-ignore
import type { GetFilteredApplicantUserIdsBody } from '../models';
// @ts-ignore
import type { GetJobApplicantLocationResponse } from '../models';
// @ts-ignore
import type { GetJobApplicantTagResponse } from '../models';
// @ts-ignore
import type { GetJobEvaluationCandidatesResponse } from '../models';
// @ts-ignore
import type { GetJobEvaluationsResponse } from '../models';
// @ts-ignore
import type { GetJobGroupResponse } from '../models';
// @ts-ignore
import type { GetJobProfileResponse } from '../models';
// @ts-ignore
import type { GetJobReportsResponse } from '../models';
// @ts-ignore
import type { GetJobResumeAnalysis } from '../models';
// @ts-ignore
import type { GetJobRoleSkillsResponse } from '../models';
// @ts-ignore
import type { GetOrgCsvParam } from '../models';
// @ts-ignore
import type { GetRecruiterEmailResponse } from '../models';
// @ts-ignore
import type { GetRelatedMockTestResponse } from '../models';
// @ts-ignore
import type { GetResumeBuilderResponse } from '../models';
// @ts-ignore
import type { GetResumeBuilderResponseById } from '../models';
// @ts-ignore
import type { GetResumeBuilderVersionsResponse } from '../models';
// @ts-ignore
import type { GetSimilarJobsResponse } from '../models';
// @ts-ignore
import type { GetSkillsListResponse } from '../models';
// @ts-ignore
import type { GetSpecializationsResponse } from '../models';
// @ts-ignore
import type { GetUserSkillResponse } from '../models';
// @ts-ignore
import type { GetlocationListResponse } from '../models';
// @ts-ignore
import type { GovernorCandidateListResponse } from '../models';
// @ts-ignore
import type { GovernorPlanBody } from '../models';
// @ts-ignore
import type { GovernorPlanWriteResponse } from '../models';
// @ts-ignore
import type { GovernorRunResponse } from '../models';
// @ts-ignore
import type { IDList } from '../models';
// @ts-ignore
import type { IDMail } from '../models';
// @ts-ignore
import type { InsertAssessmentScoreBody } from '../models';
// @ts-ignore
import type { InsertAssessmentScoreResponse } from '../models';
// @ts-ignore
import type { JobApplicantResponse } from '../models';
// @ts-ignore
import type { JobApplicantsMetaDataResponse } from '../models';
// @ts-ignore
import type { JobApplyAssessmentBody } from '../models';
// @ts-ignore
import type { JobAssessmentSubmitBase } from '../models';
// @ts-ignore
import type { JobByIdChandidate } from '../models';
// @ts-ignore
import type { JobByIdChandidateBase } from '../models';
// @ts-ignore
import type { JobByIdEmployer } from '../models';
// @ts-ignore
import type { JobByIdResponse } from '../models';
// @ts-ignore
import type { JobByIdSlim } from '../models';
// @ts-ignore
import type { JobEmailPreferenceUpdateBody } from '../models';
// @ts-ignore
import type { JobEmailPreferencesResponse } from '../models';
// @ts-ignore
import type { JobEvaluationBody } from '../models';
// @ts-ignore
import type { JobEvaluationResponse } from '../models';
// @ts-ignore
import type { JobGetCandidatesBody } from '../models';
// @ts-ignore
import type { JobGetCandidatesResponse } from '../models';
// @ts-ignore
import type { JobInvitationBody } from '../models';
// @ts-ignore
import type { JobInvitationResponse } from '../models';
// @ts-ignore
import type { JobInviteRejectBody } from '../models';
// @ts-ignore
import type { JobLocationSuggestionsResponse } from '../models';
// @ts-ignore
import type { JobMatchEmailDailyResponse } from '../models';
// @ts-ignore
import type { JobMatchEmailPreflightResponse } from '../models';
// @ts-ignore
import type { JobMatchEmailReachResponse } from '../models';
// @ts-ignore
import type { JobMatchEmailSendBody } from '../models';
// @ts-ignore
import type { JobMatchEmailSendResponse } from '../models';
// @ts-ignore
import type { JobMatchEmailStatsResponse } from '../models';
// @ts-ignore
import type { JobMatchEmailTestBody } from '../models';
// @ts-ignore
import type { JobMatchEmailTestResponse } from '../models';
// @ts-ignore
import type { JobMessageUnreadCountResponse } from '../models';
// @ts-ignore
import type { JobMigrateFilesResponse } from '../models';
// @ts-ignore
import type { JobNotesResponse } from '../models';
// @ts-ignore
import type { JobPostedResponse } from '../models';
// @ts-ignore
import type { JobProfileBody } from '../models';
// @ts-ignore
import type { JobProfileMatchList } from '../models';
// @ts-ignore
import type { JobProfileMilestone } from '../models';
// @ts-ignore
import type { JobProfileResponse } from '../models';
// @ts-ignore
import type { JobReportBody } from '../models';
// @ts-ignore
import type { JobResponse } from '../models';
// @ts-ignore
import type { JobRoleSuggestionsResponse } from '../models';
// @ts-ignore
import type { JobSkillSuggestionsResponse } from '../models';
// @ts-ignore
import type { LatestResumeJobFitResponse } from '../models';
// @ts-ignore
import type { LocationCountryBackfillResponse } from '../models';
// @ts-ignore
import type { LocationCountryHealthResponse } from '../models';
// @ts-ignore
import type { MatchingJobsResponse } from '../models';
// @ts-ignore
import type { MatchingProfilesResumeEntityResponse } from '../models';
// @ts-ignore
import type { MatchingProfilesUserResponse } from '../models';
// @ts-ignore
import type { Message } from '../models';
// @ts-ignore
import type { OrgApplicantChats } from '../models';
// @ts-ignore
import type { OrgChatJobs } from '../models';
// @ts-ignore
import type { OrgJobID } from '../models';
// @ts-ignore
import type { PopupDataResponseSub } from '../models';
// @ts-ignore
import type { ProfileMatchParam } from '../models';
// @ts-ignore
import type { ProfileMatchResponse } from '../models';
// @ts-ignore
import type { PublicCompanyStatisticsResponse } from '../models';
// @ts-ignore
import type { ReBuildJobMatchingProfiles } from '../models';
// @ts-ignore
import type { ReanalyzeApplicantResponse } from '../models';
// @ts-ignore
import type { RegenerateJobChallengeQuestionResponse } from '../models';
// @ts-ignore
import type { ReprocessStuckResumesBody } from '../models';
// @ts-ignore
import type { RequiredSkillsFilter } from '../models';
// @ts-ignore
import type { ResumeAnalysisResponse } from '../models';
// @ts-ignore
import type { ResumeBuilderAnalyseBody } from '../models';
// @ts-ignore
import type { ResumeBuilderAnalysis } from '../models';
// @ts-ignore
import type { ResumeBuilderAnalysisListResponse } from '../models';
// @ts-ignore
import type { ResumeBuilderBody } from '../models';
// @ts-ignore
import type { ResumeBuilderRestoreBody } from '../models';
// @ts-ignore
import type { ResumeBuilderRestoreResponse } from '../models';
// @ts-ignore
import type { ResumeJobFitAnalyseBody } from '../models';
// @ts-ignore
import type { ResumeJobFitAnalysisResponse } from '../models';
// @ts-ignore
import type { ResumeJobFitApplyBody } from '../models';
// @ts-ignore
import type { ResumeJobFitApplyResponse } from '../models';
// @ts-ignore
import type { ResumeJobFitDownloadBody } from '../models';
// @ts-ignore
import type { ResumeJobFitEnhanceBody } from '../models';
// @ts-ignore
import type { ResumeJobFitQuestionsResponse } from '../models';
// @ts-ignore
import type { ReviewJobParam } from '../models';
// @ts-ignore
import type { ReviewJobResponse } from '../models';
// @ts-ignore
import type { RewriteSnippetBody } from '../models';
// @ts-ignore
import type { RewriteSnippetResponse } from '../models';
// @ts-ignore
import type { ScreeningInsightsResponse } from '../models';
// @ts-ignore
import type { SendAssessmentMessageBody } from '../models';
// @ts-ignore
import type { SortBy } from '../models';
// @ts-ignore
import type { SpecializationAutocompleteResponse } from '../models';
// @ts-ignore
import type { SpotlightBoostBody } from '../models';
// @ts-ignore
import type { SpotlightBoostResponse } from '../models';
// @ts-ignore
import type { SpotlightOptionsResponse } from '../models';
// @ts-ignore
import type { SubmitEvaluationAssignmentBody } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UnlockInviteProfileResponse } from '../models';
// @ts-ignore
import type { UpdateDegreeBody } from '../models';
// @ts-ignore
import type { UpdateDegreeResponse } from '../models';
// @ts-ignore
import type { UpdateFieldPositionBody } from '../models';
// @ts-ignore
import type { UpdateHiringStatusBody } from '../models';
// @ts-ignore
import type { UpdateJobAnalysisStatusBody } from '../models';
// @ts-ignore
import type { UpdateJobApplicantTagBody } from '../models';
// @ts-ignore
import type { UpdateJobBody } from '../models';
// @ts-ignore
import type { UpdateJobBookmark } from '../models';
// @ts-ignore
import type { UpdateResumeBuilderBody } from '../models';
// @ts-ignore
import type { UpdateSkillBody } from '../models';
// @ts-ignore
import type { UpdateSkillResponse } from '../models';
// @ts-ignore
import type { UpdateSpecializationBody } from '../models';
// @ts-ignore
import type { UpdateSpecializationResponse } from '../models';
// @ts-ignore
import type { UpsertCandidateDetails } from '../models';
// @ts-ignore
import type { UpsertCandidateDetailsBody } from '../models';
// @ts-ignore
import type { UserResumeEntityList } from '../models';
// @ts-ignore
import type { UserResumeEntityListRemainderCount } from '../models';
/**
 * JobApiApi - axios parameter creator
 */
export const JobApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {AddApplicantMessageBody} addApplicantMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAddJobApplicantMsg: async (jobId: string, addApplicantMessageBody: AddApplicantMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiAddJobApplicantMsg', 'jobId', jobId)
            // verify required parameter 'addApplicantMessageBody' is not null or undefined
            assertParamExists('jobApiAddJobApplicantMsg', 'addApplicantMessageBody', addApplicantMessageBody)
            const localVarPath = `/job/{job_id}/chat`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addApplicantMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {BulkAddJobItemToCartBody} bulkAddJobItemToCartBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAddJobItemsToCart: async (orgId: string, bulkAddJobItemToCartBody: BulkAddJobItemToCartBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiAddJobItemsToCart', 'orgId', orgId)
            // verify required parameter 'bulkAddJobItemToCartBody' is not null or undefined
            assertParamExists('jobApiAddJobItemsToCart', 'bulkAddJobItemToCartBody', bulkAddJobItemToCartBody)
            const localVarPath = `/org/{org_id}/cart`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAddJobItemToCartBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobProfileMatchList} jobProfileMatchList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAddJobProfile: async (jobId: string, jobProfileMatchList: JobProfileMatchList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiAddJobProfile', 'jobId', jobId)
            // verify required parameter 'jobProfileMatchList' is not null or undefined
            assertParamExists('jobApiAddJobProfile', 'jobProfileMatchList', jobProfileMatchList)
            const localVarPath = `/admin/job/{job_id}/add-matching-job-profile`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileMatchList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} jobId 
         * @param {AddReactionMessageBody} addReactionMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAddReactionMsg: async (chatId: string, jobId: string, addReactionMessageBody: AddReactionMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('jobApiAddReactionMsg', 'chatId', chatId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiAddReactionMsg', 'jobId', jobId)
            // verify required parameter 'addReactionMessageBody' is not null or undefined
            assertParamExists('jobApiAddReactionMsg', 'addReactionMessageBody', addReactionMessageBody)
            const localVarPath = `/job/{job_id}/chat/{chat_id}/reaction`
                .replace('{chat_id}', encodeURIComponent(String(chatId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addReactionMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResumeBuilderBody} resumeBuilderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAddResumeBuilderDetails: async (resumeBuilderBody: ResumeBuilderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeBuilderBody' is not null or undefined
            assertParamExists('jobApiAddResumeBuilderDetails', 'resumeBuilderBody', resumeBuilderBody)
            const localVarPath = `/resume-builder/resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeBuilderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {AdminJobApplyBody} adminJobApplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAdminCreateJobApplicant: async (jobId: string, adminJobApplyBody: AdminJobApplyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiAdminCreateJobApplicant', 'jobId', jobId)
            // verify required parameter 'adminJobApplyBody' is not null or undefined
            assertParamExists('jobApiAdminCreateJobApplicant', 'adminJobApplyBody', adminJobApplyBody)
            const localVarPath = `/admin/job/{job_id}/apply`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminJobApplyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {boolean} [showJobAssociatedSkills] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAdminGetJobSkills: async (name?: string, pageNo?: number, pageSize?: number, showJobAssociatedSkills?: boolean, sortBy?: string, sortOrder?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/job/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (showJobAssociatedSkills !== undefined) {
                localVarQueryParameter['show_job_associated_skills'] = showJobAssociatedSkills;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReprocessStuckResumesBody} reprocessStuckResumesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAdminReprocessStuckResumes: async (reprocessStuckResumesBody: ReprocessStuckResumesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reprocessStuckResumesBody' is not null or undefined
            assertParamExists('jobApiAdminReprocessStuckResumes', 'reprocessStuckResumesBody', reprocessStuckResumesBody)
            const localVarPath = `/admin/jobs/reprocess-stuck-resumes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reprocessStuckResumesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {IDMail} iDMail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAdminWithdrawJobApplication: async (jobId: string, iDMail: IDMail, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiAdminWithdrawJobApplication', 'jobId', jobId)
            // verify required parameter 'iDMail' is not null or undefined
            assertParamExists('jobApiAdminWithdrawJobApplication', 'iDMail', iDMail)
            const localVarPath = `/admin/job/{job_id}/withdraw`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDMail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AIPromptAnalysisBody} aIPromptAnalysisBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAiDraftAnalyze: async (orgId: string, aIPromptAnalysisBody: AIPromptAnalysisBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiAiDraftAnalyze', 'orgId', orgId)
            // verify required parameter 'aIPromptAnalysisBody' is not null or undefined
            assertParamExists('jobApiAiDraftAnalyze', 'aIPromptAnalysisBody', aIPromptAnalysisBody)
            const localVarPath = `/org/{org_id}/job/ai-draft/analyze`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aIPromptAnalysisBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AIScreeningQuestionsBody} aIScreeningQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAiDraftQuestions: async (orgId: string, aIScreeningQuestionsBody: AIScreeningQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiAiDraftQuestions', 'orgId', orgId)
            // verify required parameter 'aIScreeningQuestionsBody' is not null or undefined
            assertParamExists('jobApiAiDraftQuestions', 'aIScreeningQuestionsBody', aIScreeningQuestionsBody)
            const localVarPath = `/org/{org_id}/job/ai-draft/questions`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aIScreeningQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AIRegenerateJDBody} aIRegenerateJDBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAiDraftRegenerateJd: async (orgId: string, aIRegenerateJDBody: AIRegenerateJDBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiAiDraftRegenerateJd', 'orgId', orgId)
            // verify required parameter 'aIRegenerateJDBody' is not null or undefined
            assertParamExists('jobApiAiDraftRegenerateJd', 'aIRegenerateJDBody', aIRegenerateJDBody)
            const localVarPath = `/org/{org_id}/job/ai-draft/regenerate-jd`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aIRegenerateJDBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AIDraftPromptBody} aIDraftPromptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAiDraftStream: async (orgId: string, aIDraftPromptBody: AIDraftPromptBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiAiDraftStream', 'orgId', orgId)
            // verify required parameter 'aIDraftPromptBody' is not null or undefined
            assertParamExists('jobApiAiDraftStream', 'aIDraftPromptBody', aIDraftPromptBody)
            const localVarPath = `/org/{org_id}/job/ai-draft/stream`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aIDraftPromptBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AITranslateBody} aITranslateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAiDraftTranslate: async (orgId: string, aITranslateBody: AITranslateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiAiDraftTranslate', 'orgId', orgId)
            // verify required parameter 'aITranslateBody' is not null or undefined
            assertParamExists('jobApiAiDraftTranslate', 'aITranslateBody', aITranslateBody)
            const localVarPath = `/org/{org_id}/job/ai-draft/translate`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aITranslateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAnalyseIsolatedUserResumes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/analyse-isolated-user-resumes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} versionNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAnalyzeResume: async (resumeBuilderId: string, versionNo: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeBuilderId' is not null or undefined
            assertParamExists('jobApiAnalyzeResume', 'resumeBuilderId', resumeBuilderId)
            // verify required parameter 'versionNo' is not null or undefined
            assertParamExists('jobApiAnalyzeResume', 'versionNo', versionNo)
            const localVarPath = `/resume-builder/{resume_builder_id}/version/{version_no}/analyze`
                .replace('{resume_builder_id}', encodeURIComponent(String(resumeBuilderId)))
                .replace('{version_no}', encodeURIComponent(String(versionNo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} versionNo 
         * @param {ResumeBuilderAnalyseBody} resumeBuilderAnalyseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAnalyzeResumeBuilder: async (resumeBuilderId: string, versionNo: string, resumeBuilderAnalyseBody: ResumeBuilderAnalyseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeBuilderId' is not null or undefined
            assertParamExists('jobApiAnalyzeResumeBuilder', 'resumeBuilderId', resumeBuilderId)
            // verify required parameter 'versionNo' is not null or undefined
            assertParamExists('jobApiAnalyzeResumeBuilder', 'versionNo', versionNo)
            // verify required parameter 'resumeBuilderAnalyseBody' is not null or undefined
            assertParamExists('jobApiAnalyzeResumeBuilder', 'resumeBuilderAnalyseBody', resumeBuilderAnalyseBody)
            const localVarPath = `/resume-builder/{resume_builder_id}/version/{version_no}/analysis`
                .replace('{resume_builder_id}', encodeURIComponent(String(resumeBuilderId)))
                .replace('{version_no}', encodeURIComponent(String(versionNo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeBuilderAnalyseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {ResumeJobFitAnalyseBody} resumeJobFitAnalyseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAnalyzeResumeJobFit: async (jobId: string, userResumeId: string, resumeJobFitAnalyseBody: ResumeJobFitAnalyseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiAnalyzeResumeJobFit', 'jobId', jobId)
            // verify required parameter 'userResumeId' is not null or undefined
            assertParamExists('jobApiAnalyzeResumeJobFit', 'userResumeId', userResumeId)
            // verify required parameter 'resumeJobFitAnalyseBody' is not null or undefined
            assertParamExists('jobApiAnalyzeResumeJobFit', 'resumeJobFitAnalyseBody', resumeJobFitAnalyseBody)
            const localVarPath = `/resume/{user_resume_id}/job/{job_id}/fit-analysis`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{user_resume_id}', encodeURIComponent(String(userResumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeJobFitAnalyseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {SpotlightBoostBody} spotlightBoostBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiApplySpotlightBoost: async (jobId: string, spotlightBoostBody: SpotlightBoostBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiApplySpotlightBoost', 'jobId', jobId)
            // verify required parameter 'spotlightBoostBody' is not null or undefined
            assertParamExists('jobApiApplySpotlightBoost', 'spotlightBoostBody', spotlightBoostBody)
            const localVarPath = `/job/{job_id}/spotlight`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spotlightBoostBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {ResumeJobFitApplyBody} resumeJobFitApplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiApplyWithJobFitResume: async (jobId: string, userResumeId: string, resumeJobFitApplyBody: ResumeJobFitApplyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiApplyWithJobFitResume', 'jobId', jobId)
            // verify required parameter 'userResumeId' is not null or undefined
            assertParamExists('jobApiApplyWithJobFitResume', 'userResumeId', userResumeId)
            // verify required parameter 'resumeJobFitApplyBody' is not null or undefined
            assertParamExists('jobApiApplyWithJobFitResume', 'resumeJobFitApplyBody', resumeJobFitApplyBody)
            const localVarPath = `/resume/{user_resume_id}/job/{job_id}/fit-apply-resume`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{user_resume_id}', encodeURIComponent(String(userResumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeJobFitApplyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAssociateJobWithCompetition: async (competitionId: string, jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('jobApiAssociateJobWithCompetition', 'competitionId', competitionId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiAssociateJobWithCompetition', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/competition/{competition_id}/associate`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [categories] 
         * @param {Array<string>} [companies] 
         * @param {Array<string>} [countries] 
         * @param {Array<string>} [excludeCategories] 
         * @param {Array<string>} [excludeCompanies] 
         * @param {Array<string>} [excludeCountries] 
         * @param {Array<string>} [excludeLocationKeywords] 
         * @param {Array<string>} [excludePositionKeywords] 
         * @param {Array<string>} [excludeScrapers] 
         * @param {Array<string>} [excludeTags] 
         * @param {Array<string>} [excludeTitleKeywords] 
         * @param {boolean | null} [isEmailCorporate] 
         * @param {Array<string>} [locationKeywords] 
         * @param {Array<string>} [positionKeywords] 
         * @param {Array<string>} [scrapers] 
         * @param {Array<string>} [tags] 
         * @param {Array<string>} [titleKeywords] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBqAudienceCountApi: async (categories?: Array<string>, companies?: Array<string>, countries?: Array<string>, excludeCategories?: Array<string>, excludeCompanies?: Array<string>, excludeCountries?: Array<string>, excludeLocationKeywords?: Array<string>, excludePositionKeywords?: Array<string>, excludeScrapers?: Array<string>, excludeTags?: Array<string>, excludeTitleKeywords?: Array<string>, isEmailCorporate?: boolean | null, locationKeywords?: Array<string>, positionKeywords?: Array<string>, scrapers?: Array<string>, tags?: Array<string>, titleKeywords?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/bq/audience-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }

            if (companies) {
                localVarQueryParameter['companies'] = companies;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (excludeCategories) {
                localVarQueryParameter['exclude_categories'] = excludeCategories;
            }

            if (excludeCompanies) {
                localVarQueryParameter['exclude_companies'] = excludeCompanies;
            }

            if (excludeCountries) {
                localVarQueryParameter['exclude_countries'] = excludeCountries;
            }

            if (excludeLocationKeywords) {
                localVarQueryParameter['exclude_location_keywords'] = excludeLocationKeywords;
            }

            if (excludePositionKeywords) {
                localVarQueryParameter['exclude_position_keywords'] = excludePositionKeywords;
            }

            if (excludeScrapers) {
                localVarQueryParameter['exclude_scrapers'] = excludeScrapers;
            }

            if (excludeTags) {
                localVarQueryParameter['exclude_tags'] = excludeTags;
            }

            if (excludeTitleKeywords) {
                localVarQueryParameter['exclude_title_keywords'] = excludeTitleKeywords;
            }

            if (isEmailCorporate !== undefined) {
                localVarQueryParameter['is_email_corporate'] = isEmailCorporate;
            }

            if (locationKeywords) {
                localVarQueryParameter['location_keywords'] = locationKeywords;
            }

            if (positionKeywords) {
                localVarQueryParameter['position_keywords'] = positionKeywords;
            }

            if (scrapers) {
                localVarQueryParameter['scrapers'] = scrapers;
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }

            if (titleKeywords) {
                localVarQueryParameter['title_keywords'] = titleKeywords;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [categories] 
         * @param {Array<string>} [companies] 
         * @param {Array<string>} [countries] 
         * @param {Array<string>} [excludeCategories] 
         * @param {Array<string>} [excludeCompanies] 
         * @param {Array<string>} [excludeCountries] 
         * @param {Array<string>} [excludeLocationKeywords] 
         * @param {Array<string>} [excludePositionKeywords] 
         * @param {Array<string>} [excludeScrapers] 
         * @param {Array<string>} [excludeTags] 
         * @param {Array<string>} [excludeTitleKeywords] 
         * @param {JobApiBqAudienceExportApiFormatEnum} [format] 
         * @param {boolean | null} [isEmailCorporate] 
         * @param {number} [limit] 
         * @param {Array<string>} [locationKeywords] 
         * @param {number} [offset] 
         * @param {Array<string>} [positionKeywords] 
         * @param {Array<string>} [scrapers] 
         * @param {Array<string>} [tags] 
         * @param {Array<string>} [titleKeywords] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBqAudienceExportApi: async (categories?: Array<string>, companies?: Array<string>, countries?: Array<string>, excludeCategories?: Array<string>, excludeCompanies?: Array<string>, excludeCountries?: Array<string>, excludeLocationKeywords?: Array<string>, excludePositionKeywords?: Array<string>, excludeScrapers?: Array<string>, excludeTags?: Array<string>, excludeTitleKeywords?: Array<string>, format?: JobApiBqAudienceExportApiFormatEnum, isEmailCorporate?: boolean | null, limit?: number, locationKeywords?: Array<string>, offset?: number, positionKeywords?: Array<string>, scrapers?: Array<string>, tags?: Array<string>, titleKeywords?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/bq/audience-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }

            if (companies) {
                localVarQueryParameter['companies'] = companies;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (excludeCategories) {
                localVarQueryParameter['exclude_categories'] = excludeCategories;
            }

            if (excludeCompanies) {
                localVarQueryParameter['exclude_companies'] = excludeCompanies;
            }

            if (excludeCountries) {
                localVarQueryParameter['exclude_countries'] = excludeCountries;
            }

            if (excludeLocationKeywords) {
                localVarQueryParameter['exclude_location_keywords'] = excludeLocationKeywords;
            }

            if (excludePositionKeywords) {
                localVarQueryParameter['exclude_position_keywords'] = excludePositionKeywords;
            }

            if (excludeScrapers) {
                localVarQueryParameter['exclude_scrapers'] = excludeScrapers;
            }

            if (excludeTags) {
                localVarQueryParameter['exclude_tags'] = excludeTags;
            }

            if (excludeTitleKeywords) {
                localVarQueryParameter['exclude_title_keywords'] = excludeTitleKeywords;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (isEmailCorporate !== undefined) {
                localVarQueryParameter['is_email_corporate'] = isEmailCorporate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (locationKeywords) {
                localVarQueryParameter['location_keywords'] = locationKeywords;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (positionKeywords) {
                localVarQueryParameter['position_keywords'] = positionKeywords;
            }

            if (scrapers) {
                localVarQueryParameter['scrapers'] = scrapers;
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }

            if (titleKeywords) {
                localVarQueryParameter['title_keywords'] = titleKeywords;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobApiBqAutocompleteApiFieldEnum} field 
         * @param {Array<string>} [categories] 
         * @param {Array<string>} [companies] 
         * @param {Array<string>} [countries] 
         * @param {Array<string>} [excludeCategories] 
         * @param {Array<string>} [excludeCompanies] 
         * @param {Array<string>} [excludeCountries] 
         * @param {Array<string>} [excludeLocationKeywords] 
         * @param {Array<string>} [excludePositionKeywords] 
         * @param {Array<string>} [excludeScrapers] 
         * @param {Array<string>} [excludeTags] 
         * @param {Array<string>} [excludeTitleKeywords] 
         * @param {boolean | null} [isEmailCorporate] 
         * @param {Array<string>} [locationKeywords] 
         * @param {Array<string>} [positionKeywords] 
         * @param {string} [q] 
         * @param {Array<string>} [scrapers] 
         * @param {Array<string>} [tags] 
         * @param {Array<string>} [titleKeywords] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBqAutocompleteApi: async (field: JobApiBqAutocompleteApiFieldEnum, categories?: Array<string>, companies?: Array<string>, countries?: Array<string>, excludeCategories?: Array<string>, excludeCompanies?: Array<string>, excludeCountries?: Array<string>, excludeLocationKeywords?: Array<string>, excludePositionKeywords?: Array<string>, excludeScrapers?: Array<string>, excludeTags?: Array<string>, excludeTitleKeywords?: Array<string>, isEmailCorporate?: boolean | null, locationKeywords?: Array<string>, positionKeywords?: Array<string>, q?: string, scrapers?: Array<string>, tags?: Array<string>, titleKeywords?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'field' is not null or undefined
            assertParamExists('jobApiBqAutocompleteApi', 'field', field)
            const localVarPath = `/job/bq/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }

            if (companies) {
                localVarQueryParameter['companies'] = companies;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (excludeCategories) {
                localVarQueryParameter['exclude_categories'] = excludeCategories;
            }

            if (excludeCompanies) {
                localVarQueryParameter['exclude_companies'] = excludeCompanies;
            }

            if (excludeCountries) {
                localVarQueryParameter['exclude_countries'] = excludeCountries;
            }

            if (excludeLocationKeywords) {
                localVarQueryParameter['exclude_location_keywords'] = excludeLocationKeywords;
            }

            if (excludePositionKeywords) {
                localVarQueryParameter['exclude_position_keywords'] = excludePositionKeywords;
            }

            if (excludeScrapers) {
                localVarQueryParameter['exclude_scrapers'] = excludeScrapers;
            }

            if (excludeTags) {
                localVarQueryParameter['exclude_tags'] = excludeTags;
            }

            if (excludeTitleKeywords) {
                localVarQueryParameter['exclude_title_keywords'] = excludeTitleKeywords;
            }

            if (field !== undefined) {
                localVarQueryParameter['field'] = field;
            }

            if (isEmailCorporate !== undefined) {
                localVarQueryParameter['is_email_corporate'] = isEmailCorporate;
            }

            if (locationKeywords) {
                localVarQueryParameter['location_keywords'] = locationKeywords;
            }

            if (positionKeywords) {
                localVarQueryParameter['position_keywords'] = positionKeywords;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (scrapers) {
                localVarQueryParameter['scrapers'] = scrapers;
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }

            if (titleKeywords) {
                localVarQueryParameter['title_keywords'] = titleKeywords;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {BulkApplicantActionBody} bulkApplicantActionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBulkActionOnApplicants: async (jobId: string, orgId: string, bulkApplicantActionBody: BulkApplicantActionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiBulkActionOnApplicants', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiBulkActionOnApplicants', 'orgId', orgId)
            // verify required parameter 'bulkApplicantActionBody' is not null or undefined
            assertParamExists('jobApiBulkActionOnApplicants', 'bulkApplicantActionBody', bulkApplicantActionBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/bulk-action-applicants`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkApplicantActionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {BulkAddJobApplicantMessageBody} bulkAddJobApplicantMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBulkAddJobApplicantMessage: async (jobId: string, orgId: string, bulkAddJobApplicantMessageBody: BulkAddJobApplicantMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiBulkAddJobApplicantMessage', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiBulkAddJobApplicantMessage', 'orgId', orgId)
            // verify required parameter 'bulkAddJobApplicantMessageBody' is not null or undefined
            assertParamExists('jobApiBulkAddJobApplicantMessage', 'bulkAddJobApplicantMessageBody', bulkAddJobApplicantMessageBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/chat/bulk`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAddJobApplicantMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkStatusUpdateBody} bulkStatusUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBulkJobStatusUpdate: async (bulkStatusUpdateBody: BulkStatusUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkStatusUpdateBody' is not null or undefined
            assertParamExists('jobApiBulkJobStatusUpdate', 'bulkStatusUpdateBody', bulkStatusUpdateBody)
            const localVarPath = `/job/bulk-status-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkStatusUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CandidateBoardingBody} candidateBoardingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCandidateOnboarding: async (candidateBoardingBody: CandidateBoardingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'candidateBoardingBody' is not null or undefined
            assertParamExists('jobApiCandidateOnboarding', 'candidateBoardingBody', candidateBoardingBody)
            const localVarPath = `/job/candidate-onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(candidateBoardingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [role] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCandidateShowcase: async (role?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/candidate-showcase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCheckDuplicateJob: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiCheckDuplicateJob', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiCheckDuplicateJob', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/check-duplicate-job`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobProfileBody} jobProfileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCompleteJobProfile: async (jobProfileBody: JobProfileBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobProfileBody' is not null or undefined
            assertParamExists('jobApiCompleteJobProfile', 'jobProfileBody', jobProfileBody)
            const localVarPath = `/job/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobProfileBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {CopyEvaluationQuestionsBody} copyEvaluationQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCopyEvaluationQuestions: async (evaluationId: string, jobId: string, orgId: string, copyEvaluationQuestionsBody: CopyEvaluationQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evaluationId' is not null or undefined
            assertParamExists('jobApiCopyEvaluationQuestions', 'evaluationId', evaluationId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiCopyEvaluationQuestions', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiCopyEvaluationQuestions', 'orgId', orgId)
            // verify required parameter 'copyEvaluationQuestionsBody' is not null or undefined
            assertParamExists('jobApiCopyEvaluationQuestions', 'copyEvaluationQuestionsBody', copyEvaluationQuestionsBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/evaluation/{evaluation_id}/copy-questions`
                .replace('{evaluation_id}', encodeURIComponent(String(evaluationId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyEvaluationQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {CreateApplicantNoteBody} createApplicantNoteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateApplicantNote: async (applicantId: string, jobId: string, orgId: string, createApplicantNoteBody: CreateApplicantNoteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('jobApiCreateApplicantNote', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiCreateApplicantNote', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiCreateApplicantNote', 'orgId', orgId)
            // verify required parameter 'createApplicantNoteBody' is not null or undefined
            assertParamExists('jobApiCreateApplicantNote', 'createApplicantNoteBody', createApplicantNoteBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicants/{applicant_id}/notes`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createApplicantNoteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateAssessment: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiCreateAssessment', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/assessment`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAssessmentDuplicateBody} createAssessmentDuplicateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateAssessmentDuplicate: async (createAssessmentDuplicateBody: CreateAssessmentDuplicateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAssessmentDuplicateBody' is not null or undefined
            assertParamExists('jobApiCreateAssessmentDuplicate', 'createAssessmentDuplicateBody', createAssessmentDuplicateBody)
            const localVarPath = `/assessment/duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssessmentDuplicateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {CreateAssessmentFieldBody} createAssessmentFieldBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateAssessmentField: async (assessmentId: string, createAssessmentFieldBody: CreateAssessmentFieldBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('jobApiCreateAssessmentField', 'assessmentId', assessmentId)
            // verify required parameter 'createAssessmentFieldBody' is not null or undefined
            assertParamExists('jobApiCreateAssessmentField', 'createAssessmentFieldBody', createAssessmentFieldBody)
            const localVarPath = `/assessment/{assessment_id}/field`
                .replace('{assessment_id}', encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssessmentFieldBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkJobApplyBody} bulkJobApplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateBulkJobsApplicants: async (bulkJobApplyBody: BulkJobApplyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkJobApplyBody' is not null or undefined
            assertParamExists('jobApiCreateBulkJobsApplicants', 'bulkJobApplyBody', bulkJobApplyBody)
            const localVarPath = `/job/bulk-apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkJobApplyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateCompanyXml: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sitemap/company.xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CreateDegreeBody>} createDegreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateDegree: async (createDegreeBody: Array<CreateDegreeBody>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDegreeBody' is not null or undefined
            assertParamExists('jobApiCreateDegree', 'createDegreeBody', createDegreeBody)
            const localVarPath = `/admin/degree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDegreeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateJobBody} createJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJob: async (orgId: string, createJobBody: CreateJobBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiCreateJob', 'orgId', orgId)
            // verify required parameter 'createJobBody' is not null or undefined
            assertParamExists('jobApiCreateJob', 'createJobBody', createJobBody)
            const localVarPath = `/org/{org_id}/job`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJobBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobApplyAssessmentBody} jobApplyAssessmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobApplicants: async (jobId: string, jobApplyAssessmentBody: JobApplyAssessmentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiCreateJobApplicants', 'jobId', jobId)
            // verify required parameter 'jobApplyAssessmentBody' is not null or undefined
            assertParamExists('jobApiCreateJobApplicants', 'jobApplyAssessmentBody', jobApplyAssessmentBody)
            const localVarPath = `/job/{job_id}/apply`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobApplyAssessmentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {GetFilteredApplicantUserIdsBody} getFilteredApplicantUserIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobCandidateCsv: async (jobId: string, orgId: string, getFilteredApplicantUserIdsBody: GetFilteredApplicantUserIdsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiCreateJobCandidateCsv', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiCreateJobCandidateCsv', 'orgId', orgId)
            // verify required parameter 'getFilteredApplicantUserIdsBody' is not null or undefined
            assertParamExists('jobApiCreateJobCandidateCsv', 'getFilteredApplicantUserIdsBody', getFilteredApplicantUserIdsBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/download-candidates-csv`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFilteredApplicantUserIdsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {JobEvaluationBody} jobEvaluationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobEvaluation: async (jobId: string, orgId: string, jobEvaluationBody: JobEvaluationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiCreateJobEvaluation', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiCreateJobEvaluation', 'orgId', orgId)
            // verify required parameter 'jobEvaluationBody' is not null or undefined
            assertParamExists('jobApiCreateJobEvaluation', 'jobEvaluationBody', jobEvaluationBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/evaluations`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobEvaluationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobLocationXml: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sitemap/job-location.xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobReportBody} jobReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobReport: async (jobReportBody: JobReportBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobReportBody' is not null or undefined
            assertParamExists('jobApiCreateJobReport', 'jobReportBody', jobReportBody)
            const localVarPath = `/job/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobReportBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobRoleXml: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sitemap/job-role.xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobsXml: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sitemap/jobs.xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateSitemapOfSitemapsXml: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sitemap/index.xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSkillBody} createSkillBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateSkillBulk: async (createSkillBody: CreateSkillBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSkillBody' is not null or undefined
            assertParamExists('jobApiCreateSkillBulk', 'createSkillBody', createSkillBody)
            const localVarPath = `/admin/job/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSkillBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CreateSpecializationBody>} createSpecializationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateSpecialization: async (createSpecializationBody: Array<CreateSpecializationBody>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSpecializationBody' is not null or undefined
            assertParamExists('jobApiCreateSpecialization', 'createSpecializationBody', createSpecializationBody)
            const localVarPath = `/admin/specialization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSpecializationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [degreeId] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDegreeAutoComplete: async (degreeId?: string, pageNo?: string, pageSize?: string, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/degree/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (degreeId !== undefined) {
                localVarQueryParameter['degree_id'] = degreeId;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} noteId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteApplicantNote: async (jobId: string, noteId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiDeleteApplicantNote', 'jobId', jobId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('jobApiDeleteApplicantNote', 'noteId', noteId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiDeleteApplicantNote', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicants/notes/{note_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{note_id}', encodeURIComponent(String(noteId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteAssessment: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('jobApiDeleteAssessment', 'assessmentId', assessmentId)
            const localVarPath = `/assessment/{assessment_id}`
                .replace('{assessment_id}', encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteAssessmentField: async (assessmentId: string, fieldId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('jobApiDeleteAssessmentField', 'assessmentId', assessmentId)
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('jobApiDeleteAssessmentField', 'fieldId', fieldId)
            const localVarPath = `/assessment/{assessment_id}/field/{field_id}`
                .replace('{assessment_id}', encodeURIComponent(String(assessmentId)))
                .replace('{field_id}', encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteAssessmentResponse: async (assessmentId: string, responseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('jobApiDeleteAssessmentResponse', 'assessmentId', assessmentId)
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('jobApiDeleteAssessmentResponse', 'responseId', responseId)
            const localVarPath = `/assessment/{assessment_id}/response/{response_id}`
                .replace('{assessment_id}', encodeURIComponent(String(assessmentId)))
                .replace('{response_id}', encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} degreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteDegree: async (degreeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'degreeId' is not null or undefined
            assertParamExists('jobApiDeleteDegree', 'degreeId', degreeId)
            const localVarPath = `/admin/degree/{degree_id}`
                .replace('{degree_id}', encodeURIComponent(String(degreeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteJob: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiDeleteJob', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiDeleteJob', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteJobApplicantMsg: async (chatId: string, jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('jobApiDeleteJobApplicantMsg', 'chatId', chatId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiDeleteJobApplicantMsg', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/chat/{chat_id}`
                .replace('{chat_id}', encodeURIComponent(String(chatId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteJobCompletely: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiDeleteJobCompletely', 'jobId', jobId)
            const localVarPath = `/admin/delete-job-completely/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} chatReactionId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteReactionMsg: async (chatId: string, chatReactionId: string, jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('jobApiDeleteReactionMsg', 'chatId', chatId)
            // verify required parameter 'chatReactionId' is not null or undefined
            assertParamExists('jobApiDeleteReactionMsg', 'chatReactionId', chatReactionId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiDeleteReactionMsg', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/chat/{chat_id}/chat_reaction/{chat_reaction_id}`
                .replace('{chat_id}', encodeURIComponent(String(chatId)))
                .replace('{chat_reaction_id}', encodeURIComponent(String(chatReactionId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} [versionNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteResumeBuilderDetails: async (resumeBuilderId: string, versionNo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeBuilderId' is not null or undefined
            assertParamExists('jobApiDeleteResumeBuilderDetails', 'resumeBuilderId', resumeBuilderId)
            const localVarPath = `/resume-builder/resume/{resume_builder_id}`
                .replace('{resume_builder_id}', encodeURIComponent(String(resumeBuilderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (versionNo !== undefined) {
                localVarQueryParameter['version_no'] = versionNo;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {DeleteJobApplicantBody} deleteJobApplicantBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteResumeJobApplicant: async (jobId: string, orgId: string, deleteJobApplicantBody: DeleteJobApplicantBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiDeleteResumeJobApplicant', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiDeleteResumeJobApplicant', 'orgId', orgId)
            // verify required parameter 'deleteJobApplicantBody' is not null or undefined
            assertParamExists('jobApiDeleteResumeJobApplicant', 'deleteJobApplicantBody', deleteJobApplicantBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/job_applicant`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteJobApplicantBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteSkill: async (iDList: IDList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDList' is not null or undefined
            assertParamExists('jobApiDeleteSkill', 'iDList', iDList)
            const localVarPath = `/admin/job/skills/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} specializationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteSpecialization: async (specializationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'specializationId' is not null or undefined
            assertParamExists('jobApiDeleteSpecialization', 'specializationId', specializationId)
            const localVarPath = `/admin/specialization/{specialization_id}`
                .replace('{specialization_id}', encodeURIComponent(String(specializationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteUserSkill: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('jobApiDeleteUserSkill', 'skillId', skillId)
            const localVarPath = `/job/user-skill/{skill_id}`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDisableAutoJobApply: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/auto-job-apply/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDownloadJobProfileMatchById: async (jobId: string, orgId: string, profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiDownloadJobProfileMatchById', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiDownloadJobProfileMatchById', 'orgId', orgId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('jobApiDownloadJobProfileMatchById', 'profileId', profileId)
            const localVarPath = `/org/{org_id}/job/{job_id}/profile/{profile_id}/download`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{profile_id}', encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {ResumeJobFitDownloadBody} resumeJobFitDownloadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDownloadResumeJobFit: async (jobId: string, userResumeId: string, resumeJobFitDownloadBody: ResumeJobFitDownloadBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiDownloadResumeJobFit', 'jobId', jobId)
            // verify required parameter 'userResumeId' is not null or undefined
            assertParamExists('jobApiDownloadResumeJobFit', 'userResumeId', userResumeId)
            // verify required parameter 'resumeJobFitDownloadBody' is not null or undefined
            assertParamExists('jobApiDownloadResumeJobFit', 'resumeJobFitDownloadBody', resumeJobFitDownloadBody)
            const localVarPath = `/resume/{user_resume_id}/job/{job_id}/fit-download`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{user_resume_id}', encodeURIComponent(String(userResumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeJobFitDownloadBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {UserResumeEntityList} userResumeEntityList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiEmailAllMatchingJobProfiles: async (jobId: string, userResumeEntityList: UserResumeEntityList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiEmailAllMatchingJobProfiles', 'jobId', jobId)
            // verify required parameter 'userResumeEntityList' is not null or undefined
            assertParamExists('jobApiEmailAllMatchingJobProfiles', 'userResumeEntityList', userResumeEntityList)
            const localVarPath = `/admin/job/{job_id}/email-matching-profiles`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userResumeEntityList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {EmployerBulkStatusUpdateBody} employerBulkStatusUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiEmployerBulkJobStatusUpdate: async (orgId: string, employerBulkStatusUpdateBody: EmployerBulkStatusUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiEmployerBulkJobStatusUpdate', 'orgId', orgId)
            // verify required parameter 'employerBulkStatusUpdateBody' is not null or undefined
            assertParamExists('jobApiEmployerBulkJobStatusUpdate', 'employerBulkStatusUpdateBody', employerBulkStatusUpdateBody)
            const localVarPath = `/org/{org_id}/job/bulk-close`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employerBulkStatusUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiEnableAutoJobApply: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/auto-job-apply/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} versionNo 
         * @param {EnhanceResumeBody} enhanceResumeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiEnhanceResume: async (resumeBuilderId: string, versionNo: string, enhanceResumeBody: EnhanceResumeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeBuilderId' is not null or undefined
            assertParamExists('jobApiEnhanceResume', 'resumeBuilderId', resumeBuilderId)
            // verify required parameter 'versionNo' is not null or undefined
            assertParamExists('jobApiEnhanceResume', 'versionNo', versionNo)
            // verify required parameter 'enhanceResumeBody' is not null or undefined
            assertParamExists('jobApiEnhanceResume', 'enhanceResumeBody', enhanceResumeBody)
            const localVarPath = `/resume-builder/enhance_resume/{resume_builder_id}/version/{version_no}`
                .replace('{resume_builder_id}', encodeURIComponent(String(resumeBuilderId)))
                .replace('{version_no}', encodeURIComponent(String(versionNo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enhanceResumeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {ResumeJobFitEnhanceBody} resumeJobFitEnhanceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiEnhanceResumeJobFit: async (jobId: string, userResumeId: string, resumeJobFitEnhanceBody: ResumeJobFitEnhanceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiEnhanceResumeJobFit', 'jobId', jobId)
            // verify required parameter 'userResumeId' is not null or undefined
            assertParamExists('jobApiEnhanceResumeJobFit', 'userResumeId', userResumeId)
            // verify required parameter 'resumeJobFitEnhanceBody' is not null or undefined
            assertParamExists('jobApiEnhanceResumeJobFit', 'resumeJobFitEnhanceBody', resumeJobFitEnhanceBody)
            const localVarPath = `/resume/{user_resume_id}/job/{job_id}/fit-enhance`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{user_resume_id}', encodeURIComponent(String(userResumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeJobFitEnhanceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {ExternalApplyBody} externalApplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiExternalApply: async (jobId: string, externalApplyBody: ExternalApplyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiExternalApply', 'jobId', jobId)
            // verify required parameter 'externalApplyBody' is not null or undefined
            assertParamExists('jobApiExternalApply', 'externalApplyBody', externalApplyBody)
            const localVarPath = `/job/{job_id}/external-apply`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalApplyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiExternalClick: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiExternalClick', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/external-click`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FixJobFormattingBody} fixJobFormattingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiFixJobFormatting: async (fixJobFormattingBody: FixJobFormattingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixJobFormattingBody' is not null or undefined
            assertParamExists('jobApiFixJobFormatting', 'fixJobFormattingBody', fixJobFormattingBody)
            const localVarPath = `/admin/job/fix-formatting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fixJobFormattingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} jobId 
         * @param {GenerateAndAssociateJobChallengeQuestionsBody} generateAndAssociateJobChallengeQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGenerateAndAssociateJobChallengeQuestions: async (competitionId: string, jobId: string, generateAndAssociateJobChallengeQuestionsBody: GenerateAndAssociateJobChallengeQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('jobApiGenerateAndAssociateJobChallengeQuestions', 'competitionId', competitionId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGenerateAndAssociateJobChallengeQuestions', 'jobId', jobId)
            // verify required parameter 'generateAndAssociateJobChallengeQuestionsBody' is not null or undefined
            assertParamExists('jobApiGenerateAndAssociateJobChallengeQuestions', 'generateAndAssociateJobChallengeQuestionsBody', generateAndAssociateJobChallengeQuestionsBody)
            const localVarPath = `/job/{job_id}/competition/{competition_id}/generate-and-associate-job-challenge-questions`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateAndAssociateJobChallengeQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {GenerateQuestionsAndCreateJobCompetitionBody} generateQuestionsAndCreateJobCompetitionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGenerateQuestionsAndCreateJobCompetition: async (jobId: string, generateQuestionsAndCreateJobCompetitionBody: GenerateQuestionsAndCreateJobCompetitionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGenerateQuestionsAndCreateJobCompetition', 'jobId', jobId)
            // verify required parameter 'generateQuestionsAndCreateJobCompetitionBody' is not null or undefined
            assertParamExists('jobApiGenerateQuestionsAndCreateJobCompetition', 'generateQuestionsAndCreateJobCompetitionBody', generateQuestionsAndCreateJobCompetitionBody)
            const localVarPath = `/admin/job/{job_id}/generate-questions-and-create-competition`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateQuestionsAndCreateJobCompetitionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {GenerateRecruiterMessageBody} generateRecruiterMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGenerateRecruiterMessage: async (jobId: string, generateRecruiterMessageBody: GenerateRecruiterMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGenerateRecruiterMessage', 'jobId', jobId)
            // verify required parameter 'generateRecruiterMessageBody' is not null or undefined
            assertParamExists('jobApiGenerateRecruiterMessage', 'generateRecruiterMessageBody', generateRecruiterMessageBody)
            const localVarPath = `/job/{job_id}/chat/generate-message`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateRecruiterMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetActivityTypeCounts: async (days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/activity-logs/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAiDraftPayload: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetAiDraftPayload', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetAiDraftPayload', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/ai-draft`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAiDraftedJobs: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetAiDraftedJobs', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/ai-drafted`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ActiveJobBody} activeJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAllActiveJobs: async (activeJobBody: ActiveJobBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activeJobBody' is not null or undefined
            assertParamExists('jobApiGetAllActiveJobs', 'activeJobBody', activeJobBody)
            const localVarPath = `/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activeJobBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ActiveJobBody} activeJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAllActiveJobsPublic: async (activeJobBody: ActiveJobBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activeJobBody' is not null or undefined
            assertParamExists('jobApiGetAllActiveJobsPublic', 'activeJobBody', activeJobBody)
            const localVarPath = `/public/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activeJobBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string> | null} [hiringStatus] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string> | null} [skillIds] 
         * @param {Array<string> | null} [status] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAllAppliedJobs: async (hiringStatus?: Array<string> | null, page?: number, pageSize?: number, skillIds?: Array<string> | null, status?: Array<string> | null, userSearchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/applied`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (hiringStatus) {
                localVarQueryParameter['hiring_status'] = hiringStatus;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (userSearchQuery !== undefined) {
                localVarQueryParameter['user_search_query'] = userSearchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {boolean} [showContacts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAndMarkJobProfileDownload: async (jobId: string, orgId: string, profileId: string, showContacts?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetAndMarkJobProfileDownload', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetAndMarkJobProfileDownload', 'orgId', orgId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('jobApiGetAndMarkJobProfileDownload', 'profileId', profileId)
            const localVarPath = `/org/{org_id}/job/{job_id}/profile/{profile_id}/details`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{profile_id}', encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (showContacts !== undefined) {
                localVarQueryParameter['show_contacts'] = showContacts;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantAiAccessStatus: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetApplicantAiAccessStatus', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetApplicantAiAccessStatus', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant-ai-access`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantLocation: async (jobId: string, orgId: string, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetApplicantLocation', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetApplicantLocation', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicants-location`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantResumeAnalysisByUserId: async (applicantId: string, jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('jobApiGetApplicantResumeAnalysisByUserId', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetApplicantResumeAnalysisByUserId', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetApplicantResumeAnalysisByUserId', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/resume-analysis/applicant/{applicant_id}`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantSkills: async (jobId: string, orgId: string, page?: number, pageSize?: number, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetApplicantSkills', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetApplicantSkills', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicants-skills`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantTags: async (jobId: string, orgId: string, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetApplicantTags', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetApplicantTags', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicants-tag`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {Array<string>} [applicantStatus] 
         * @param {Array<string>} [applicantTag] 
         * @param {Array<AssessmentScreeningFilter>} [assessmentScreening] 
         * @param {Array<string>} [collegeIds] 
         * @param {Array<string>} [collegeTier] 
         * @param {CompetitionData} [competitionData] 
         * @param {boolean} [countOnly] 
         * @param {string} [endDate] 
         * @param {boolean | null} [isApplicantSeen] 
         * @param {boolean} [isChatStarted] 
         * @param {string} [jobPreference] 
         * @param {Array<string>} [jobRoleIds] 
         * @param {Array<string>} [matchingBranch] 
         * @param {Array<string>} [matchingDegree] 
         * @param {Array<string>} [matchingLocations] 
         * @param {Array<string>} [matchingSkills] 
         * @param {number} [maxAssessmentScore] 
         * @param {number} [maxCurrentCtc] 
         * @param {number} [maxEducation] 
         * @param {number} [maxExperience] 
         * @param {number} [maxGrade] 
         * @param {number} [maxPassingYear] 
         * @param {number} [maxPercentile] 
         * @param {number} [maxRating] 
         * @param {number} [maxResumeAnalysisExperienceScore] 
         * @param {number} [maxResumeAnalysisOverallScore] 
         * @param {number} [maxResumeAnalysisSkillScore] 
         * @param {number} [maxWorkExperienceMonths] 
         * @param {number} [minAssessmentScore] 
         * @param {number} [minCurrentCtc] 
         * @param {number} [minEducation] 
         * @param {number} [minExperience] 
         * @param {number} [minGrade] 
         * @param {number} [minPassingYear] 
         * @param {number} [minPercentile] 
         * @param {number} [minRating] 
         * @param {number} [minReleventResumeExperienceMonths] 
         * @param {number} [minResumeAnalysisExperienceScore] 
         * @param {number} [minResumeAnalysisOverallScore] 
         * @param {number} [minResumeAnalysisSkillScore] 
         * @param {number} [minWorkExperienceMonths] 
         * @param {Array<string>} [missingSkills] 
         * @param {number} [noticePeriod] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<RequiredSkillsFilter>} [requiredSkills] 
         * @param {boolean} [resumeUploaded] 
         * @param {string} [sortBy] 
         * @param {SortBy} [sortByCompetitionData] 
         * @param {string} [sortOrder] 
         * @param {string} [startDate] 
         * @param {string} [userSearchQuery] 
         * @param {Array<string>} [usernames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantsDetailsByPage: async (jobId: string, orgId: string, applicantStatus?: Array<string>, applicantTag?: Array<string>, assessmentScreening?: Array<AssessmentScreeningFilter>, collegeIds?: Array<string>, collegeTier?: Array<string>, competitionData?: CompetitionData, countOnly?: boolean, endDate?: string, isApplicantSeen?: boolean | null, isChatStarted?: boolean, jobPreference?: string, jobRoleIds?: Array<string>, matchingBranch?: Array<string>, matchingDegree?: Array<string>, matchingLocations?: Array<string>, matchingSkills?: Array<string>, maxAssessmentScore?: number, maxCurrentCtc?: number, maxEducation?: number, maxExperience?: number, maxGrade?: number, maxPassingYear?: number, maxPercentile?: number, maxRating?: number, maxResumeAnalysisExperienceScore?: number, maxResumeAnalysisOverallScore?: number, maxResumeAnalysisSkillScore?: number, maxWorkExperienceMonths?: number, minAssessmentScore?: number, minCurrentCtc?: number, minEducation?: number, minExperience?: number, minGrade?: number, minPassingYear?: number, minPercentile?: number, minRating?: number, minReleventResumeExperienceMonths?: number, minResumeAnalysisExperienceScore?: number, minResumeAnalysisOverallScore?: number, minResumeAnalysisSkillScore?: number, minWorkExperienceMonths?: number, missingSkills?: Array<string>, noticePeriod?: number, page?: number, pageSize?: number, requiredSkills?: Array<RequiredSkillsFilter>, resumeUploaded?: boolean, sortBy?: string, sortByCompetitionData?: SortBy, sortOrder?: string, startDate?: string, userSearchQuery?: string, usernames?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetApplicantsDetailsByPage', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetApplicantsDetailsByPage', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant-details-by-page`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (applicantStatus) {
                localVarQueryParameter['applicant_status'] = applicantStatus;
            }

            if (applicantTag) {
                localVarQueryParameter['applicant_tag'] = applicantTag;
            }

            if (assessmentScreening) {
                localVarQueryParameter['assessment_screening'] = assessmentScreening;
            }

            if (collegeIds) {
                localVarQueryParameter['college_ids'] = collegeIds;
            }

            if (collegeTier) {
                localVarQueryParameter['college_tier'] = collegeTier;
            }

            if (competitionData !== undefined) {
                for (const [key, value] of Object.entries(competitionData)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (countOnly !== undefined) {
                localVarQueryParameter['count_only'] = countOnly;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (isApplicantSeen !== undefined) {
                localVarQueryParameter['is_applicant_seen'] = isApplicantSeen;
            }

            if (isChatStarted !== undefined) {
                localVarQueryParameter['is_chat_started'] = isChatStarted;
            }

            if (jobPreference !== undefined) {
                localVarQueryParameter['job_preference'] = jobPreference;
            }

            if (jobRoleIds) {
                localVarQueryParameter['job_role_ids'] = jobRoleIds;
            }

            if (matchingBranch) {
                localVarQueryParameter['matching_branch'] = matchingBranch;
            }

            if (matchingDegree) {
                localVarQueryParameter['matching_degree'] = matchingDegree;
            }

            if (matchingLocations) {
                localVarQueryParameter['matching_locations'] = matchingLocations;
            }

            if (matchingSkills) {
                localVarQueryParameter['matching_skills'] = matchingSkills;
            }

            if (maxAssessmentScore !== undefined) {
                localVarQueryParameter['max_assessment_score'] = maxAssessmentScore;
            }

            if (maxCurrentCtc !== undefined) {
                localVarQueryParameter['max_current_ctc'] = maxCurrentCtc;
            }

            if (maxEducation !== undefined) {
                localVarQueryParameter['max_education'] = maxEducation;
            }

            if (maxExperience !== undefined) {
                localVarQueryParameter['max_experience'] = maxExperience;
            }

            if (maxGrade !== undefined) {
                localVarQueryParameter['max_grade'] = maxGrade;
            }

            if (maxPassingYear !== undefined) {
                localVarQueryParameter['max_passing_year'] = maxPassingYear;
            }

            if (maxPercentile !== undefined) {
                localVarQueryParameter['max_percentile'] = maxPercentile;
            }

            if (maxRating !== undefined) {
                localVarQueryParameter['max_rating'] = maxRating;
            }

            if (maxResumeAnalysisExperienceScore !== undefined) {
                localVarQueryParameter['max_resume_analysis_experience_score'] = maxResumeAnalysisExperienceScore;
            }

            if (maxResumeAnalysisOverallScore !== undefined) {
                localVarQueryParameter['max_resume_analysis_overall_score'] = maxResumeAnalysisOverallScore;
            }

            if (maxResumeAnalysisSkillScore !== undefined) {
                localVarQueryParameter['max_resume_analysis_skill_score'] = maxResumeAnalysisSkillScore;
            }

            if (maxWorkExperienceMonths !== undefined) {
                localVarQueryParameter['max_work_experience_months'] = maxWorkExperienceMonths;
            }

            if (minAssessmentScore !== undefined) {
                localVarQueryParameter['min_assessment_score'] = minAssessmentScore;
            }

            if (minCurrentCtc !== undefined) {
                localVarQueryParameter['min_current_ctc'] = minCurrentCtc;
            }

            if (minEducation !== undefined) {
                localVarQueryParameter['min_education'] = minEducation;
            }

            if (minExperience !== undefined) {
                localVarQueryParameter['min_experience'] = minExperience;
            }

            if (minGrade !== undefined) {
                localVarQueryParameter['min_grade'] = minGrade;
            }

            if (minPassingYear !== undefined) {
                localVarQueryParameter['min_passing_year'] = minPassingYear;
            }

            if (minPercentile !== undefined) {
                localVarQueryParameter['min_percentile'] = minPercentile;
            }

            if (minRating !== undefined) {
                localVarQueryParameter['min_rating'] = minRating;
            }

            if (minReleventResumeExperienceMonths !== undefined) {
                localVarQueryParameter['min_relevent_resume_experience_months'] = minReleventResumeExperienceMonths;
            }

            if (minResumeAnalysisExperienceScore !== undefined) {
                localVarQueryParameter['min_resume_analysis_experience_score'] = minResumeAnalysisExperienceScore;
            }

            if (minResumeAnalysisOverallScore !== undefined) {
                localVarQueryParameter['min_resume_analysis_overall_score'] = minResumeAnalysisOverallScore;
            }

            if (minResumeAnalysisSkillScore !== undefined) {
                localVarQueryParameter['min_resume_analysis_skill_score'] = minResumeAnalysisSkillScore;
            }

            if (minWorkExperienceMonths !== undefined) {
                localVarQueryParameter['min_work_experience_months'] = minWorkExperienceMonths;
            }

            if (missingSkills) {
                localVarQueryParameter['missing_skills'] = missingSkills;
            }

            if (noticePeriod !== undefined) {
                localVarQueryParameter['notice_period'] = noticePeriod;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (requiredSkills) {
                localVarQueryParameter['required_skills'] = requiredSkills;
            }

            if (resumeUploaded !== undefined) {
                localVarQueryParameter['resume_uploaded'] = resumeUploaded;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortByCompetitionData !== undefined) {
                for (const [key, value] of Object.entries(sortByCompetitionData)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userSearchQuery !== undefined) {
                localVarQueryParameter['user_search_query'] = userSearchQuery;
            }

            if (usernames) {
                localVarQueryParameter['usernames'] = usernames;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AppliedJobPopupDataBody} appliedJobPopupDataBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAppliedJobPopupData: async (appliedJobPopupDataBody: AppliedJobPopupDataBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appliedJobPopupDataBody' is not null or undefined
            assertParamExists('jobApiGetAppliedJobPopupData', 'appliedJobPopupDataBody', appliedJobPopupDataBody)
            const localVarPath = `/applied_job/popup_data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appliedJobPopupDataBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAppliedJobsSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/applied/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAssessment: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetAssessment', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/assessment`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAssessmentFields: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('jobApiGetAssessmentFields', 'assessmentId', assessmentId)
            const localVarPath = `/assessment/{assessment_id}/assessment_field`
                .replace('{assessment_id}', encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAutocompleteCollegeApplicants: async (jobId: string, page?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetAutocompleteCollegeApplicants', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/autocomplete/college/applicants`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAutocompleteJobRoleApplicants: async (jobId: string, pageNo?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetAutocompleteJobRoleApplicants', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/autocomplete/job-role/applicants`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [count] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetBestJobs: async (count?: number, days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/landing-page-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobGetCandidatesBody} jobGetCandidatesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetBqCandidatesApi: async (jobGetCandidatesBody: JobGetCandidatesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobGetCandidatesBody' is not null or undefined
            assertParamExists('jobApiGetBqCandidatesApi', 'jobGetCandidatesBody', jobGetCandidatesBody)
            const localVarPath = `/job/get_candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobGetCandidatesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobGetCandidatesBody} jobGetCandidatesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetBqCompaniesApi: async (jobGetCandidatesBody: JobGetCandidatesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobGetCandidatesBody' is not null or undefined
            assertParamExists('jobApiGetBqCompaniesApi', 'jobGetCandidatesBody', jobGetCandidatesBody)
            const localVarPath = `/job/get_companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobGetCandidatesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetBqFilterOptionsApi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/bq/filter-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetCandidateEvaluation: async (evaluationId: string, jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evaluationId' is not null or undefined
            assertParamExists('jobApiGetCandidateEvaluation', 'evaluationId', evaluationId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetCandidateEvaluation', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/evaluation/{evaluation_id}`
                .replace('{evaluation_id}', encodeURIComponent(String(evaluationId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetCandidateMetaDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/candidate-meta-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetChatUsersForApplicant: async (page?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/chat-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetChatUsersForEmployer: async (jobId: string, orgId: string, page?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetChatUsersForEmployer', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetChatUsersForEmployer', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/chat-users`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyAlias 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetCompanyJobs: async (companyAlias: string, page?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyAlias' is not null or undefined
            assertParamExists('jobApiGetCompanyJobs', 'companyAlias', companyAlias)
            const localVarPath = `/company/{company_alias}/jobs`
                .replace('{company_alias}', encodeURIComponent(String(companyAlias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetCompanyStatistics: async (companyAlias: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyAlias' is not null or undefined
            assertParamExists('jobApiGetCompanyStatistics', 'companyAlias', companyAlias)
            const localVarPath = `/company/{company_alias}/statistics`
                .replace('{company_alias}', encodeURIComponent(String(companyAlias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetDbAccessStatus: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetDbAccessStatus', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetDbAccessStatus', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/db-access`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [approvalStatus] 
         * @param {string} [degreeId] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetDegree: async (approvalStatus?: string, degreeId?: string, pageNo?: string, pageSize?: string, sortBy?: string, sortOrder?: string, userSearchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/degree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (approvalStatus !== undefined) {
                localVarQueryParameter['approval_status'] = approvalStatus;
            }

            if (degreeId !== undefined) {
                localVarQueryParameter['degree_id'] = degreeId;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (userSearchQuery !== undefined) {
                localVarQueryParameter['user_search_query'] = userSearchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobApplicantMessage: async (applicantId: string, jobId: string, cursor?: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('jobApiGetJobApplicantMessage', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobApplicantMessage', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/chat/{applicant_id}`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobApplicantsDetails: async (applicantId: string, jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('jobApiGetJobApplicantsDetails', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobApplicantsDetails', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobApplicantsDetails', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicants/{applicant_id}`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {ApplicantListParam} applicantListParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobApplicantsList: async (jobId: string, orgId: string, applicantListParam: ApplicantListParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobApplicantsList', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobApplicantsList', 'orgId', orgId)
            // verify required parameter 'applicantListParam' is not null or undefined
            assertParamExists('jobApiGetJobApplicantsList', 'applicantListParam', applicantListParam)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicants`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicantListParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobApplicantsMetaData: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobApplicantsMetaData', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobApplicantsMetaData', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicants-meta-data`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobById: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobById', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobById', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobByIdForApplied: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobByIdForApplied', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/applied-details`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {boolean} [isSkillPopupRequired] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobByIdForCandidate: async (jobId: string, isSkillPopupRequired?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobByIdForCandidate', 'jobId', jobId)
            const localVarPath = `/job/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isSkillPopupRequired !== undefined) {
                localVarQueryParameter['is_skill_popup_required'] = isSkillPopupRequired;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobByIdForCandidatePublic: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobByIdForCandidatePublic', 'jobId', jobId)
            const localVarPath = `/public/job/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobByIdForEmployer: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobByIdForEmployer', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/employer-job-details`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobByIdSlim: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobByIdSlim', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/details`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobCandidateJourney: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobCandidateJourney', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobCandidateJourney', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/candidate-journey`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantUserId 
         * @param {string} competitionId 
         * @param {string} jobId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobCompetitionAnsweredQuestions: async (applicantUserId: string, competitionId: string, jobId: string, page?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantUserId' is not null or undefined
            assertParamExists('jobApiGetJobCompetitionAnsweredQuestions', 'applicantUserId', applicantUserId)
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('jobApiGetJobCompetitionAnsweredQuestions', 'competitionId', competitionId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobCompetitionAnsweredQuestions', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/applicant/{applicant_user_id}/competition/{competition_id}/question/answered`
                .replace('{applicant_user_id}', encodeURIComponent(String(applicantUserId)))
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobCompetitionStatistics: async (competitionId: string, jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('jobApiGetJobCompetitionStatistics', 'competitionId', competitionId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobCompetitionStatistics', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/competition/{competition_id}/statistics`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobEmailPreferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/job-email/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobEvaluationCandidates: async (evaluationId: string, jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evaluationId' is not null or undefined
            assertParamExists('jobApiGetJobEvaluationCandidates', 'evaluationId', evaluationId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobEvaluationCandidates', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobEvaluationCandidates', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/evaluation/{evaluation_id}/candidates`
                .replace('{evaluation_id}', encodeURIComponent(String(evaluationId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {boolean} [ensureCompetition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobEvaluationDetail: async (evaluationId: string, jobId: string, orgId: string, ensureCompetition?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evaluationId' is not null or undefined
            assertParamExists('jobApiGetJobEvaluationDetail', 'evaluationId', evaluationId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobEvaluationDetail', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobEvaluationDetail', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/evaluation/{evaluation_id}`
                .replace('{evaluation_id}', encodeURIComponent(String(evaluationId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ensureCompetition !== undefined) {
                localVarQueryParameter['ensure_competition'] = ensureCompetition;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {boolean | null} [autoApplyEnabled] 
         * @param {string} [endDate] 
         * @param {boolean | null} [hasApplied] 
         * @param {Array<string>} [jobRoleList] 
         * @param {number | null} [maxExperience] 
         * @param {number | null} [minExperience] 
         * @param {boolean} [notified] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {Array<string>} [skillIds] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobMatchingEntities: async (jobId: string, autoApplyEnabled?: boolean | null, endDate?: string, hasApplied?: boolean | null, jobRoleList?: Array<string>, maxExperience?: number | null, minExperience?: number | null, notified?: boolean, pageNo?: number, pageSize?: number, searchQuery?: string, skillIds?: Array<string>, sortBy?: string, sortOrder?: string, startDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobMatchingEntities', 'jobId', jobId)
            const localVarPath = `/admin/job/{job_id}/get-matching-profiles-resume-entities`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (autoApplyEnabled !== undefined) {
                localVarQueryParameter['auto_apply_enabled'] = autoApplyEnabled;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (hasApplied !== undefined) {
                localVarQueryParameter['has_applied'] = hasApplied;
            }

            if (jobRoleList) {
                localVarQueryParameter['job_role_list'] = jobRoleList;
            }

            if (maxExperience !== undefined) {
                localVarQueryParameter['max_experience'] = maxExperience;
            }

            if (minExperience !== undefined) {
                localVarQueryParameter['min_experience'] = minExperience;
            }

            if (notified !== undefined) {
                localVarQueryParameter['notified'] = notified;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {boolean | null} [autoApplyEnabled] 
         * @param {string} [endDate] 
         * @param {boolean | null} [hasApplied] 
         * @param {Array<string>} [jobRoleList] 
         * @param {number | null} [maxExperience] 
         * @param {number | null} [minExperience] 
         * @param {boolean} [notified] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {Array<string>} [skillIds] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobMatchingUsers: async (jobId: string, autoApplyEnabled?: boolean | null, endDate?: string, hasApplied?: boolean | null, jobRoleList?: Array<string>, maxExperience?: number | null, minExperience?: number | null, notified?: boolean, pageNo?: number, pageSize?: number, searchQuery?: string, skillIds?: Array<string>, sortBy?: string, sortOrder?: string, startDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobMatchingUsers', 'jobId', jobId)
            const localVarPath = `/admin/job/{job_id}/get-matching-profiles-users`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (autoApplyEnabled !== undefined) {
                localVarQueryParameter['auto_apply_enabled'] = autoApplyEnabled;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (hasApplied !== undefined) {
                localVarQueryParameter['has_applied'] = hasApplied;
            }

            if (jobRoleList) {
                localVarQueryParameter['job_role_list'] = jobRoleList;
            }

            if (maxExperience !== undefined) {
                localVarQueryParameter['max_experience'] = maxExperience;
            }

            if (minExperience !== undefined) {
                localVarQueryParameter['min_experience'] = minExperience;
            }

            if (notified !== undefined) {
                localVarQueryParameter['notified'] = notified;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean | null} [isArchieved] 
         * @param {boolean | null} [isCompetitive] 
         * @param {boolean | null} [isGptJob] 
         * @param {string} [jobStatus] 
         * @param {string} [orgId] 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {Array<string>} [planTypeList] 
         * @param {string} [productType] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobPostedList: async (isArchieved?: boolean | null, isCompetitive?: boolean | null, isGptJob?: boolean | null, jobStatus?: string, orgId?: string, pageNo?: number | null, pageSize?: number | null, planTypeList?: Array<string>, productType?: string, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job-posted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isArchieved !== undefined) {
                localVarQueryParameter['is_archieved'] = isArchieved;
            }

            if (isCompetitive !== undefined) {
                localVarQueryParameter['is_competitive'] = isCompetitive;
            }

            if (isGptJob !== undefined) {
                localVarQueryParameter['is_gpt_job'] = isGptJob;
            }

            if (jobStatus !== undefined) {
                localVarQueryParameter['job_status'] = jobStatus;
            }

            if (orgId !== undefined) {
                localVarQueryParameter['org_id'] = orgId;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (planTypeList) {
                localVarQueryParameter['plan_type_list'] = planTypeList;
            }

            if (productType !== undefined) {
                localVarQueryParameter['product_type'] = productType;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {ProfileMatchParam} profileMatchParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobProfileMatch: async (jobId: string, orgId: string, profileMatchParam: ProfileMatchParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobProfileMatch', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobProfileMatch', 'orgId', orgId)
            // verify required parameter 'profileMatchParam' is not null or undefined
            assertParamExists('jobApiGetJobProfileMatch', 'profileMatchParam', profileMatchParam)
            const localVarPath = `/org/{org_id}/job/{job_id}/profile-match`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileMatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {boolean} [showContacts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobProfileMatchById: async (jobId: string, orgId: string, profileId: string, showContacts?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobProfileMatchById', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobProfileMatchById', 'orgId', orgId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('jobApiGetJobProfileMatchById', 'profileId', profileId)
            const localVarPath = `/org/{org_id}/job/{job_id}/profile/{profile_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{profile_id}', encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (showContacts !== undefined) {
                localVarQueryParameter['show_contacts'] = showContacts;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobProfileMilestone: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/profile-milestone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobRelatedMocktests: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobRelatedMocktests', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/related-mocktests`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobReports: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetJobReports', 'jobId', jobId)
            const localVarPath = `/admin/job/{job_id}/reports`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobRoleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobRoleSkills: async (jobRoleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobRoleId' is not null or undefined
            assertParamExists('jobApiGetJobRoleSkills', 'jobRoleId', jobRoleId)
            const localVarPath = `/job-role/{job_role_id}/skills`
                .replace('{job_role_id}', encodeURIComponent(String(jobRoleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobRoleSuggestions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/role-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobSkillSuggestions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/skill-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {string} [searchType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobSkillsAutocomplete: async (pageNo?: number, pageSize?: number, searchQuery?: string, searchType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/job-role-skills/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['search_type'] = searchType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobStatistics: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobStatistics', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job-statistics`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobSummary: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobSummary', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job-summary`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobUnreadMessageCount: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetJobUnreadMessageCount', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job_message_count`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetOrgCsvParam} getOrgCsvParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobsGoogleAdsMetadataCsv: async (getOrgCsvParam: GetOrgCsvParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getOrgCsvParam' is not null or undefined
            assertParamExists('jobApiGetJobsGoogleAdsMetadataCsv', 'getOrgCsvParam', getOrgCsvParam)
            const localVarPath = `/admin/jobs-google-ads-metadata/csv-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOrgCsvParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [jobRoleIds] 
         * @param {string} [locationName] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobsGroupPublic: async (jobRoleIds?: Array<string>, locationName?: string, pageNo?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/job/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (jobRoleIds) {
                localVarQueryParameter['job_role_ids'] = jobRoleIds;
            }

            if (locationName !== undefined) {
                localVarQueryParameter['location_name'] = locationName;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [jobRoleIds] 
         * @param {string} [locationName] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobsLocationsPublic: async (jobRoleIds?: Array<string>, locationName?: string, pageNo?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/job/state-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (jobRoleIds) {
                localVarQueryParameter['job_role_ids'] = jobRoleIds;
            }

            if (locationName !== undefined) {
                localVarQueryParameter['location_name'] = locationName;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetLatestResumeJobFit: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetLatestResumeJobFit', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/latest-fit-analysis`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetMatchingJobsDeck: async (jobId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/matching-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [jobRoleId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetOrgApplicantChats: async (orgId: string, jobRoleId?: string, page?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetOrgApplicantChats', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/applicant-chats`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (jobRoleId !== undefined) {
                localVarQueryParameter['job_role_id'] = jobRoleId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetOrgChatJobs: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetOrgChatJobs', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/chat-jobs`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetOrgJobIds: async (jobAlias: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobAlias' is not null or undefined
            assertParamExists('jobApiGetOrgJobIds', 'jobAlias', jobAlias)
            const localVarPath = `/job/{job_alias}/ids`
                .replace('{job_alias}', encodeURIComponent(String(jobAlias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyAlias 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetPublicCompanyJobs: async (companyAlias: string, page?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyAlias' is not null or undefined
            assertParamExists('jobApiGetPublicCompanyJobs', 'companyAlias', companyAlias)
            const localVarPath = `/public/company/{company_alias}/jobs`
                .replace('{company_alias}', encodeURIComponent(String(companyAlias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetPublicCompanyStatistics: async (companyAlias: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyAlias' is not null or undefined
            assertParamExists('jobApiGetPublicCompanyStatistics', 'companyAlias', companyAlias)
            const localVarPath = `/public/company/{company_alias}/statistics`
                .replace('{company_alias}', encodeURIComponent(String(companyAlias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetRecruiterEmail: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetRecruiterEmail', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/recruiter-email`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeBuilderAnalysis: async (analysisId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('jobApiGetResumeBuilderAnalysis', 'analysisId', analysisId)
            const localVarPath = `/resume-builder/analysis/{analysis_id}`
                .replace('{analysis_id}', encodeURIComponent(String(analysisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeBuilderData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resume-builder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} [versionNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeBuilderDataById: async (resumeBuilderId: string, versionNo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeBuilderId' is not null or undefined
            assertParamExists('jobApiGetResumeBuilderDataById', 'resumeBuilderId', resumeBuilderId)
            const localVarPath = `/resume-builder/resume/{resume_builder_id}`
                .replace('{resume_builder_id}', encodeURIComponent(String(resumeBuilderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (versionNo !== undefined) {
                localVarQueryParameter['version_no'] = versionNo;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeBuilderVersionsById: async (resumeBuilderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeBuilderId' is not null or undefined
            assertParamExists('jobApiGetResumeBuilderVersionsById', 'resumeBuilderId', resumeBuilderId)
            const localVarPath = `/resume-builder/resume/{resume_builder_id}/versions`
                .replace('{resume_builder_id}', encodeURIComponent(String(resumeBuilderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeJobFit: async (jobId: string, userResumeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetResumeJobFit', 'jobId', jobId)
            // verify required parameter 'userResumeId' is not null or undefined
            assertParamExists('jobApiGetResumeJobFit', 'userResumeId', userResumeId)
            const localVarPath = `/resume/{user_resume_id}/job/{job_id}/fit-analysis`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{user_resume_id}', encodeURIComponent(String(userResumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeJobFitQuestions: async (jobId: string, userResumeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetResumeJobFitQuestions', 'jobId', jobId)
            // verify required parameter 'userResumeId' is not null or undefined
            assertParamExists('jobApiGetResumeJobFitQuestions', 'userResumeId', userResumeId)
            const localVarPath = `/resume/{user_resume_id}/job/{job_id}/fit-questions`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{user_resume_id}', encodeURIComponent(String(userResumeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetScreeningInsights: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetScreeningInsights', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/screening-insights`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetSimilarJobs: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetSimilarJobs', 'jobId', jobId)
            const localVarPath = `/public/jobs/{job_id}/get-similar-jobs`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetSitemapUrls: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sitemap/urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [approvalStatus] 
         * @param {string | null} [degreeId] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [specializationId] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetSpecialization: async (approvalStatus?: string, degreeId?: string | null, pageNo?: string, pageSize?: string, sortBy?: string, sortOrder?: string, specializationId?: string, userSearchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/specialization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (approvalStatus !== undefined) {
                localVarQueryParameter['approval_status'] = approvalStatus;
            }

            if (degreeId !== undefined) {
                localVarQueryParameter['degree_id'] = degreeId;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (specializationId !== undefined) {
                localVarQueryParameter['specialization_id'] = specializationId;
            }

            if (userSearchQuery !== undefined) {
                localVarQueryParameter['user_search_query'] = userSearchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetSpotlightOptions: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiGetSpotlightOptions', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/spotlight-options`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [activityTypeList] 
         * @param {string} [applicantId] 
         * @param {Array<string>} [jobIds] 
         * @param {string} [maxDate] 
         * @param {string} [minDate] 
         * @param {Array<string>} [orgIds] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [userId] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetSystemActivityLogs: async (activityTypeList?: Array<string>, applicantId?: string, jobIds?: Array<string>, maxDate?: string, minDate?: string, orgIds?: Array<string>, pageNo?: number, pageSize?: number, userId?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/activity-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (activityTypeList) {
                localVarQueryParameter['activity_type_list'] = activityTypeList;
            }

            if (applicantId !== undefined) {
                localVarQueryParameter['applicant_id'] = applicantId;
            }

            if (jobIds) {
                localVarQueryParameter['job_ids'] = jobIds;
            }

            if (maxDate !== undefined) {
                localVarQueryParameter['max_date'] = maxDate;
            }

            if (minDate !== undefined) {
                localVarQueryParameter['min_date'] = minDate;
            }

            if (orgIds) {
                localVarQueryParameter['org_ids'] = orgIds;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [activityType] 
         * @param {string} [applicantId] 
         * @param {string} [jobId] 
         * @param {string} [maxDate] 
         * @param {string} [minDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetUserActivityLogs: async (orgId: string, activityType?: string, applicantId?: string, jobId?: string, maxDate?: string, minDate?: string, pageNo?: number, pageSize?: number, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiGetUserActivityLogs', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/activity`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (activityType !== undefined) {
                localVarQueryParameter['activity_type'] = activityType;
            }

            if (applicantId !== undefined) {
                localVarQueryParameter['applicant_id'] = applicantId;
            }

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }

            if (maxDate !== undefined) {
                localVarQueryParameter['max_date'] = maxDate;
            }

            if (minDate !== undefined) {
                localVarQueryParameter['min_date'] = minDate;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetUserActivityLogsDetails: async (activityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('jobApiGetUserActivityLogsDetails', 'activityId', activityId)
            const localVarPath = `/admin/activity-logs/{activity_id}`
                .replace('{activity_id}', encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetUserSkill: async (pageNo?: number, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/user-skill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGovernorDryRun: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/job-governor/dry-run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiHighlightJob: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiHighlightJob', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/highlight`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiInitialiseJobData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/initialise-data-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiInitialiseJobDataCompany: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/initialise-data-status-company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiInitiateJobApplicationPreAnalysis: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiInitiateJobApplicationPreAnalysis', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/application_pre_analysis`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {JobInvitationBody} jobInvitationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiInviteUsersJob: async (jobId: string, orgId: string, profileId: string, jobInvitationBody: JobInvitationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiInviteUsersJob', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiInviteUsersJob', 'orgId', orgId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('jobApiInviteUsersJob', 'profileId', profileId)
            // verify required parameter 'jobInvitationBody' is not null or undefined
            assertParamExists('jobApiInviteUsersJob', 'jobInvitationBody', jobInvitationBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/profile/{profile_id}/invitation`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{profile_id}', encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobInvitationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobApplicantChatMarkSeen: async (applicantId: string, jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('jobApiJobApplicantChatMarkSeen', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiJobApplicantChatMarkSeen', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/chat/applicant/{applicant_id}/mark-seen`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobMatchEmailDaily: async (jobId: string, days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiJobMatchEmailDaily', 'jobId', jobId)
            const localVarPath = `/admin/job/{job_id}/email-daily`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobApiJobMatchEmailPreflightAppliedActivityModeEnum} [appliedActivityMode] 
         * @param {number | null} [appliedInLastDays] 
         * @param {boolean | null} [exactOnly] 
         * @param {boolean | null} [hardExperience] 
         * @param {JobApiJobMatchEmailPreflightLoginActivityModeEnum} [loginActivityMode] 
         * @param {number | null} [loginInLastDays] 
         * @param {number | null} [maxExperience] 
         * @param {number | null} [minExperience] 
         * @param {boolean | null} [neverOpenedOnly] 
         * @param {boolean | null} [savedBand] 
         * @param {boolean | null} [studentsOnly] 
         * @param {boolean | null} [withCeilings] 
         * @param {boolean | null} [withSendable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobMatchEmailPreflight: async (jobId: string, appliedActivityMode?: JobApiJobMatchEmailPreflightAppliedActivityModeEnum, appliedInLastDays?: number | null, exactOnly?: boolean | null, hardExperience?: boolean | null, loginActivityMode?: JobApiJobMatchEmailPreflightLoginActivityModeEnum, loginInLastDays?: number | null, maxExperience?: number | null, minExperience?: number | null, neverOpenedOnly?: boolean | null, savedBand?: boolean | null, studentsOnly?: boolean | null, withCeilings?: boolean | null, withSendable?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiJobMatchEmailPreflight', 'jobId', jobId)
            const localVarPath = `/admin/job/{job_id}/external-email-preflight`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appliedActivityMode !== undefined) {
                localVarQueryParameter['applied_activity_mode'] = appliedActivityMode;
            }

            if (appliedInLastDays !== undefined) {
                localVarQueryParameter['applied_in_last_days'] = appliedInLastDays;
            }

            if (exactOnly !== undefined) {
                localVarQueryParameter['exact_only'] = exactOnly;
            }

            if (hardExperience !== undefined) {
                localVarQueryParameter['hard_experience'] = hardExperience;
            }

            if (loginActivityMode !== undefined) {
                localVarQueryParameter['login_activity_mode'] = loginActivityMode;
            }

            if (loginInLastDays !== undefined) {
                localVarQueryParameter['login_in_last_days'] = loginInLastDays;
            }

            if (maxExperience !== undefined) {
                localVarQueryParameter['max_experience'] = maxExperience;
            }

            if (minExperience !== undefined) {
                localVarQueryParameter['min_experience'] = minExperience;
            }

            if (neverOpenedOnly !== undefined) {
                localVarQueryParameter['never_opened_only'] = neverOpenedOnly;
            }

            if (savedBand !== undefined) {
                localVarQueryParameter['saved_band'] = savedBand;
            }

            if (studentsOnly !== undefined) {
                localVarQueryParameter['students_only'] = studentsOnly;
            }

            if (withCeilings !== undefined) {
                localVarQueryParameter['with_ceilings'] = withCeilings;
            }

            if (withSendable !== undefined) {
                localVarQueryParameter['with_sendable'] = withSendable;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobMatchEmailReach: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiJobMatchEmailReach', 'jobId', jobId)
            const localVarPath = `/admin/job/{job_id}/email-reach`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobMatchEmailStats: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiJobMatchEmailStats', 'jobId', jobId)
            const localVarPath = `/admin/job/{job_id}/external-email-stats`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [degreeIds] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {string} [specializationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobSpecializationAutoComplete: async (degreeIds?: Array<string>, pageNo?: string, pageSize?: string, query?: string, specializationId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/specialization/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (degreeIds) {
                localVarQueryParameter['degree_ids'] = degreeIds;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (specializationId !== undefined) {
                localVarQueryParameter['specialization_id'] = specializationId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number | null} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiListGovernorCandidates: async (limit?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/job-governor/candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiListJobEvaluations: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiListJobEvaluations', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiListJobEvaluations', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/evaluations`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiListOrgEvaluationQuestionSources: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiListOrgEvaluationQuestionSources', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiListOrgEvaluationQuestionSources', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/evaluation/question-sources`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiListResumeBuilderAnalyses: async (resumeBuilderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeBuilderId' is not null or undefined
            assertParamExists('jobApiListResumeBuilderAnalyses', 'resumeBuilderId', resumeBuilderId)
            const localVarPath = `/resume-builder/{resume_builder_id}/analyses`
                .replace('{resume_builder_id}', encodeURIComponent(String(resumeBuilderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiLocationCountryBackfillRoute: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/location-countries/backfill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiLocationCountryHealthRoute: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/location-countries/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMarkJobAsNotInterested: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiMarkJobAsNotInterested', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/mark_as_not_interested`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMarkJobSkipped: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiMarkJobSkipped', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/skip`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMergeDuplicateCollegesCompanies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/merge-duplicate-colleges-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMigrateData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/migrate-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMigrateDataCompany: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/migrate-data-company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMigrateDataCompanyTask: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/migrate-data-company-task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMigrateDataTask: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/migrate-data-task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPopulateMissingApplicantMatchesForAllJobs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/populate-missing-applicant-profile-match-score`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPublicDegreeAutocomplete: async (pageNo?: number, pageSize?: number, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/degree/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * count — the location twin of /skill-suggestions and /role-suggestions.  Unauthenticated on purpose: it reports nothing the browse facets and the sitemap don\'t already publish. Device type changes the counts (external jobs are hidden from the native app), so it is resolved here and passed in — the controller is memoized, so it has to be part of the cache key rather than read from the request inside.
         * @summary Places the location filter can be set to, each with its live-posting
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {JobApiPublicJobLocationSuggestionsWorkModeEnum} [workMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPublicJobLocationSuggestions: async (pageSize?: number, searchQuery?: string | null, workMode?: JobApiPublicJobLocationSuggestionsWorkModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/job/location-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (workMode !== undefined) {
                localVarQueryParameter['work_mode'] = workMode;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPublicJobRoleSuggestions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/job/role-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPublicJobSkillSuggestions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/job/skill-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPublishJobCompetition: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('jobApiPublishJobCompetition', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/publish-job-competition`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiReanalyzeApplicant: async (applicantId: string, jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('jobApiReanalyzeApplicant', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiReanalyzeApplicant', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiReanalyzeApplicant', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant/{applicant_id}/reanalyze`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReBuildJobMatchingProfiles} reBuildJobMatchingProfiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRebuildMatchingProfiles: async (reBuildJobMatchingProfiles: ReBuildJobMatchingProfiles, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reBuildJobMatchingProfiles' is not null or undefined
            assertParamExists('jobApiRebuildMatchingProfiles', 'reBuildJobMatchingProfiles', reBuildJobMatchingProfiles)
            const localVarPath = `/admin/job/rebuild-matching-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reBuildJobMatchingProfiles, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRefreshBqFacetCachesApi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/bq/refresh-autocomplete-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} jobId 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRegenerateJobChallengeQuestion: async (competitionId: string, jobId: string, questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('jobApiRegenerateJobChallengeQuestion', 'competitionId', competitionId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiRegenerateJobChallengeQuestion', 'jobId', jobId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('jobApiRegenerateJobChallengeQuestion', 'questionId', questionId)
            const localVarPath = `/job/{job_id}/competition/{competition_id}/question/{question_id}/regenerate`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userId 
         * @param {JobInviteRejectBody} jobInviteRejectBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRejectJobInvitation: async (jobId: string, userId: string, jobInviteRejectBody: JobInviteRejectBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiRejectJobInvitation', 'jobId', jobId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('jobApiRejectJobInvitation', 'userId', userId)
            // verify required parameter 'jobInviteRejectBody' is not null or undefined
            assertParamExists('jobApiRejectJobInvitation', 'jobInviteRejectBody', jobInviteRejectBody)
            const localVarPath = `/job/{job_id}/user/{user_id}/invitation-reject`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobInviteRejectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {UserResumeEntityList} userResumeEntityList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRejectJobProfile: async (jobId: string, userResumeEntityList: UserResumeEntityList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiRejectJobProfile', 'jobId', jobId)
            // verify required parameter 'userResumeEntityList' is not null or undefined
            assertParamExists('jobApiRejectJobProfile', 'userResumeEntityList', userResumeEntityList)
            const localVarPath = `/admin/job/{job_id}/reject-matching-job-profile`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userResumeEntityList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRejectJobProfileByEmployer: async (jobId: string, orgId: string, profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiRejectJobProfileByEmployer', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiRejectJobProfileByEmployer', 'orgId', orgId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('jobApiRejectJobProfileByEmployer', 'profileId', profileId)
            const localVarPath = `/org/{org_id}/job/{job_id}/profile/{profile_id}/reject`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{profile_id}', encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {UserResumeEntityListRemainderCount} userResumeEntityListRemainderCount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiReminderEmailAllMatchingJobProfiles: async (jobId: string, userResumeEntityListRemainderCount: UserResumeEntityListRemainderCount, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiReminderEmailAllMatchingJobProfiles', 'jobId', jobId)
            // verify required parameter 'userResumeEntityListRemainderCount' is not null or undefined
            assertParamExists('jobApiReminderEmailAllMatchingJobProfiles', 'userResumeEntityListRemainderCount', userResumeEntityListRemainderCount)
            const localVarPath = `/admin/job/{job_id}/reminder-email-matching-profiles`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userResumeEntityListRemainderCount, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRemoveExternalApplication: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiRemoveExternalApplication', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/external-application`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {GetFilteredApplicantUserIdsBody} getFilteredApplicantUserIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRequestBulkAnalysis: async (jobId: string, orgId: string, getFilteredApplicantUserIdsBody: GetFilteredApplicantUserIdsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiRequestBulkAnalysis', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiRequestBulkAnalysis', 'orgId', orgId)
            // verify required parameter 'getFilteredApplicantUserIdsBody' is not null or undefined
            assertParamExists('jobApiRequestBulkAnalysis', 'getFilteredApplicantUserIdsBody', getFilteredApplicantUserIdsBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/bulk-analysis`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFilteredApplicantUserIdsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisId 
         * @param {ResumeBuilderRestoreBody} resumeBuilderRestoreBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRestoreResumeBuilderAnalysis: async (analysisId: string, resumeBuilderRestoreBody: ResumeBuilderRestoreBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('jobApiRestoreResumeBuilderAnalysis', 'analysisId', analysisId)
            // verify required parameter 'resumeBuilderRestoreBody' is not null or undefined
            assertParamExists('jobApiRestoreResumeBuilderAnalysis', 'resumeBuilderRestoreBody', resumeBuilderRestoreBody)
            const localVarPath = `/resume-builder/analysis/{analysis_id}/restore`
                .replace('{analysis_id}', encodeURIComponent(String(analysisId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeBuilderRestoreBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiResumePdfBuilder: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/resume_pdf_builder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReviewJobParam} reviewJobParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiReviewJobs: async (reviewJobParam: ReviewJobParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewJobParam' is not null or undefined
            assertParamExists('jobApiReviewJobs', 'reviewJobParam', reviewJobParam)
            const localVarPath = `/admin/job/review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reviewJobParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RewriteSnippetBody} rewriteSnippetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRewriteResumeSnippet: async (rewriteSnippetBody: RewriteSnippetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rewriteSnippetBody' is not null or undefined
            assertParamExists('jobApiRewriteResumeSnippet', 'rewriteSnippetBody', rewriteSnippetBody)
            const localVarPath = `/resume-builder/rewrite-snippet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rewriteSnippetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {SendAssessmentMessageBody} sendAssessmentMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSendAssessmentMessageToApplicants: async (jobId: string, orgId: string, sendAssessmentMessageBody: SendAssessmentMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiSendAssessmentMessageToApplicants', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiSendAssessmentMessageToApplicants', 'orgId', orgId)
            // verify required parameter 'sendAssessmentMessageBody' is not null or undefined
            assertParamExists('jobApiSendAssessmentMessageToApplicants', 'sendAssessmentMessageBody', sendAssessmentMessageBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/send-assessment-message`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendAssessmentMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BqSendEmailsBody} bqSendEmailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSendBqEmailsApi: async (bqSendEmailsBody: BqSendEmailsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bqSendEmailsBody' is not null or undefined
            assertParamExists('jobApiSendBqEmailsApi', 'bqSendEmailsBody', bqSendEmailsBody)
            const localVarPath = `/job/bq/send_emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bqSendEmailsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobMatchEmailSendBody} jobMatchEmailSendBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSendJobMatchEmails: async (jobId: string, jobMatchEmailSendBody: JobMatchEmailSendBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiSendJobMatchEmails', 'jobId', jobId)
            // verify required parameter 'jobMatchEmailSendBody' is not null or undefined
            assertParamExists('jobApiSendJobMatchEmails', 'jobMatchEmailSendBody', jobMatchEmailSendBody)
            const localVarPath = `/admin/job/{job_id}/external-email-matches`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobMatchEmailSendBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobMatchEmailTestBody} jobMatchEmailTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSendJobMatchTestEmail: async (jobId: string, jobMatchEmailTestBody: JobMatchEmailTestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiSendJobMatchTestEmail', 'jobId', jobId)
            // verify required parameter 'jobMatchEmailTestBody' is not null or undefined
            assertParamExists('jobApiSendJobMatchTestEmail', 'jobMatchEmailTestBody', jobMatchEmailTestBody)
            const localVarPath = `/admin/job/{job_id}/match-email-test`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobMatchEmailTestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {Array<InsertAssessmentScoreBody>} insertAssessmentScoreBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSetAssessmentResponseScore: async (applicantId: string, jobId: string, orgId: string, insertAssessmentScoreBody: Array<InsertAssessmentScoreBody>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('jobApiSetAssessmentResponseScore', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiSetAssessmentResponseScore', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiSetAssessmentResponseScore', 'orgId', orgId)
            // verify required parameter 'insertAssessmentScoreBody' is not null or undefined
            assertParamExists('jobApiSetAssessmentResponseScore', 'insertAssessmentScoreBody', insertAssessmentScoreBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant/{applicant_id}/assessment-score`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insertAssessmentScoreBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {EvaluationStatusBody} evaluationStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSetEvaluationStatus: async (evaluationId: string, jobId: string, orgId: string, evaluationStatusBody: EvaluationStatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evaluationId' is not null or undefined
            assertParamExists('jobApiSetEvaluationStatus', 'evaluationId', evaluationId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiSetEvaluationStatus', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiSetEvaluationStatus', 'orgId', orgId)
            // verify required parameter 'evaluationStatusBody' is not null or undefined
            assertParamExists('jobApiSetEvaluationStatus', 'evaluationStatusBody', evaluationStatusBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/evaluation/{evaluation_id}/status`
                .replace('{evaluation_id}', encodeURIComponent(String(evaluationId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluationStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSetupBqTablesApi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/bq/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [degreeId] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {string} [specializationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSpecializationAutoComplete: async (degreeId?: string | null, pageNo?: string, pageSize?: string, query?: string, specializationId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/specialization/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (degreeId !== undefined) {
                localVarQueryParameter['degree_id'] = degreeId;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (specializationId !== undefined) {
                localVarQueryParameter['specialization_id'] = specializationId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobEvaluationId 
         * @param {string} jobId 
         * @param {SubmitEvaluationAssignmentBody} submitEvaluationAssignmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSubmitEvaluationAssignment: async (jobEvaluationId: string, jobId: string, submitEvaluationAssignmentBody: SubmitEvaluationAssignmentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobEvaluationId' is not null or undefined
            assertParamExists('jobApiSubmitEvaluationAssignment', 'jobEvaluationId', jobEvaluationId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiSubmitEvaluationAssignment', 'jobId', jobId)
            // verify required parameter 'submitEvaluationAssignmentBody' is not null or undefined
            assertParamExists('jobApiSubmitEvaluationAssignment', 'submitEvaluationAssignmentBody', submitEvaluationAssignmentBody)
            const localVarPath = `/job/{job_id}/evaluation/{job_evaluation_id}/submit`
                .replace('{job_evaluation_id}', encodeURIComponent(String(jobEvaluationId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitEvaluationAssignmentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobAssessmentSubmitBase} jobAssessmentSubmitBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSubmitJobAssessment: async (jobId: string, jobAssessmentSubmitBase: JobAssessmentSubmitBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiSubmitJobAssessment', 'jobId', jobId)
            // verify required parameter 'jobAssessmentSubmitBase' is not null or undefined
            assertParamExists('jobApiSubmitJobAssessment', 'jobAssessmentSubmitBase', jobAssessmentSubmitBase)
            const localVarPath = `/job/{job_id}/assessment/submit`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobAssessmentSubmitBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiTestSpotlightWhatsapp: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/job/admin/test-spotlight-whatsapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {number} [expectedCost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUnlockApplicantAiScores: async (jobId: string, orgId: string, expectedCost?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUnlockApplicantAiScores', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiUnlockApplicantAiScores', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant-ai-access/unlock`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (expectedCost !== undefined) {
                localVarQueryParameter['expected_cost'] = expectedCost;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUnlockDbAccess: async (jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUnlockDbAccess', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiUnlockDbAccess', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/job/{job_id}/db-access/unlock`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUnlockInviteProfile: async (jobId: string, orgId: string, profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUnlockInviteProfile', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiUnlockInviteProfile', 'orgId', orgId)
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('jobApiUnlockInviteProfile', 'profileId', profileId)
            const localVarPath = `/org/{org_id}/job/{job_id}/profile/{profile_id}/unlock`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{profile_id}', encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} noteId 
         * @param {string} orgId 
         * @param {CreateApplicantNoteBody} createApplicantNoteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateApplicantNote: async (jobId: string, noteId: string, orgId: string, createApplicantNoteBody: CreateApplicantNoteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateApplicantNote', 'jobId', jobId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('jobApiUpdateApplicantNote', 'noteId', noteId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiUpdateApplicantNote', 'orgId', orgId)
            // verify required parameter 'createApplicantNoteBody' is not null or undefined
            assertParamExists('jobApiUpdateApplicantNote', 'createApplicantNoteBody', createApplicantNoteBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicants/notes/{note_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{note_id}', encodeURIComponent(String(noteId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createApplicantNoteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} ratingValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateApplicantRating: async (applicantId: string, jobId: string, orgId: string, ratingValue: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('jobApiUpdateApplicantRating', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateApplicantRating', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiUpdateApplicantRating', 'orgId', orgId)
            // verify required parameter 'ratingValue' is not null or undefined
            assertParamExists('jobApiUpdateApplicantRating', 'ratingValue', ratingValue)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant/{applicant_id}/rating/{rating_value}`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{rating_value}', encodeURIComponent(String(ratingValue)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {string} fieldId 
         * @param {CreateAssessmentFieldBody} createAssessmentFieldBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateAssessmentField: async (assessmentId: string, fieldId: string, createAssessmentFieldBody: CreateAssessmentFieldBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('jobApiUpdateAssessmentField', 'assessmentId', assessmentId)
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('jobApiUpdateAssessmentField', 'fieldId', fieldId)
            // verify required parameter 'createAssessmentFieldBody' is not null or undefined
            assertParamExists('jobApiUpdateAssessmentField', 'createAssessmentFieldBody', createAssessmentFieldBody)
            const localVarPath = `/assessment/{assessment_id}/field/{field_id}`
                .replace('{assessment_id}', encodeURIComponent(String(assessmentId)))
                .replace('{field_id}', encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssessmentFieldBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assessmentResponseId 
         * @param {CreateAssessmentResponsedBody} createAssessmentResponsedBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateAssessmentResponse: async (assessmentResponseId: string, createAssessmentResponsedBody: CreateAssessmentResponsedBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentResponseId' is not null or undefined
            assertParamExists('jobApiUpdateAssessmentResponse', 'assessmentResponseId', assessmentResponseId)
            // verify required parameter 'createAssessmentResponsedBody' is not null or undefined
            assertParamExists('jobApiUpdateAssessmentResponse', 'createAssessmentResponsedBody', createAssessmentResponsedBody)
            const localVarPath = `/assessment_response/{assessment_response_id}`
                .replace('{assessment_response_id}', encodeURIComponent(String(assessmentResponseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssessmentResponsedBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDegreeBody} updateDegreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateDegree: async (updateDegreeBody: UpdateDegreeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDegreeBody' is not null or undefined
            assertParamExists('jobApiUpdateDegree', 'updateDegreeBody', updateDegreeBody)
            const localVarPath = `/admin/degree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDegreeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {ExternalApplicationStatusBody} externalApplicationStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateExternalApplication: async (jobId: string, externalApplicationStatusBody: ExternalApplicationStatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateExternalApplication', 'jobId', jobId)
            // verify required parameter 'externalApplicationStatusBody' is not null or undefined
            assertParamExists('jobApiUpdateExternalApplication', 'externalApplicationStatusBody', externalApplicationStatusBody)
            const localVarPath = `/job/{job_id}/external-application`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalApplicationStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {Array<UpdateFieldPositionBody>} updateFieldPositionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateFieldPosition: async (assessmentId: string, updateFieldPositionBody: Array<UpdateFieldPositionBody>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('jobApiUpdateFieldPosition', 'assessmentId', assessmentId)
            // verify required parameter 'updateFieldPositionBody' is not null or undefined
            assertParamExists('jobApiUpdateFieldPosition', 'updateFieldPositionBody', updateFieldPositionBody)
            const localVarPath = `/assessment/{assessment_id}/field/position`
                .replace('{assessment_id}', encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFieldPositionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {UpdateJobAnalysisStatusBody} updateJobAnalysisStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateGptJobAnalysisStatus: async (jobId: string, updateJobAnalysisStatusBody: UpdateJobAnalysisStatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateGptJobAnalysisStatus', 'jobId', jobId)
            // verify required parameter 'updateJobAnalysisStatusBody' is not null or undefined
            assertParamExists('jobApiUpdateGptJobAnalysisStatus', 'updateJobAnalysisStatusBody', updateJobAnalysisStatusBody)
            const localVarPath = `/internal/job/{job_id}/analysis-status`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateJobAnalysisStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {UpdateHiringStatusBody} updateHiringStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateHiringStatus: async (applicantId: string, jobId: string, orgId: string, updateHiringStatusBody: UpdateHiringStatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicantId' is not null or undefined
            assertParamExists('jobApiUpdateHiringStatus', 'applicantId', applicantId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateHiringStatus', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiUpdateHiringStatus', 'orgId', orgId)
            // verify required parameter 'updateHiringStatusBody' is not null or undefined
            assertParamExists('jobApiUpdateHiringStatus', 'updateHiringStatusBody', updateHiringStatusBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicants/{applicant_id}/hiring-status`
                .replace('{applicant_id}', encodeURIComponent(String(applicantId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHiringStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {UpdateJobBody} updateJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJob: async (jobId: string, orgId: string, updateJobBody: UpdateJobBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateJob', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiUpdateJob', 'orgId', orgId)
            // verify required parameter 'updateJobBody' is not null or undefined
            assertParamExists('jobApiUpdateJob', 'updateJobBody', updateJobBody)
            const localVarPath = `/org/{org_id}/job/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateJobBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminUpdateJobBody} adminUpdateJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobAdmin: async (adminUpdateJobBody: AdminUpdateJobBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUpdateJobBody' is not null or undefined
            assertParamExists('jobApiUpdateJobAdmin', 'adminUpdateJobBody', adminUpdateJobBody)
            const localVarPath = `/admin/job-attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateJobBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} jobId 
         * @param {AddApplicantMessageBody} addApplicantMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobApplicantMsg: async (chatId: string, jobId: string, addApplicantMessageBody: AddApplicantMessageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('jobApiUpdateJobApplicantMsg', 'chatId', chatId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateJobApplicantMsg', 'jobId', jobId)
            // verify required parameter 'addApplicantMessageBody' is not null or undefined
            assertParamExists('jobApiUpdateJobApplicantMsg', 'addApplicantMessageBody', addApplicantMessageBody)
            const localVarPath = `/job/{job_id}/chat/{chat_id}`
                .replace('{chat_id}', encodeURIComponent(String(chatId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addApplicantMessageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {Array<UpdateJobApplicantTagBody>} updateJobApplicantTagBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobApplicantTag: async (jobId: string, orgId: string, updateJobApplicantTagBody: Array<UpdateJobApplicantTagBody>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateJobApplicantTag', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiUpdateJobApplicantTag', 'orgId', orgId)
            // verify required parameter 'updateJobApplicantTagBody' is not null or undefined
            assertParamExists('jobApiUpdateJobApplicantTag', 'updateJobApplicantTagBody', updateJobApplicantTagBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/applicant-tag`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateJobApplicantTagBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} [bookmark] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobBookmark: async (jobId: string, bookmark?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateJobBookmark', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/bookmark`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bookmark !== undefined) {
                localVarQueryParameter['bookmark'] = bookmark;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobEmailPreferenceUpdateBody} jobEmailPreferenceUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobEmailPreferences: async (jobEmailPreferenceUpdateBody: JobEmailPreferenceUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobEmailPreferenceUpdateBody' is not null or undefined
            assertParamExists('jobApiUpdateJobEmailPreferences', 'jobEmailPreferenceUpdateBody', jobEmailPreferenceUpdateBody)
            const localVarPath = `/admin/job-email/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobEmailPreferenceUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {JobEvaluationBody} jobEvaluationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobEvaluation: async (evaluationId: string, jobId: string, orgId: string, jobEvaluationBody: JobEvaluationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evaluationId' is not null or undefined
            assertParamExists('jobApiUpdateJobEvaluation', 'evaluationId', evaluationId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateJobEvaluation', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('jobApiUpdateJobEvaluation', 'orgId', orgId)
            // verify required parameter 'jobEvaluationBody' is not null or undefined
            assertParamExists('jobApiUpdateJobEvaluation', 'jobEvaluationBody', jobEvaluationBody)
            const localVarPath = `/org/{org_id}/job/{job_id}/evaluation/{evaluation_id}`
                .replace('{evaluation_id}', encodeURIComponent(String(evaluationId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(jobEvaluationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobProfileSkillBuilderScores: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateJobProfileSkillBuilderScores', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/update-job-profile-skill-builder-scores`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} chatReactionId 
         * @param {string} jobId 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateReactionMsg: async (chatId: string, chatReactionId: string, jobId: string, message: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('jobApiUpdateReactionMsg', 'chatId', chatId)
            // verify required parameter 'chatReactionId' is not null or undefined
            assertParamExists('jobApiUpdateReactionMsg', 'chatReactionId', chatReactionId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiUpdateReactionMsg', 'jobId', jobId)
            // verify required parameter 'message' is not null or undefined
            assertParamExists('jobApiUpdateReactionMsg', 'message', message)
            const localVarPath = `/job/{job_id}/chat/{chat_id}/chat_reaction/{chat_reaction_id}`
                .replace('{chat_id}', encodeURIComponent(String(chatId)))
                .replace('{chat_reaction_id}', encodeURIComponent(String(chatReactionId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (message !== undefined) {
                localVarQueryParameter['message'] = message;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} versionNo 
         * @param {UpdateResumeBuilderBody} updateResumeBuilderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateResumeBuilderDetails: async (resumeBuilderId: string, versionNo: string, updateResumeBuilderBody: UpdateResumeBuilderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resumeBuilderId' is not null or undefined
            assertParamExists('jobApiUpdateResumeBuilderDetails', 'resumeBuilderId', resumeBuilderId)
            // verify required parameter 'versionNo' is not null or undefined
            assertParamExists('jobApiUpdateResumeBuilderDetails', 'versionNo', versionNo)
            // verify required parameter 'updateResumeBuilderBody' is not null or undefined
            assertParamExists('jobApiUpdateResumeBuilderDetails', 'updateResumeBuilderBody', updateResumeBuilderBody)
            const localVarPath = `/resume-builder/resume/{resume_builder_id}/version/{version_no}`
                .replace('{resume_builder_id}', encodeURIComponent(String(resumeBuilderId)))
                .replace('{version_no}', encodeURIComponent(String(versionNo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateResumeBuilderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpdateSkillBody} updateSkillBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateSkill: async (skillId: string, updateSkillBody: UpdateSkillBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('jobApiUpdateSkill', 'skillId', skillId)
            // verify required parameter 'updateSkillBody' is not null or undefined
            assertParamExists('jobApiUpdateSkill', 'updateSkillBody', updateSkillBody)
            const localVarPath = `/admin/job/skills/{skill_id}`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSkillBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSpecializationBody} updateSpecializationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateSpecialization: async (updateSpecializationBody: UpdateSpecializationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSpecializationBody' is not null or undefined
            assertParamExists('jobApiUpdateSpecialization', 'updateSpecializationBody', updateSpecializationBody)
            const localVarPath = `/admin/specialization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSpecializationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertCandidateDetailsBody} upsertCandidateDetailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpsertCandidateMetaDetails: async (upsertCandidateDetailsBody: UpsertCandidateDetailsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertCandidateDetailsBody' is not null or undefined
            assertParamExists('jobApiUpsertCandidateMetaDetails', 'upsertCandidateDetailsBody', upsertCandidateDetailsBody)
            const localVarPath = `/job/candidate-meta-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertCandidateDetailsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GovernorPlanBody} governorPlanBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpsertGovernorPlans: async (governorPlanBody: GovernorPlanBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'governorPlanBody' is not null or undefined
            assertParamExists('jobApiUpsertGovernorPlans', 'governorPlanBody', governorPlanBody)
            const localVarPath = `/admin/job-governor/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(governorPlanBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiWithdrawJobApplication: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('jobApiWithdrawJobApplication', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/withdraw`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobApiApi - functional programming interface
 */
export const JobApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} jobId 
         * @param {AddApplicantMessageBody} addApplicantMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAddJobApplicantMsg(jobId: string, addApplicantMessageBody: AddApplicantMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddApplicantMsgResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAddJobApplicantMsg(jobId, addApplicantMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAddJobApplicantMsg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {BulkAddJobItemToCartBody} bulkAddJobItemToCartBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAddJobItemsToCart(orgId: string, bulkAddJobItemToCartBody: BulkAddJobItemToCartBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddItemToCartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAddJobItemsToCart(orgId, bulkAddJobItemToCartBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAddJobItemsToCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobProfileMatchList} jobProfileMatchList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAddJobProfile(jobId: string, jobProfileMatchList: JobProfileMatchList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAddJobProfile(jobId, jobProfileMatchList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAddJobProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} jobId 
         * @param {AddReactionMessageBody} addReactionMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAddReactionMsg(chatId: string, jobId: string, addReactionMessageBody: AddReactionMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddReactionMsgResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAddReactionMsg(chatId, jobId, addReactionMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAddReactionMsg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResumeBuilderBody} resumeBuilderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAddResumeBuilderDetails(resumeBuilderBody: ResumeBuilderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResumeBuilderResponseById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAddResumeBuilderDetails(resumeBuilderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAddResumeBuilderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {AdminJobApplyBody} adminJobApplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAdminCreateJobApplicant(jobId: string, adminJobApplyBody: AdminJobApplyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAdminCreateJobApplicant(jobId, adminJobApplyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAdminCreateJobApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {boolean} [showJobAssociatedSkills] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAdminGetJobSkills(name?: string, pageNo?: number, pageSize?: number, showJobAssociatedSkills?: boolean, sortBy?: string, sortOrder?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetAllSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAdminGetJobSkills(name, pageNo, pageSize, showJobAssociatedSkills, sortBy, sortOrder, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAdminGetJobSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReprocessStuckResumesBody} reprocessStuckResumesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAdminReprocessStuckResumes(reprocessStuckResumesBody: ReprocessStuckResumesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAdminReprocessStuckResumes(reprocessStuckResumesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAdminReprocessStuckResumes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {IDMail} iDMail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAdminWithdrawJobApplication(jobId: string, iDMail: IDMail, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAdminWithdrawJobApplication(jobId, iDMail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAdminWithdrawJobApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AIPromptAnalysisBody} aIPromptAnalysisBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAiDraftAnalyze(orgId: string, aIPromptAnalysisBody: AIPromptAnalysisBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIPromptAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAiDraftAnalyze(orgId, aIPromptAnalysisBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAiDraftAnalyze']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AIScreeningQuestionsBody} aIScreeningQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAiDraftQuestions(orgId: string, aIScreeningQuestionsBody: AIScreeningQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIScreeningQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAiDraftQuestions(orgId, aIScreeningQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAiDraftQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AIRegenerateJDBody} aIRegenerateJDBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAiDraftRegenerateJd(orgId: string, aIRegenerateJDBody: AIRegenerateJDBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAiDraftRegenerateJd(orgId, aIRegenerateJDBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAiDraftRegenerateJd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AIDraftPromptBody} aIDraftPromptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAiDraftStream(orgId: string, aIDraftPromptBody: AIDraftPromptBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAiDraftStream(orgId, aIDraftPromptBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAiDraftStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {AITranslateBody} aITranslateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAiDraftTranslate(orgId: string, aITranslateBody: AITranslateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AITranslateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAiDraftTranslate(orgId, aITranslateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAiDraftTranslate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAnalyseIsolatedUserResumes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAnalyseIsolatedUserResumes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAnalyseIsolatedUserResumes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} versionNo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAnalyzeResume(resumeBuilderId: string, versionNo: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAnalyzeResume(resumeBuilderId, versionNo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAnalyzeResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} versionNo 
         * @param {ResumeBuilderAnalyseBody} resumeBuilderAnalyseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAnalyzeResumeBuilder(resumeBuilderId: string, versionNo: string, resumeBuilderAnalyseBody: ResumeBuilderAnalyseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeBuilderAnalysis>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAnalyzeResumeBuilder(resumeBuilderId, versionNo, resumeBuilderAnalyseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAnalyzeResumeBuilder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {ResumeJobFitAnalyseBody} resumeJobFitAnalyseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAnalyzeResumeJobFit(jobId: string, userResumeId: string, resumeJobFitAnalyseBody: ResumeJobFitAnalyseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeJobFitAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAnalyzeResumeJobFit(jobId, userResumeId, resumeJobFitAnalyseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAnalyzeResumeJobFit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {SpotlightBoostBody} spotlightBoostBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiApplySpotlightBoost(jobId: string, spotlightBoostBody: SpotlightBoostBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpotlightBoostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiApplySpotlightBoost(jobId, spotlightBoostBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiApplySpotlightBoost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {ResumeJobFitApplyBody} resumeJobFitApplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiApplyWithJobFitResume(jobId: string, userResumeId: string, resumeJobFitApplyBody: ResumeJobFitApplyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeJobFitApplyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiApplyWithJobFitResume(jobId, userResumeId, resumeJobFitApplyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiApplyWithJobFitResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiAssociateJobWithCompetition(competitionId: string, jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiAssociateJobWithCompetition(competitionId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiAssociateJobWithCompetition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [categories] 
         * @param {Array<string>} [companies] 
         * @param {Array<string>} [countries] 
         * @param {Array<string>} [excludeCategories] 
         * @param {Array<string>} [excludeCompanies] 
         * @param {Array<string>} [excludeCountries] 
         * @param {Array<string>} [excludeLocationKeywords] 
         * @param {Array<string>} [excludePositionKeywords] 
         * @param {Array<string>} [excludeScrapers] 
         * @param {Array<string>} [excludeTags] 
         * @param {Array<string>} [excludeTitleKeywords] 
         * @param {boolean | null} [isEmailCorporate] 
         * @param {Array<string>} [locationKeywords] 
         * @param {Array<string>} [positionKeywords] 
         * @param {Array<string>} [scrapers] 
         * @param {Array<string>} [tags] 
         * @param {Array<string>} [titleKeywords] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiBqAudienceCountApi(categories?: Array<string>, companies?: Array<string>, countries?: Array<string>, excludeCategories?: Array<string>, excludeCompanies?: Array<string>, excludeCountries?: Array<string>, excludeLocationKeywords?: Array<string>, excludePositionKeywords?: Array<string>, excludeScrapers?: Array<string>, excludeTags?: Array<string>, excludeTitleKeywords?: Array<string>, isEmailCorporate?: boolean | null, locationKeywords?: Array<string>, positionKeywords?: Array<string>, scrapers?: Array<string>, tags?: Array<string>, titleKeywords?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BqAudienceCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiBqAudienceCountApi(categories, companies, countries, excludeCategories, excludeCompanies, excludeCountries, excludeLocationKeywords, excludePositionKeywords, excludeScrapers, excludeTags, excludeTitleKeywords, isEmailCorporate, locationKeywords, positionKeywords, scrapers, tags, titleKeywords, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiBqAudienceCountApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [categories] 
         * @param {Array<string>} [companies] 
         * @param {Array<string>} [countries] 
         * @param {Array<string>} [excludeCategories] 
         * @param {Array<string>} [excludeCompanies] 
         * @param {Array<string>} [excludeCountries] 
         * @param {Array<string>} [excludeLocationKeywords] 
         * @param {Array<string>} [excludePositionKeywords] 
         * @param {Array<string>} [excludeScrapers] 
         * @param {Array<string>} [excludeTags] 
         * @param {Array<string>} [excludeTitleKeywords] 
         * @param {JobApiBqAudienceExportApiFormatEnum} [format] 
         * @param {boolean | null} [isEmailCorporate] 
         * @param {number} [limit] 
         * @param {Array<string>} [locationKeywords] 
         * @param {number} [offset] 
         * @param {Array<string>} [positionKeywords] 
         * @param {Array<string>} [scrapers] 
         * @param {Array<string>} [tags] 
         * @param {Array<string>} [titleKeywords] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiBqAudienceExportApi(categories?: Array<string>, companies?: Array<string>, countries?: Array<string>, excludeCategories?: Array<string>, excludeCompanies?: Array<string>, excludeCountries?: Array<string>, excludeLocationKeywords?: Array<string>, excludePositionKeywords?: Array<string>, excludeScrapers?: Array<string>, excludeTags?: Array<string>, excludeTitleKeywords?: Array<string>, format?: JobApiBqAudienceExportApiFormatEnum, isEmailCorporate?: boolean | null, limit?: number, locationKeywords?: Array<string>, offset?: number, positionKeywords?: Array<string>, scrapers?: Array<string>, tags?: Array<string>, titleKeywords?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiBqAudienceExportApi(categories, companies, countries, excludeCategories, excludeCompanies, excludeCountries, excludeLocationKeywords, excludePositionKeywords, excludeScrapers, excludeTags, excludeTitleKeywords, format, isEmailCorporate, limit, locationKeywords, offset, positionKeywords, scrapers, tags, titleKeywords, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiBqAudienceExportApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobApiBqAutocompleteApiFieldEnum} field 
         * @param {Array<string>} [categories] 
         * @param {Array<string>} [companies] 
         * @param {Array<string>} [countries] 
         * @param {Array<string>} [excludeCategories] 
         * @param {Array<string>} [excludeCompanies] 
         * @param {Array<string>} [excludeCountries] 
         * @param {Array<string>} [excludeLocationKeywords] 
         * @param {Array<string>} [excludePositionKeywords] 
         * @param {Array<string>} [excludeScrapers] 
         * @param {Array<string>} [excludeTags] 
         * @param {Array<string>} [excludeTitleKeywords] 
         * @param {boolean | null} [isEmailCorporate] 
         * @param {Array<string>} [locationKeywords] 
         * @param {Array<string>} [positionKeywords] 
         * @param {string} [q] 
         * @param {Array<string>} [scrapers] 
         * @param {Array<string>} [tags] 
         * @param {Array<string>} [titleKeywords] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiBqAutocompleteApi(field: JobApiBqAutocompleteApiFieldEnum, categories?: Array<string>, companies?: Array<string>, countries?: Array<string>, excludeCategories?: Array<string>, excludeCompanies?: Array<string>, excludeCountries?: Array<string>, excludeLocationKeywords?: Array<string>, excludePositionKeywords?: Array<string>, excludeScrapers?: Array<string>, excludeTags?: Array<string>, excludeTitleKeywords?: Array<string>, isEmailCorporate?: boolean | null, locationKeywords?: Array<string>, positionKeywords?: Array<string>, q?: string, scrapers?: Array<string>, tags?: Array<string>, titleKeywords?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BqAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiBqAutocompleteApi(field, categories, companies, countries, excludeCategories, excludeCompanies, excludeCountries, excludeLocationKeywords, excludePositionKeywords, excludeScrapers, excludeTags, excludeTitleKeywords, isEmailCorporate, locationKeywords, positionKeywords, q, scrapers, tags, titleKeywords, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiBqAutocompleteApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {BulkApplicantActionBody} bulkApplicantActionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiBulkActionOnApplicants(jobId: string, orgId: string, bulkApplicantActionBody: BulkApplicantActionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiBulkActionOnApplicants(jobId, orgId, bulkApplicantActionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiBulkActionOnApplicants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {BulkAddJobApplicantMessageBody} bulkAddJobApplicantMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiBulkAddJobApplicantMessage(jobId: string, orgId: string, bulkAddJobApplicantMessageBody: BulkAddJobApplicantMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiBulkAddJobApplicantMessage(jobId, orgId, bulkAddJobApplicantMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiBulkAddJobApplicantMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkStatusUpdateBody} bulkStatusUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiBulkJobStatusUpdate(bulkStatusUpdateBody: BulkStatusUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiBulkJobStatusUpdate(bulkStatusUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiBulkJobStatusUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CandidateBoardingBody} candidateBoardingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCandidateOnboarding(candidateBoardingBody: CandidateBoardingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCandidateOnboarding(candidateBoardingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCandidateOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [role] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCandidateShowcase(role?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateShowcaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCandidateShowcase(role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCandidateShowcase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCheckDuplicateJob(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckDuplicateJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCheckDuplicateJob(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCheckDuplicateJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobProfileBody} jobProfileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCompleteJobProfile(jobProfileBody: JobProfileBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCompleteJobProfile(jobProfileBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCompleteJobProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {CopyEvaluationQuestionsBody} copyEvaluationQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCopyEvaluationQuestions(evaluationId: string, jobId: string, orgId: string, copyEvaluationQuestionsBody: CopyEvaluationQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCopyEvaluationQuestions(evaluationId, jobId, orgId, copyEvaluationQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCopyEvaluationQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {CreateApplicantNoteBody} createApplicantNoteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateApplicantNote(applicantId: string, jobId: string, orgId: string, createApplicantNoteBody: CreateApplicantNoteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobNotesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateApplicantNote(applicantId, jobId, orgId, createApplicantNoteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateApplicantNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateAssessment(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAssessmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateAssessment(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateAssessmentDuplicateBody} createAssessmentDuplicateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateAssessmentDuplicate(createAssessmentDuplicateBody: CreateAssessmentDuplicateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAssessmentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateAssessmentDuplicate(createAssessmentDuplicateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateAssessmentDuplicate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {CreateAssessmentFieldBody} createAssessmentFieldBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateAssessmentField(assessmentId: string, createAssessmentFieldBody: CreateAssessmentFieldBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateAssessmentField(assessmentId, createAssessmentFieldBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateAssessmentField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkJobApplyBody} bulkJobApplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateBulkJobsApplicants(bulkJobApplyBody: BulkJobApplyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkJobApplyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateBulkJobsApplicants(bulkJobApplyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateBulkJobsApplicants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateCompanyXml(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateCompanyXml(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateCompanyXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<CreateDegreeBody>} createDegreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateDegree(createDegreeBody: Array<CreateDegreeBody>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDegreeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateDegree(createDegreeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateDegree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateJobBody} createJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateJob(orgId: string, createJobBody: CreateJobBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateJob(orgId, createJobBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobApplyAssessmentBody} jobApplyAssessmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateJobApplicants(jobId: string, jobApplyAssessmentBody: JobApplyAssessmentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobApplicantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateJobApplicants(jobId, jobApplyAssessmentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateJobApplicants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {GetFilteredApplicantUserIdsBody} getFilteredApplicantUserIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateJobCandidateCsv(jobId: string, orgId: string, getFilteredApplicantUserIdsBody: GetFilteredApplicantUserIdsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateJobCandidateCsv(jobId, orgId, getFilteredApplicantUserIdsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateJobCandidateCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {JobEvaluationBody} jobEvaluationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateJobEvaluation(jobId: string, orgId: string, jobEvaluationBody: JobEvaluationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEvaluationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateJobEvaluation(jobId, orgId, jobEvaluationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateJobEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateJobLocationXml(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateJobLocationXml(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateJobLocationXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobReportBody} jobReportBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateJobReport(jobReportBody: JobReportBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateJobReport(jobReportBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateJobReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateJobRoleXml(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateJobRoleXml(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateJobRoleXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateJobsXml(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateJobsXml(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateJobsXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateSitemapOfSitemapsXml(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateSitemapOfSitemapsXml(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateSitemapOfSitemapsXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSkillBody} createSkillBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateSkillBulk(createSkillBody: CreateSkillBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateSkillBulk(createSkillBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateSkillBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<CreateSpecializationBody>} createSpecializationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiCreateSpecialization(createSpecializationBody: Array<CreateSpecializationBody>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSpecializationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiCreateSpecialization(createSpecializationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiCreateSpecialization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [degreeId] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDegreeAutoComplete(degreeId?: string, pageNo?: string, pageSize?: string, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DegreeAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDegreeAutoComplete(degreeId, pageNo, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDegreeAutoComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} noteId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteApplicantNote(jobId: string, noteId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobNotesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteApplicantNote(jobId, noteId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteApplicantNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteAssessment(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteAssessment(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteAssessmentField(assessmentId: string, fieldId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteAssessmentField(assessmentId, fieldId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteAssessmentField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {string} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteAssessmentResponse(assessmentId: string, responseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteAssessmentResponse(assessmentId, responseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteAssessmentResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} degreeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteDegree(degreeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteDegree(degreeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteDegree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteJob(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteJob(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteJobApplicantMsg(chatId: string, jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteJobApplicantMsg(chatId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteJobApplicantMsg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteJobCompletely(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteJobCompletelyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteJobCompletely(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteJobCompletely']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} chatReactionId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteReactionMsg(chatId: string, chatReactionId: string, jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteReactionMsg(chatId, chatReactionId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteReactionMsg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} [versionNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteResumeBuilderDetails(resumeBuilderId: string, versionNo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteResumeBuilderDetails(resumeBuilderId, versionNo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteResumeBuilderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {DeleteJobApplicantBody} deleteJobApplicantBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteResumeJobApplicant(jobId: string, orgId: string, deleteJobApplicantBody: DeleteJobApplicantBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteResumeJobApplicant(jobId, orgId, deleteJobApplicantBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteResumeJobApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IDList} iDList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteSkill(iDList: IDList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteSkill(iDList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} specializationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteSpecialization(specializationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteSpecialization(specializationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteSpecialization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDeleteUserSkill(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDeleteUserSkill(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDeleteUserSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDisableAutoJobApply(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDisableAutoJobApply(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDisableAutoJobApply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDownloadJobProfileMatchById(jobId: string, orgId: string, profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDownloadJobProfileMatchById(jobId, orgId, profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDownloadJobProfileMatchById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {ResumeJobFitDownloadBody} resumeJobFitDownloadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiDownloadResumeJobFit(jobId: string, userResumeId: string, resumeJobFitDownloadBody: ResumeJobFitDownloadBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiDownloadResumeJobFit(jobId, userResumeId, resumeJobFitDownloadBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiDownloadResumeJobFit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {UserResumeEntityList} userResumeEntityList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiEmailAllMatchingJobProfiles(jobId: string, userResumeEntityList: UserResumeEntityList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiEmailAllMatchingJobProfiles(jobId, userResumeEntityList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiEmailAllMatchingJobProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {EmployerBulkStatusUpdateBody} employerBulkStatusUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiEmployerBulkJobStatusUpdate(orgId: string, employerBulkStatusUpdateBody: EmployerBulkStatusUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiEmployerBulkJobStatusUpdate(orgId, employerBulkStatusUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiEmployerBulkJobStatusUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiEnableAutoJobApply(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnableAutoJobApplyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiEnableAutoJobApply(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiEnableAutoJobApply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} versionNo 
         * @param {EnhanceResumeBody} enhanceResumeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiEnhanceResume(resumeBuilderId: string, versionNo: string, enhanceResumeBody: EnhanceResumeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiEnhanceResume(resumeBuilderId, versionNo, enhanceResumeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiEnhanceResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {ResumeJobFitEnhanceBody} resumeJobFitEnhanceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiEnhanceResumeJobFit(jobId: string, userResumeId: string, resumeJobFitEnhanceBody: ResumeJobFitEnhanceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiEnhanceResumeJobFit(jobId, userResumeId, resumeJobFitEnhanceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiEnhanceResumeJobFit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {ExternalApplyBody} externalApplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiExternalApply(jobId: string, externalApplyBody: ExternalApplyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalApplicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiExternalApply(jobId, externalApplyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiExternalApply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiExternalClick(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiExternalClick(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiExternalClick']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FixJobFormattingBody} fixJobFormattingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiFixJobFormatting(fixJobFormattingBody: FixJobFormattingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FixJobFormattingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiFixJobFormatting(fixJobFormattingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiFixJobFormatting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} jobId 
         * @param {GenerateAndAssociateJobChallengeQuestionsBody} generateAndAssociateJobChallengeQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGenerateAndAssociateJobChallengeQuestions(competitionId: string, jobId: string, generateAndAssociateJobChallengeQuestionsBody: GenerateAndAssociateJobChallengeQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGenerateAndAssociateJobChallengeQuestions(competitionId, jobId, generateAndAssociateJobChallengeQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGenerateAndAssociateJobChallengeQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {GenerateQuestionsAndCreateJobCompetitionBody} generateQuestionsAndCreateJobCompetitionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGenerateQuestionsAndCreateJobCompetition(jobId: string, generateQuestionsAndCreateJobCompetitionBody: GenerateQuestionsAndCreateJobCompetitionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGenerateQuestionsAndCreateJobCompetition(jobId, generateQuestionsAndCreateJobCompetitionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGenerateQuestionsAndCreateJobCompetition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {GenerateRecruiterMessageBody} generateRecruiterMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGenerateRecruiterMessage(jobId: string, generateRecruiterMessageBody: GenerateRecruiterMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGenerateRecruiterMessage(jobId, generateRecruiterMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGenerateRecruiterMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetActivityTypeCounts(days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivityTypeCountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetActivityTypeCounts(days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetActivityTypeCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAiDraftPayload(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIDraftPayloadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAiDraftPayload(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAiDraftPayload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAiDraftedJobs(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIDraftedJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAiDraftedJobs(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAiDraftedJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ActiveJobBody} activeJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAllActiveJobs(activeJobBody: ActiveJobBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAllActiveJobs(activeJobBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAllActiveJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ActiveJobBody} activeJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAllActiveJobsPublic(activeJobBody: ActiveJobBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAllActiveJobsPublic(activeJobBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAllActiveJobsPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string> | null} [hiringStatus] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<string> | null} [skillIds] 
         * @param {Array<string> | null} [status] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAllAppliedJobs(hiringStatus?: Array<string> | null, page?: number, pageSize?: number, skillIds?: Array<string> | null, status?: Array<string> | null, userSearchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAppliedJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAllAppliedJobs(hiringStatus, page, pageSize, skillIds, status, userSearchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAllAppliedJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {boolean} [showContacts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAndMarkJobProfileDownload(jobId: string, orgId: string, profileId: string, showContacts?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAndMarkJobProfileDownload(jobId, orgId, profileId, showContacts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAndMarkJobProfileDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetApplicantAiAccessStatus(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicantAiAccessStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetApplicantAiAccessStatus(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetApplicantAiAccessStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetApplicantLocation(jobId: string, orgId: string, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobApplicantLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetApplicantLocation(jobId, orgId, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetApplicantLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetApplicantResumeAnalysisByUserId(applicantId: string, jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobResumeAnalysis>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetApplicantResumeAnalysisByUserId(applicantId, jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetApplicantResumeAnalysisByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetApplicantSkills(jobId: string, orgId: string, page?: number, pageSize?: number, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicantsJobRoleAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetApplicantSkills(jobId, orgId, page, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetApplicantSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetApplicantTags(jobId: string, orgId: string, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobApplicantTagResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetApplicantTags(jobId, orgId, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetApplicantTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {Array<string>} [applicantStatus] 
         * @param {Array<string>} [applicantTag] 
         * @param {Array<AssessmentScreeningFilter>} [assessmentScreening] 
         * @param {Array<string>} [collegeIds] 
         * @param {Array<string>} [collegeTier] 
         * @param {CompetitionData} [competitionData] 
         * @param {boolean} [countOnly] 
         * @param {string} [endDate] 
         * @param {boolean | null} [isApplicantSeen] 
         * @param {boolean} [isChatStarted] 
         * @param {string} [jobPreference] 
         * @param {Array<string>} [jobRoleIds] 
         * @param {Array<string>} [matchingBranch] 
         * @param {Array<string>} [matchingDegree] 
         * @param {Array<string>} [matchingLocations] 
         * @param {Array<string>} [matchingSkills] 
         * @param {number} [maxAssessmentScore] 
         * @param {number} [maxCurrentCtc] 
         * @param {number} [maxEducation] 
         * @param {number} [maxExperience] 
         * @param {number} [maxGrade] 
         * @param {number} [maxPassingYear] 
         * @param {number} [maxPercentile] 
         * @param {number} [maxRating] 
         * @param {number} [maxResumeAnalysisExperienceScore] 
         * @param {number} [maxResumeAnalysisOverallScore] 
         * @param {number} [maxResumeAnalysisSkillScore] 
         * @param {number} [maxWorkExperienceMonths] 
         * @param {number} [minAssessmentScore] 
         * @param {number} [minCurrentCtc] 
         * @param {number} [minEducation] 
         * @param {number} [minExperience] 
         * @param {number} [minGrade] 
         * @param {number} [minPassingYear] 
         * @param {number} [minPercentile] 
         * @param {number} [minRating] 
         * @param {number} [minReleventResumeExperienceMonths] 
         * @param {number} [minResumeAnalysisExperienceScore] 
         * @param {number} [minResumeAnalysisOverallScore] 
         * @param {number} [minResumeAnalysisSkillScore] 
         * @param {number} [minWorkExperienceMonths] 
         * @param {Array<string>} [missingSkills] 
         * @param {number} [noticePeriod] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<RequiredSkillsFilter>} [requiredSkills] 
         * @param {boolean} [resumeUploaded] 
         * @param {string} [sortBy] 
         * @param {SortBy} [sortByCompetitionData] 
         * @param {string} [sortOrder] 
         * @param {string} [startDate] 
         * @param {string} [userSearchQuery] 
         * @param {Array<string>} [usernames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetApplicantsDetailsByPage(jobId: string, orgId: string, applicantStatus?: Array<string>, applicantTag?: Array<string>, assessmentScreening?: Array<AssessmentScreeningFilter>, collegeIds?: Array<string>, collegeTier?: Array<string>, competitionData?: CompetitionData, countOnly?: boolean, endDate?: string, isApplicantSeen?: boolean | null, isChatStarted?: boolean, jobPreference?: string, jobRoleIds?: Array<string>, matchingBranch?: Array<string>, matchingDegree?: Array<string>, matchingLocations?: Array<string>, matchingSkills?: Array<string>, maxAssessmentScore?: number, maxCurrentCtc?: number, maxEducation?: number, maxExperience?: number, maxGrade?: number, maxPassingYear?: number, maxPercentile?: number, maxRating?: number, maxResumeAnalysisExperienceScore?: number, maxResumeAnalysisOverallScore?: number, maxResumeAnalysisSkillScore?: number, maxWorkExperienceMonths?: number, minAssessmentScore?: number, minCurrentCtc?: number, minEducation?: number, minExperience?: number, minGrade?: number, minPassingYear?: number, minPercentile?: number, minRating?: number, minReleventResumeExperienceMonths?: number, minResumeAnalysisExperienceScore?: number, minResumeAnalysisOverallScore?: number, minResumeAnalysisSkillScore?: number, minWorkExperienceMonths?: number, missingSkills?: Array<string>, noticePeriod?: number, page?: number, pageSize?: number, requiredSkills?: Array<RequiredSkillsFilter>, resumeUploaded?: boolean, sortBy?: string, sortByCompetitionData?: SortBy, sortOrder?: string, startDate?: string, userSearchQuery?: string, usernames?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicantDetailsPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetApplicantsDetailsByPage(jobId, orgId, applicantStatus, applicantTag, assessmentScreening, collegeIds, collegeTier, competitionData, countOnly, endDate, isApplicantSeen, isChatStarted, jobPreference, jobRoleIds, matchingBranch, matchingDegree, matchingLocations, matchingSkills, maxAssessmentScore, maxCurrentCtc, maxEducation, maxExperience, maxGrade, maxPassingYear, maxPercentile, maxRating, maxResumeAnalysisExperienceScore, maxResumeAnalysisOverallScore, maxResumeAnalysisSkillScore, maxWorkExperienceMonths, minAssessmentScore, minCurrentCtc, minEducation, minExperience, minGrade, minPassingYear, minPercentile, minRating, minReleventResumeExperienceMonths, minResumeAnalysisExperienceScore, minResumeAnalysisOverallScore, minResumeAnalysisSkillScore, minWorkExperienceMonths, missingSkills, noticePeriod, page, pageSize, requiredSkills, resumeUploaded, sortBy, sortByCompetitionData, sortOrder, startDate, userSearchQuery, usernames, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetApplicantsDetailsByPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AppliedJobPopupDataBody} appliedJobPopupDataBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAppliedJobPopupData(appliedJobPopupDataBody: AppliedJobPopupDataBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopupDataResponseSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAppliedJobPopupData(appliedJobPopupDataBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAppliedJobPopupData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAppliedJobsSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppliedJobsSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAppliedJobsSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAppliedJobsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAssessment(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAssessmentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAssessment(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAssessmentFields(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentField>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAssessmentFields(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAssessmentFields']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAutocompleteCollegeApplicants(jobId: string, page?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicantsJobRoleAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAutocompleteCollegeApplicants(jobId, page, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAutocompleteCollegeApplicants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetAutocompleteJobRoleApplicants(jobId: string, pageNo?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicantsJobRoleAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetAutocompleteJobRoleApplicants(jobId, pageNo, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetAutocompleteJobRoleApplicants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [count] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetBestJobs(count?: number, days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BestJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetBestJobs(count, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetBestJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobGetCandidatesBody} jobGetCandidatesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetBqCandidatesApi(jobGetCandidatesBody: JobGetCandidatesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobGetCandidatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetBqCandidatesApi(jobGetCandidatesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetBqCandidatesApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobGetCandidatesBody} jobGetCandidatesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetBqCompaniesApi(jobGetCandidatesBody: JobGetCandidatesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobGetCandidatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetBqCompaniesApi(jobGetCandidatesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetBqCompaniesApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetBqFilterOptionsApi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BqFilterOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetBqFilterOptionsApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetBqFilterOptionsApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetCandidateEvaluation(evaluationId: string, jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEvaluationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetCandidateEvaluation(evaluationId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetCandidateEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetCandidateMetaDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateMetaDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetCandidateMetaDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetCandidateMetaDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetChatUsersForApplicant(page?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatForApplicant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetChatUsersForApplicant(page, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetChatUsersForApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetChatUsersForEmployer(jobId: string, orgId: string, page?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatForEmployers>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetChatUsersForEmployer(jobId, orgId, page, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetChatUsersForEmployer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyAlias 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetCompanyJobs(companyAlias: string, page?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetCompanyJobs(companyAlias, page, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetCompanyJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetCompanyStatistics(companyAlias: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicCompanyStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetCompanyStatistics(companyAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetCompanyStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetDbAccessStatus(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DbAccessStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetDbAccessStatus(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetDbAccessStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [approvalStatus] 
         * @param {string} [degreeId] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetDegree(approvalStatus?: string, degreeId?: string, pageNo?: string, pageSize?: string, sortBy?: string, sortOrder?: string, userSearchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDegreesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetDegree(approvalStatus, degreeId, pageNo, pageSize, sortBy, sortOrder, userSearchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetDegree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobApplicantMessage(applicantId: string, jobId: string, cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApplicantChatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobApplicantMessage(applicantId, jobId, cursor, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobApplicantMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobApplicantsDetails(applicantId: string, jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicantDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobApplicantsDetails(applicantId, jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobApplicantsDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {ApplicantListParam} applicantListParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobApplicantsList(jobId: string, orgId: string, applicantListParam: ApplicantListParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllJobApplicantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobApplicantsList(jobId, orgId, applicantListParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobApplicantsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobApplicantsMetaData(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobApplicantsMetaDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobApplicantsMetaData(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobApplicantsMetaData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobById(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobByIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobById(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobByIdForApplied(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobByIdChandidate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobByIdForApplied(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobByIdForApplied']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {boolean} [isSkillPopupRequired] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobByIdForCandidate(jobId: string, isSkillPopupRequired?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobByIdChandidate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobByIdForCandidate(jobId, isSkillPopupRequired, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobByIdForCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobByIdForCandidatePublic(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobByIdChandidateBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobByIdForCandidatePublic(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobByIdForCandidatePublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobByIdForEmployer(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobByIdEmployer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobByIdForEmployer(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobByIdForEmployer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobByIdSlim(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobByIdSlim>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobByIdSlim(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobByIdSlim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobCandidateJourney(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCandidateJourneyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobCandidateJourney(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobCandidateJourney']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantUserId 
         * @param {string} competitionId 
         * @param {string} jobId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobCompetitionAnsweredQuestions(applicantUserId: string, competitionId: string, jobId: string, page?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnsweredQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobCompetitionAnsweredQuestions(applicantUserId, competitionId, jobId, page, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobCompetitionAnsweredQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobCompetitionStatistics(competitionId: string, jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobCompetitionStatistics(competitionId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobCompetitionStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobEmailPreferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEmailPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobEmailPreferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobEmailPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobEvaluationCandidates(evaluationId: string, jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobEvaluationCandidatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobEvaluationCandidates(evaluationId, jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobEvaluationCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {boolean} [ensureCompetition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobEvaluationDetail(evaluationId: string, jobId: string, orgId: string, ensureCompetition?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEvaluationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobEvaluationDetail(evaluationId, jobId, orgId, ensureCompetition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobEvaluationDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {boolean | null} [autoApplyEnabled] 
         * @param {string} [endDate] 
         * @param {boolean | null} [hasApplied] 
         * @param {Array<string>} [jobRoleList] 
         * @param {number | null} [maxExperience] 
         * @param {number | null} [minExperience] 
         * @param {boolean} [notified] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {Array<string>} [skillIds] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobMatchingEntities(jobId: string, autoApplyEnabled?: boolean | null, endDate?: string, hasApplied?: boolean | null, jobRoleList?: Array<string>, maxExperience?: number | null, minExperience?: number | null, notified?: boolean, pageNo?: number, pageSize?: number, searchQuery?: string, skillIds?: Array<string>, sortBy?: string, sortOrder?: string, startDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchingProfilesResumeEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobMatchingEntities(jobId, autoApplyEnabled, endDate, hasApplied, jobRoleList, maxExperience, minExperience, notified, pageNo, pageSize, searchQuery, skillIds, sortBy, sortOrder, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobMatchingEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {boolean | null} [autoApplyEnabled] 
         * @param {string} [endDate] 
         * @param {boolean | null} [hasApplied] 
         * @param {Array<string>} [jobRoleList] 
         * @param {number | null} [maxExperience] 
         * @param {number | null} [minExperience] 
         * @param {boolean} [notified] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {Array<string>} [skillIds] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobMatchingUsers(jobId: string, autoApplyEnabled?: boolean | null, endDate?: string, hasApplied?: boolean | null, jobRoleList?: Array<string>, maxExperience?: number | null, minExperience?: number | null, notified?: boolean, pageNo?: number, pageSize?: number, searchQuery?: string, skillIds?: Array<string>, sortBy?: string, sortOrder?: string, startDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchingProfilesUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobMatchingUsers(jobId, autoApplyEnabled, endDate, hasApplied, jobRoleList, maxExperience, minExperience, notified, pageNo, pageSize, searchQuery, skillIds, sortBy, sortOrder, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobMatchingUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean | null} [isArchieved] 
         * @param {boolean | null} [isCompetitive] 
         * @param {boolean | null} [isGptJob] 
         * @param {string} [jobStatus] 
         * @param {string} [orgId] 
         * @param {number | null} [pageNo] 
         * @param {number | null} [pageSize] 
         * @param {Array<string>} [planTypeList] 
         * @param {string} [productType] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobPostedList(isArchieved?: boolean | null, isCompetitive?: boolean | null, isGptJob?: boolean | null, jobStatus?: string, orgId?: string, pageNo?: number | null, pageSize?: number | null, planTypeList?: Array<string>, productType?: string, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobPostedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobPostedList(isArchieved, isCompetitive, isGptJob, jobStatus, orgId, pageNo, pageSize, planTypeList, productType, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobPostedList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {ProfileMatchParam} profileMatchParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobProfileMatch(jobId: string, orgId: string, profileMatchParam: ProfileMatchParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileMatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobProfileMatch(jobId, orgId, profileMatchParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobProfileMatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {boolean} [showContacts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobProfileMatchById(jobId: string, orgId: string, profileId: string, showContacts?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobProfileMatchById(jobId, orgId, profileId, showContacts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobProfileMatchById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobProfileMilestone(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobProfileMilestone>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobProfileMilestone(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobProfileMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobRelatedMocktests(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRelatedMockTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobRelatedMocktests(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobRelatedMocktests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobReports(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobReportsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobReports(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobRoleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobRoleSkills(jobRoleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobRoleSkills(jobRoleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobRoleSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobRoleSuggestions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobRoleSuggestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobRoleSuggestions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobRoleSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobSkillSuggestions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobSkillSuggestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobSkillSuggestions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobSkillSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {string} [searchType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobSkillsAutocomplete(pageNo?: number, pageSize?: number, searchQuery?: string, searchType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobRoleSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobSkillsAutocomplete(pageNo, pageSize, searchQuery, searchType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobSkillsAutocomplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobStatistics(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllJobStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobStatistics(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobSummary(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllJobSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobSummary(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobUnreadMessageCount(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobMessageUnreadCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobUnreadMessageCount(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobUnreadMessageCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetOrgCsvParam} getOrgCsvParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobsGoogleAdsMetadataCsv(getOrgCsvParam: GetOrgCsvParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobsGoogleAdsMetadataCsv(getOrgCsvParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobsGoogleAdsMetadataCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [jobRoleIds] 
         * @param {string} [locationName] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobsGroupPublic(jobRoleIds?: Array<string>, locationName?: string, pageNo?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobsGroupPublic(jobRoleIds, locationName, pageNo, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobsGroupPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [jobRoleIds] 
         * @param {string} [locationName] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetJobsLocationsPublic(jobRoleIds?: Array<string>, locationName?: string, pageNo?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetlocationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetJobsLocationsPublic(jobRoleIds, locationName, pageNo, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetJobsLocationsPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetLatestResumeJobFit(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LatestResumeJobFitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetLatestResumeJobFit(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetLatestResumeJobFit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetMatchingJobsDeck(jobId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchingJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetMatchingJobsDeck(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetMatchingJobsDeck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [jobRoleId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetOrgApplicantChats(orgId: string, jobRoleId?: string, page?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgApplicantChats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetOrgApplicantChats(orgId, jobRoleId, page, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetOrgApplicantChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetOrgChatJobs(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgChatJobs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetOrgChatJobs(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetOrgChatJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetOrgJobIds(jobAlias: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgJobID>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetOrgJobIds(jobAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetOrgJobIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyAlias 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetPublicCompanyJobs(companyAlias: string, page?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetPublicCompanyJobs(companyAlias, page, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetPublicCompanyJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetPublicCompanyStatistics(companyAlias: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicCompanyStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetPublicCompanyStatistics(companyAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetPublicCompanyStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetRecruiterEmail(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRecruiterEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetRecruiterEmail(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetRecruiterEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetResumeBuilderAnalysis(analysisId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeBuilderAnalysis>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetResumeBuilderAnalysis(analysisId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetResumeBuilderAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetResumeBuilderData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResumeBuilderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetResumeBuilderData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetResumeBuilderData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} [versionNo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetResumeBuilderDataById(resumeBuilderId: string, versionNo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResumeBuilderResponseById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetResumeBuilderDataById(resumeBuilderId, versionNo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetResumeBuilderDataById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetResumeBuilderVersionsById(resumeBuilderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResumeBuilderVersionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetResumeBuilderVersionsById(resumeBuilderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetResumeBuilderVersionsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetResumeJobFit(jobId: string, userResumeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeJobFitAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetResumeJobFit(jobId, userResumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetResumeJobFit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userResumeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetResumeJobFitQuestions(jobId: string, userResumeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeJobFitQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetResumeJobFitQuestions(jobId, userResumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetResumeJobFitQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetScreeningInsights(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScreeningInsightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetScreeningInsights(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetScreeningInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetSimilarJobs(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSimilarJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetSimilarJobs(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetSimilarJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetSitemapUrls(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetSitemapUrls(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetSitemapUrls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [approvalStatus] 
         * @param {string | null} [degreeId] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [specializationId] 
         * @param {string} [userSearchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetSpecialization(approvalStatus?: string, degreeId?: string | null, pageNo?: string, pageSize?: string, sortBy?: string, sortOrder?: string, specializationId?: string, userSearchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpecializationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetSpecialization(approvalStatus, degreeId, pageNo, pageSize, sortBy, sortOrder, specializationId, userSearchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetSpecialization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetSpotlightOptions(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpotlightOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetSpotlightOptions(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetSpotlightOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [activityTypeList] 
         * @param {string} [applicantId] 
         * @param {Array<string>} [jobIds] 
         * @param {string} [maxDate] 
         * @param {string} [minDate] 
         * @param {Array<string>} [orgIds] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [userId] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetSystemActivityLogs(activityTypeList?: Array<string>, applicantId?: string, jobIds?: Array<string>, maxDate?: string, minDate?: string, orgIds?: Array<string>, pageNo?: number, pageSize?: number, userId?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetSystemActivityLogs(activityTypeList, applicantId, jobIds, maxDate, minDate, orgIds, pageNo, pageSize, userId, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetSystemActivityLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} [activityType] 
         * @param {string} [applicantId] 
         * @param {string} [jobId] 
         * @param {string} [maxDate] 
         * @param {string} [minDate] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetUserActivityLogs(orgId: string, activityType?: string, applicantId?: string, jobId?: string, maxDate?: string, minDate?: string, pageNo?: number, pageSize?: number, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetUserActivityLogs(orgId, activityType, applicantId, jobId, maxDate, minDate, pageNo, pageSize, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetUserActivityLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetUserActivityLogsDetails(activityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivityDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetUserActivityLogsDetails(activityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetUserActivityLogsDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGetUserSkill(pageNo?: number, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserSkillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGetUserSkill(pageNo, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGetUserSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiGovernorDryRun(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GovernorRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiGovernorDryRun(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiGovernorDryRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiHighlightJob(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiHighlightJob(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiHighlightJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiInitialiseJobData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiInitialiseJobData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiInitialiseJobData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiInitialiseJobDataCompany(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiInitialiseJobDataCompany(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiInitialiseJobDataCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiInitiateJobApplicationPreAnalysis(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiInitiateJobApplicationPreAnalysis(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiInitiateJobApplicationPreAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {JobInvitationBody} jobInvitationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiInviteUsersJob(jobId: string, orgId: string, profileId: string, jobInvitationBody: JobInvitationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiInviteUsersJob(jobId, orgId, profileId, jobInvitationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiInviteUsersJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiJobApplicantChatMarkSeen(applicantId: string, jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiJobApplicantChatMarkSeen(applicantId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiJobApplicantChatMarkSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiJobMatchEmailDaily(jobId: string, days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobMatchEmailDailyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiJobMatchEmailDaily(jobId, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiJobMatchEmailDaily']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobApiJobMatchEmailPreflightAppliedActivityModeEnum} [appliedActivityMode] 
         * @param {number | null} [appliedInLastDays] 
         * @param {boolean | null} [exactOnly] 
         * @param {boolean | null} [hardExperience] 
         * @param {JobApiJobMatchEmailPreflightLoginActivityModeEnum} [loginActivityMode] 
         * @param {number | null} [loginInLastDays] 
         * @param {number | null} [maxExperience] 
         * @param {number | null} [minExperience] 
         * @param {boolean | null} [neverOpenedOnly] 
         * @param {boolean | null} [savedBand] 
         * @param {boolean | null} [studentsOnly] 
         * @param {boolean | null} [withCeilings] 
         * @param {boolean | null} [withSendable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiJobMatchEmailPreflight(jobId: string, appliedActivityMode?: JobApiJobMatchEmailPreflightAppliedActivityModeEnum, appliedInLastDays?: number | null, exactOnly?: boolean | null, hardExperience?: boolean | null, loginActivityMode?: JobApiJobMatchEmailPreflightLoginActivityModeEnum, loginInLastDays?: number | null, maxExperience?: number | null, minExperience?: number | null, neverOpenedOnly?: boolean | null, savedBand?: boolean | null, studentsOnly?: boolean | null, withCeilings?: boolean | null, withSendable?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobMatchEmailPreflightResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiJobMatchEmailPreflight(jobId, appliedActivityMode, appliedInLastDays, exactOnly, hardExperience, loginActivityMode, loginInLastDays, maxExperience, minExperience, neverOpenedOnly, savedBand, studentsOnly, withCeilings, withSendable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiJobMatchEmailPreflight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiJobMatchEmailReach(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobMatchEmailReachResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiJobMatchEmailReach(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiJobMatchEmailReach']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiJobMatchEmailStats(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobMatchEmailStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiJobMatchEmailStats(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiJobMatchEmailStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [degreeIds] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {string} [specializationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiJobSpecializationAutoComplete(degreeIds?: Array<string>, pageNo?: string, pageSize?: string, query?: string, specializationId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecializationAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiJobSpecializationAutoComplete(degreeIds, pageNo, pageSize, query, specializationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiJobSpecializationAutoComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number | null} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiListGovernorCandidates(limit?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GovernorCandidateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiListGovernorCandidates(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiListGovernorCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiListJobEvaluations(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobEvaluationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiListJobEvaluations(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiListJobEvaluations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiListOrgEvaluationQuestionSources(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvaluationQuestionSourcesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiListOrgEvaluationQuestionSources(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiListOrgEvaluationQuestionSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiListResumeBuilderAnalyses(resumeBuilderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeBuilderAnalysisListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiListResumeBuilderAnalyses(resumeBuilderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiListResumeBuilderAnalyses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiLocationCountryBackfillRoute(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationCountryBackfillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiLocationCountryBackfillRoute(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiLocationCountryBackfillRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiLocationCountryHealthRoute(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationCountryHealthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiLocationCountryHealthRoute(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiLocationCountryHealthRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiMarkJobAsNotInterested(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiMarkJobAsNotInterested(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiMarkJobAsNotInterested']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiMarkJobSkipped(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiMarkJobSkipped(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiMarkJobSkipped']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiMergeDuplicateCollegesCompanies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiMergeDuplicateCollegesCompanies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiMergeDuplicateCollegesCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiMigrateData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobMigrateFilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiMigrateData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiMigrateData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiMigrateDataCompany(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobMigrateFilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiMigrateDataCompany(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiMigrateDataCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiMigrateDataCompanyTask(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiMigrateDataCompanyTask(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiMigrateDataCompanyTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiMigrateDataTask(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiMigrateDataTask(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiMigrateDataTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiPopulateMissingApplicantMatchesForAllJobs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiPopulateMissingApplicantMatchesForAllJobs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiPopulateMissingApplicantMatchesForAllJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiPublicDegreeAutocomplete(pageNo?: number, pageSize?: number, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DegreeAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiPublicDegreeAutocomplete(pageNo, pageSize, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiPublicDegreeAutocomplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * count — the location twin of /skill-suggestions and /role-suggestions.  Unauthenticated on purpose: it reports nothing the browse facets and the sitemap don\'t already publish. Device type changes the counts (external jobs are hidden from the native app), so it is resolved here and passed in — the controller is memoized, so it has to be part of the cache key rather than read from the request inside.
         * @summary Places the location filter can be set to, each with its live-posting
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {JobApiPublicJobLocationSuggestionsWorkModeEnum} [workMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiPublicJobLocationSuggestions(pageSize?: number, searchQuery?: string | null, workMode?: JobApiPublicJobLocationSuggestionsWorkModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobLocationSuggestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiPublicJobLocationSuggestions(pageSize, searchQuery, workMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiPublicJobLocationSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiPublicJobRoleSuggestions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobRoleSuggestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiPublicJobRoleSuggestions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiPublicJobRoleSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiPublicJobSkillSuggestions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobSkillSuggestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiPublicJobSkillSuggestions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiPublicJobSkillSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiPublishJobCompetition(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiPublishJobCompetition(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiPublishJobCompetition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiReanalyzeApplicant(applicantId: string, jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReanalyzeApplicantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiReanalyzeApplicant(applicantId, jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiReanalyzeApplicant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReBuildJobMatchingProfiles} reBuildJobMatchingProfiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiRebuildMatchingProfiles(reBuildJobMatchingProfiles: ReBuildJobMatchingProfiles, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiRebuildMatchingProfiles(reBuildJobMatchingProfiles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiRebuildMatchingProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiRefreshBqFacetCachesApi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiRefreshBqFacetCachesApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiRefreshBqFacetCachesApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} jobId 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiRegenerateJobChallengeQuestion(competitionId: string, jobId: string, questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegenerateJobChallengeQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiRegenerateJobChallengeQuestion(competitionId, jobId, questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiRegenerateJobChallengeQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} userId 
         * @param {JobInviteRejectBody} jobInviteRejectBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiRejectJobInvitation(jobId: string, userId: string, jobInviteRejectBody: JobInviteRejectBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiRejectJobInvitation(jobId, userId, jobInviteRejectBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiRejectJobInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {UserResumeEntityList} userResumeEntityList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiRejectJobProfile(jobId: string, userResumeEntityList: UserResumeEntityList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiRejectJobProfile(jobId, userResumeEntityList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiRejectJobProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiRejectJobProfileByEmployer(jobId: string, orgId: string, profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiRejectJobProfileByEmployer(jobId, orgId, profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiRejectJobProfileByEmployer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {UserResumeEntityListRemainderCount} userResumeEntityListRemainderCount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiReminderEmailAllMatchingJobProfiles(jobId: string, userResumeEntityListRemainderCount: UserResumeEntityListRemainderCount, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiReminderEmailAllMatchingJobProfiles(jobId, userResumeEntityListRemainderCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiReminderEmailAllMatchingJobProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiRemoveExternalApplication(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiRemoveExternalApplication(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiRemoveExternalApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {GetFilteredApplicantUserIdsBody} getFilteredApplicantUserIdsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiRequestBulkAnalysis(jobId: string, orgId: string, getFilteredApplicantUserIdsBody: GetFilteredApplicantUserIdsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiRequestBulkAnalysis(jobId, orgId, getFilteredApplicantUserIdsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiRequestBulkAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisId 
         * @param {ResumeBuilderRestoreBody} resumeBuilderRestoreBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiRestoreResumeBuilderAnalysis(analysisId: string, resumeBuilderRestoreBody: ResumeBuilderRestoreBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeBuilderRestoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiRestoreResumeBuilderAnalysis(analysisId, resumeBuilderRestoreBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiRestoreResumeBuilderAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiResumePdfBuilder(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiResumePdfBuilder(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiResumePdfBuilder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReviewJobParam} reviewJobParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiReviewJobs(reviewJobParam: ReviewJobParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiReviewJobs(reviewJobParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiReviewJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RewriteSnippetBody} rewriteSnippetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiRewriteResumeSnippet(rewriteSnippetBody: RewriteSnippetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewriteSnippetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiRewriteResumeSnippet(rewriteSnippetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiRewriteResumeSnippet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {SendAssessmentMessageBody} sendAssessmentMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiSendAssessmentMessageToApplicants(jobId: string, orgId: string, sendAssessmentMessageBody: SendAssessmentMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiSendAssessmentMessageToApplicants(jobId, orgId, sendAssessmentMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiSendAssessmentMessageToApplicants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BqSendEmailsBody} bqSendEmailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiSendBqEmailsApi(bqSendEmailsBody: BqSendEmailsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobGetCandidatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiSendBqEmailsApi(bqSendEmailsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiSendBqEmailsApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobMatchEmailSendBody} jobMatchEmailSendBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiSendJobMatchEmails(jobId: string, jobMatchEmailSendBody: JobMatchEmailSendBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobMatchEmailSendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiSendJobMatchEmails(jobId, jobMatchEmailSendBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiSendJobMatchEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobMatchEmailTestBody} jobMatchEmailTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiSendJobMatchTestEmail(jobId: string, jobMatchEmailTestBody: JobMatchEmailTestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobMatchEmailTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiSendJobMatchTestEmail(jobId, jobMatchEmailTestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiSendJobMatchTestEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {Array<InsertAssessmentScoreBody>} insertAssessmentScoreBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiSetAssessmentResponseScore(applicantId: string, jobId: string, orgId: string, insertAssessmentScoreBody: Array<InsertAssessmentScoreBody>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsertAssessmentScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiSetAssessmentResponseScore(applicantId, jobId, orgId, insertAssessmentScoreBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiSetAssessmentResponseScore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {EvaluationStatusBody} evaluationStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiSetEvaluationStatus(evaluationId: string, jobId: string, orgId: string, evaluationStatusBody: EvaluationStatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEvaluationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiSetEvaluationStatus(evaluationId, jobId, orgId, evaluationStatusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiSetEvaluationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiSetupBqTablesApi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiSetupBqTablesApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiSetupBqTablesApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [degreeId] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {string} [specializationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiSpecializationAutoComplete(degreeId?: string | null, pageNo?: string, pageSize?: string, query?: string, specializationId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecializationAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiSpecializationAutoComplete(degreeId, pageNo, pageSize, query, specializationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiSpecializationAutoComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobEvaluationId 
         * @param {string} jobId 
         * @param {SubmitEvaluationAssignmentBody} submitEvaluationAssignmentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiSubmitEvaluationAssignment(jobEvaluationId: string, jobId: string, submitEvaluationAssignmentBody: SubmitEvaluationAssignmentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiSubmitEvaluationAssignment(jobEvaluationId, jobId, submitEvaluationAssignmentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiSubmitEvaluationAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {JobAssessmentSubmitBase} jobAssessmentSubmitBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiSubmitJobAssessment(jobId: string, jobAssessmentSubmitBase: JobAssessmentSubmitBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiSubmitJobAssessment(jobId, jobAssessmentSubmitBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiSubmitJobAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiTestSpotlightWhatsapp(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiTestSpotlightWhatsapp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiTestSpotlightWhatsapp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {number} [expectedCost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUnlockApplicantAiScores(jobId: string, orgId: string, expectedCost?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicantAiUnlockResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUnlockApplicantAiScores(jobId, orgId, expectedCost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUnlockApplicantAiScores']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUnlockDbAccess(jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DbAccessUnlockResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUnlockDbAccess(jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUnlockDbAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUnlockInviteProfile(jobId: string, orgId: string, profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnlockInviteProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUnlockInviteProfile(jobId, orgId, profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUnlockInviteProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} noteId 
         * @param {string} orgId 
         * @param {CreateApplicantNoteBody} createApplicantNoteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateApplicantNote(jobId: string, noteId: string, orgId: string, createApplicantNoteBody: CreateApplicantNoteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobNotesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateApplicantNote(jobId, noteId, orgId, createApplicantNoteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateApplicantNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} ratingValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateApplicantRating(applicantId: string, jobId: string, orgId: string, ratingValue: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicantRating>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateApplicantRating(applicantId, jobId, orgId, ratingValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateApplicantRating']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {string} fieldId 
         * @param {CreateAssessmentFieldBody} createAssessmentFieldBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateAssessmentField(assessmentId: string, fieldId: string, createAssessmentFieldBody: CreateAssessmentFieldBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateAssessmentField(assessmentId, fieldId, createAssessmentFieldBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateAssessmentField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assessmentResponseId 
         * @param {CreateAssessmentResponsedBody} createAssessmentResponsedBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateAssessmentResponse(assessmentResponseId: string, createAssessmentResponsedBody: CreateAssessmentResponsedBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateAssessmentResponse(assessmentResponseId, createAssessmentResponsedBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateAssessmentResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateDegreeBody} updateDegreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateDegree(updateDegreeBody: UpdateDegreeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDegreeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateDegree(updateDegreeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateDegree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {ExternalApplicationStatusBody} externalApplicationStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateExternalApplication(jobId: string, externalApplicationStatusBody: ExternalApplicationStatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalApplicationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateExternalApplication(jobId, externalApplicationStatusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateExternalApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {Array<UpdateFieldPositionBody>} updateFieldPositionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateFieldPosition(assessmentId: string, updateFieldPositionBody: Array<UpdateFieldPositionBody>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateFieldPosition(assessmentId, updateFieldPositionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateFieldPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {UpdateJobAnalysisStatusBody} updateJobAnalysisStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateGptJobAnalysisStatus(jobId: string, updateJobAnalysisStatusBody: UpdateJobAnalysisStatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateGptJobAnalysisStatus(jobId, updateJobAnalysisStatusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateGptJobAnalysisStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} applicantId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {UpdateHiringStatusBody} updateHiringStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateHiringStatus(applicantId: string, jobId: string, orgId: string, updateHiringStatusBody: UpdateHiringStatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobApplicantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateHiringStatus(applicantId, jobId, orgId, updateHiringStatusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateHiringStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {UpdateJobBody} updateJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateJob(jobId: string, orgId: string, updateJobBody: UpdateJobBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateJob(jobId, orgId, updateJobBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminUpdateJobBody} adminUpdateJobBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateJobAdmin(adminUpdateJobBody: AdminUpdateJobBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateJobAdmin(adminUpdateJobBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateJobAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} jobId 
         * @param {AddApplicantMessageBody} addApplicantMessageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateJobApplicantMsg(chatId: string, jobId: string, addApplicantMessageBody: AddApplicantMessageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddApplicantMsgResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateJobApplicantMsg(chatId, jobId, addApplicantMessageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateJobApplicantMsg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {Array<UpdateJobApplicantTagBody>} updateJobApplicantTagBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateJobApplicantTag(jobId: string, orgId: string, updateJobApplicantTagBody: Array<UpdateJobApplicantTagBody>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateJobApplicantTag(jobId, orgId, updateJobApplicantTagBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateJobApplicantTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} [bookmark] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateJobBookmark(jobId: string, bookmark?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateJobBookmark>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateJobBookmark(jobId, bookmark, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateJobBookmark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobEmailPreferenceUpdateBody} jobEmailPreferenceUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateJobEmailPreferences(jobEmailPreferenceUpdateBody: JobEmailPreferenceUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEmailPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateJobEmailPreferences(jobEmailPreferenceUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateJobEmailPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} evaluationId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {JobEvaluationBody} jobEvaluationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateJobEvaluation(evaluationId: string, jobId: string, orgId: string, jobEvaluationBody: JobEvaluationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEvaluationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateJobEvaluation(evaluationId, jobId, orgId, jobEvaluationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateJobEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateJobProfileSkillBuilderScores(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateJobProfileSkillBuilderScores(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateJobProfileSkillBuilderScores']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} chatReactionId 
         * @param {string} jobId 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateReactionMsg(chatId: string, chatReactionId: string, jobId: string, message: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddReactionMsgResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateReactionMsg(chatId, chatReactionId, jobId, message, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateReactionMsg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} resumeBuilderId 
         * @param {string} versionNo 
         * @param {UpdateResumeBuilderBody} updateResumeBuilderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateResumeBuilderDetails(resumeBuilderId: string, versionNo: string, updateResumeBuilderBody: UpdateResumeBuilderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResumeBuilderResponseById>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateResumeBuilderDetails(resumeBuilderId, versionNo, updateResumeBuilderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateResumeBuilderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpdateSkillBody} updateSkillBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateSkill(skillId: string, updateSkillBody: UpdateSkillBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSkillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateSkill(skillId, updateSkillBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateSpecializationBody} updateSpecializationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpdateSpecialization(updateSpecializationBody: UpdateSpecializationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSpecializationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpdateSpecialization(updateSpecializationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpdateSpecialization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertCandidateDetailsBody} upsertCandidateDetailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpsertCandidateMetaDetails(upsertCandidateDetailsBody: UpsertCandidateDetailsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertCandidateDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpsertCandidateMetaDetails(upsertCandidateDetailsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpsertCandidateMetaDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GovernorPlanBody} governorPlanBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiUpsertGovernorPlans(governorPlanBody: GovernorPlanBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GovernorPlanWriteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiUpsertGovernorPlans(governorPlanBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiUpsertGovernorPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobApiWithdrawJobApplication(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobApiWithdrawJobApplication(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobApiApi.jobApiWithdrawJobApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobApiApi - factory interface
 */
export const JobApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobApiApiFp(configuration)
    return {
        /**
         * 
         * @param {JobApiApiJobApiAddJobApplicantMsgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAddJobApplicantMsg(requestParameters: JobApiApiJobApiAddJobApplicantMsgRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddApplicantMsgResponse> {
            return localVarFp.jobApiAddJobApplicantMsg(requestParameters.jobId, requestParameters.addApplicantMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAddJobItemsToCartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAddJobItemsToCart(requestParameters: JobApiApiJobApiAddJobItemsToCartRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddItemToCartResponse> {
            return localVarFp.jobApiAddJobItemsToCart(requestParameters.orgId, requestParameters.bulkAddJobItemToCartBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAddJobProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAddJobProfile(requestParameters: JobApiApiJobApiAddJobProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiAddJobProfile(requestParameters.jobId, requestParameters.jobProfileMatchList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAddReactionMsgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAddReactionMsg(requestParameters: JobApiApiJobApiAddReactionMsgRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddReactionMsgResponse> {
            return localVarFp.jobApiAddReactionMsg(requestParameters.chatId, requestParameters.jobId, requestParameters.addReactionMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAddResumeBuilderDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAddResumeBuilderDetails(requestParameters: JobApiApiJobApiAddResumeBuilderDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetResumeBuilderResponseById> {
            return localVarFp.jobApiAddResumeBuilderDetails(requestParameters.resumeBuilderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAdminCreateJobApplicantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAdminCreateJobApplicant(requestParameters: JobApiApiJobApiAdminCreateJobApplicantRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiAdminCreateJobApplicant(requestParameters.jobId, requestParameters.adminJobApplyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAdminGetJobSkillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAdminGetJobSkills(requestParameters: JobApiApiJobApiAdminGetJobSkillsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetAllSkillsResponse> {
            return localVarFp.jobApiAdminGetJobSkills(requestParameters.name, requestParameters.pageNo, requestParameters.pageSize, requestParameters.showJobAssociatedSkills, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAdminReprocessStuckResumesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAdminReprocessStuckResumes(requestParameters: JobApiApiJobApiAdminReprocessStuckResumesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Message> {
            return localVarFp.jobApiAdminReprocessStuckResumes(requestParameters.reprocessStuckResumesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAdminWithdrawJobApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAdminWithdrawJobApplication(requestParameters: JobApiApiJobApiAdminWithdrawJobApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiAdminWithdrawJobApplication(requestParameters.jobId, requestParameters.iDMail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAiDraftAnalyzeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAiDraftAnalyze(requestParameters: JobApiApiJobApiAiDraftAnalyzeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIPromptAnalysisResponse> {
            return localVarFp.jobApiAiDraftAnalyze(requestParameters.orgId, requestParameters.aIPromptAnalysisBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAiDraftQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAiDraftQuestions(requestParameters: JobApiApiJobApiAiDraftQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIScreeningQuestionsResponse> {
            return localVarFp.jobApiAiDraftQuestions(requestParameters.orgId, requestParameters.aIScreeningQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAiDraftRegenerateJdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAiDraftRegenerateJd(requestParameters: JobApiApiJobApiAiDraftRegenerateJdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiAiDraftRegenerateJd(requestParameters.orgId, requestParameters.aIRegenerateJDBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAiDraftStreamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAiDraftStream(requestParameters: JobApiApiJobApiAiDraftStreamRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiAiDraftStream(requestParameters.orgId, requestParameters.aIDraftPromptBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAiDraftTranslateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAiDraftTranslate(requestParameters: JobApiApiJobApiAiDraftTranslateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AITranslateResponse> {
            return localVarFp.jobApiAiDraftTranslate(requestParameters.orgId, requestParameters.aITranslateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAnalyseIsolatedUserResumes(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiAnalyseIsolatedUserResumes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAnalyzeResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAnalyzeResume(requestParameters: JobApiApiJobApiAnalyzeResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeAnalysisResponse> {
            return localVarFp.jobApiAnalyzeResume(requestParameters.resumeBuilderId, requestParameters.versionNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAnalyzeResumeBuilderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAnalyzeResumeBuilder(requestParameters: JobApiApiJobApiAnalyzeResumeBuilderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeBuilderAnalysis> {
            return localVarFp.jobApiAnalyzeResumeBuilder(requestParameters.resumeBuilderId, requestParameters.versionNo, requestParameters.resumeBuilderAnalyseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAnalyzeResumeJobFitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAnalyzeResumeJobFit(requestParameters: JobApiApiJobApiAnalyzeResumeJobFitRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeJobFitAnalysisResponse> {
            return localVarFp.jobApiAnalyzeResumeJobFit(requestParameters.jobId, requestParameters.userResumeId, requestParameters.resumeJobFitAnalyseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiApplySpotlightBoostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiApplySpotlightBoost(requestParameters: JobApiApiJobApiApplySpotlightBoostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpotlightBoostResponse> {
            return localVarFp.jobApiApplySpotlightBoost(requestParameters.jobId, requestParameters.spotlightBoostBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiApplyWithJobFitResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiApplyWithJobFitResume(requestParameters: JobApiApiJobApiApplyWithJobFitResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeJobFitApplyResponse> {
            return localVarFp.jobApiApplyWithJobFitResume(requestParameters.jobId, requestParameters.userResumeId, requestParameters.resumeJobFitApplyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiAssociateJobWithCompetitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiAssociateJobWithCompetition(requestParameters: JobApiApiJobApiAssociateJobWithCompetitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiAssociateJobWithCompetition(requestParameters.competitionId, requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiBqAudienceCountApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBqAudienceCountApi(requestParameters: JobApiApiJobApiBqAudienceCountApiRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BqAudienceCountResponse> {
            return localVarFp.jobApiBqAudienceCountApi(requestParameters.categories, requestParameters.companies, requestParameters.countries, requestParameters.excludeCategories, requestParameters.excludeCompanies, requestParameters.excludeCountries, requestParameters.excludeLocationKeywords, requestParameters.excludePositionKeywords, requestParameters.excludeScrapers, requestParameters.excludeTags, requestParameters.excludeTitleKeywords, requestParameters.isEmailCorporate, requestParameters.locationKeywords, requestParameters.positionKeywords, requestParameters.scrapers, requestParameters.tags, requestParameters.titleKeywords, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiBqAudienceExportApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBqAudienceExportApi(requestParameters: JobApiApiJobApiBqAudienceExportApiRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiBqAudienceExportApi(requestParameters.categories, requestParameters.companies, requestParameters.countries, requestParameters.excludeCategories, requestParameters.excludeCompanies, requestParameters.excludeCountries, requestParameters.excludeLocationKeywords, requestParameters.excludePositionKeywords, requestParameters.excludeScrapers, requestParameters.excludeTags, requestParameters.excludeTitleKeywords, requestParameters.format, requestParameters.isEmailCorporate, requestParameters.limit, requestParameters.locationKeywords, requestParameters.offset, requestParameters.positionKeywords, requestParameters.scrapers, requestParameters.tags, requestParameters.titleKeywords, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiBqAutocompleteApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBqAutocompleteApi(requestParameters: JobApiApiJobApiBqAutocompleteApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<BqAutocompleteResponse> {
            return localVarFp.jobApiBqAutocompleteApi(requestParameters.field, requestParameters.categories, requestParameters.companies, requestParameters.countries, requestParameters.excludeCategories, requestParameters.excludeCompanies, requestParameters.excludeCountries, requestParameters.excludeLocationKeywords, requestParameters.excludePositionKeywords, requestParameters.excludeScrapers, requestParameters.excludeTags, requestParameters.excludeTitleKeywords, requestParameters.isEmailCorporate, requestParameters.locationKeywords, requestParameters.positionKeywords, requestParameters.q, requestParameters.scrapers, requestParameters.tags, requestParameters.titleKeywords, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiBulkActionOnApplicantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBulkActionOnApplicants(requestParameters: JobApiApiJobApiBulkActionOnApplicantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiBulkActionOnApplicants(requestParameters.jobId, requestParameters.orgId, requestParameters.bulkApplicantActionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiBulkAddJobApplicantMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBulkAddJobApplicantMessage(requestParameters: JobApiApiJobApiBulkAddJobApplicantMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiBulkAddJobApplicantMessage(requestParameters.jobId, requestParameters.orgId, requestParameters.bulkAddJobApplicantMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiBulkJobStatusUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiBulkJobStatusUpdate(requestParameters: JobApiApiJobApiBulkJobStatusUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiBulkJobStatusUpdate(requestParameters.bulkStatusUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCandidateOnboardingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCandidateOnboarding(requestParameters: JobApiApiJobApiCandidateOnboardingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiCandidateOnboarding(requestParameters.candidateBoardingBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCandidateShowcaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCandidateShowcase(requestParameters: JobApiApiJobApiCandidateShowcaseRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CandidateShowcaseResponse> {
            return localVarFp.jobApiCandidateShowcase(requestParameters.role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCheckDuplicateJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCheckDuplicateJob(requestParameters: JobApiApiJobApiCheckDuplicateJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckDuplicateJobResponse> {
            return localVarFp.jobApiCheckDuplicateJob(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCompleteJobProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCompleteJobProfile(requestParameters: JobApiApiJobApiCompleteJobProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobProfileResponse> {
            return localVarFp.jobApiCompleteJobProfile(requestParameters.jobProfileBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCopyEvaluationQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCopyEvaluationQuestions(requestParameters: JobApiApiJobApiCopyEvaluationQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiCopyEvaluationQuestions(requestParameters.evaluationId, requestParameters.jobId, requestParameters.orgId, requestParameters.copyEvaluationQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateApplicantNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateApplicantNote(requestParameters: JobApiApiJobApiCreateApplicantNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<JobNotesResponse>> {
            return localVarFp.jobApiCreateApplicantNote(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.createApplicantNoteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateAssessmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateAssessment(requestParameters: JobApiApiJobApiCreateAssessmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateAssessmentResponse> {
            return localVarFp.jobApiCreateAssessment(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateAssessmentDuplicateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateAssessmentDuplicate(requestParameters: JobApiApiJobApiCreateAssessmentDuplicateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAssessmentResponse>> {
            return localVarFp.jobApiCreateAssessmentDuplicate(requestParameters.createAssessmentDuplicateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateAssessmentFieldRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateAssessmentField(requestParameters: JobApiApiJobApiCreateAssessmentFieldRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentField> {
            return localVarFp.jobApiCreateAssessmentField(requestParameters.assessmentId, requestParameters.createAssessmentFieldBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateBulkJobsApplicantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateBulkJobsApplicants(requestParameters: JobApiApiJobApiCreateBulkJobsApplicantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkJobApplyResponse> {
            return localVarFp.jobApiCreateBulkJobsApplicants(requestParameters.bulkJobApplyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateCompanyXml(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiCreateCompanyXml(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateDegreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateDegree(requestParameters: JobApiApiJobApiCreateDegreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateDegreeResponse> {
            return localVarFp.jobApiCreateDegree(requestParameters.createDegreeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJob(requestParameters: JobApiApiJobApiCreateJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobResponse> {
            return localVarFp.jobApiCreateJob(requestParameters.orgId, requestParameters.createJobBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateJobApplicantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobApplicants(requestParameters: JobApiApiJobApiCreateJobApplicantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobApplicantResponse> {
            return localVarFp.jobApiCreateJobApplicants(requestParameters.jobId, requestParameters.jobApplyAssessmentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateJobCandidateCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobCandidateCsv(requestParameters: JobApiApiJobApiCreateJobCandidateCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiCreateJobCandidateCsv(requestParameters.jobId, requestParameters.orgId, requestParameters.getFilteredApplicantUserIdsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateJobEvaluationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobEvaluation(requestParameters: JobApiApiJobApiCreateJobEvaluationRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobEvaluationResponse> {
            return localVarFp.jobApiCreateJobEvaluation(requestParameters.jobId, requestParameters.orgId, requestParameters.jobEvaluationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobLocationXml(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiCreateJobLocationXml(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateJobReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobReport(requestParameters: JobApiApiJobApiCreateJobReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiCreateJobReport(requestParameters.jobReportBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobRoleXml(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiCreateJobRoleXml(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateJobsXml(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiCreateJobsXml(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateSitemapOfSitemapsXml(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiCreateSitemapOfSitemapsXml(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateSkillBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateSkillBulk(requestParameters: JobApiApiJobApiCreateSkillBulkRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiCreateSkillBulk(requestParameters.createSkillBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiCreateSpecializationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiCreateSpecialization(requestParameters: JobApiApiJobApiCreateSpecializationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateSpecializationResponse> {
            return localVarFp.jobApiCreateSpecialization(requestParameters.createSpecializationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDegreeAutoCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDegreeAutoComplete(requestParameters: JobApiApiJobApiDegreeAutoCompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DegreeAutocompleteResponse> {
            return localVarFp.jobApiDegreeAutoComplete(requestParameters.degreeId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteApplicantNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteApplicantNote(requestParameters: JobApiApiJobApiDeleteApplicantNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<JobNotesResponse>> {
            return localVarFp.jobApiDeleteApplicantNote(requestParameters.jobId, requestParameters.noteId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteAssessmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteAssessment(requestParameters: JobApiApiJobApiDeleteAssessmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteAssessment(requestParameters.assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteAssessmentFieldRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteAssessmentField(requestParameters: JobApiApiJobApiDeleteAssessmentFieldRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteAssessmentField(requestParameters.assessmentId, requestParameters.fieldId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteAssessmentResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteAssessmentResponse(requestParameters: JobApiApiJobApiDeleteAssessmentResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteAssessmentResponse(requestParameters.assessmentId, requestParameters.responseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteDegreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteDegree(requestParameters: JobApiApiJobApiDeleteDegreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteDegree(requestParameters.degreeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteJob(requestParameters: JobApiApiJobApiDeleteJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteJob(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteJobApplicantMsgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteJobApplicantMsg(requestParameters: JobApiApiJobApiDeleteJobApplicantMsgRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteJobApplicantMsg(requestParameters.chatId, requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteJobCompletelyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteJobCompletely(requestParameters: JobApiApiJobApiDeleteJobCompletelyRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteJobCompletelyResponse> {
            return localVarFp.jobApiDeleteJobCompletely(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteReactionMsgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteReactionMsg(requestParameters: JobApiApiJobApiDeleteReactionMsgRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteReactionMsg(requestParameters.chatId, requestParameters.chatReactionId, requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteResumeBuilderDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteResumeBuilderDetails(requestParameters: JobApiApiJobApiDeleteResumeBuilderDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteResumeBuilderDetails(requestParameters.resumeBuilderId, requestParameters.versionNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteResumeJobApplicantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteResumeJobApplicant(requestParameters: JobApiApiJobApiDeleteResumeJobApplicantRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteResumeJobApplicant(requestParameters.jobId, requestParameters.orgId, requestParameters.deleteJobApplicantBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteSkillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteSkill(requestParameters: JobApiApiJobApiDeleteSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteSkill(requestParameters.iDList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteSpecializationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteSpecialization(requestParameters: JobApiApiJobApiDeleteSpecializationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteSpecialization(requestParameters.specializationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDeleteUserSkillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDeleteUserSkill(requestParameters: JobApiApiJobApiDeleteUserSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDeleteUserSkill(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDisableAutoJobApply(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiDisableAutoJobApply(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDownloadJobProfileMatchByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDownloadJobProfileMatchById(requestParameters: JobApiApiJobApiDownloadJobProfileMatchByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiDownloadJobProfileMatchById(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiDownloadResumeJobFitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiDownloadResumeJobFit(requestParameters: JobApiApiJobApiDownloadResumeJobFitRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiDownloadResumeJobFit(requestParameters.jobId, requestParameters.userResumeId, requestParameters.resumeJobFitDownloadBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiEmailAllMatchingJobProfilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiEmailAllMatchingJobProfiles(requestParameters: JobApiApiJobApiEmailAllMatchingJobProfilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiEmailAllMatchingJobProfiles(requestParameters.jobId, requestParameters.userResumeEntityList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiEmployerBulkJobStatusUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiEmployerBulkJobStatusUpdate(requestParameters: JobApiApiJobApiEmployerBulkJobStatusUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiEmployerBulkJobStatusUpdate(requestParameters.orgId, requestParameters.employerBulkStatusUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiEnableAutoJobApply(options?: RawAxiosRequestConfig): AxiosPromise<EnableAutoJobApplyResponse> {
            return localVarFp.jobApiEnableAutoJobApply(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiEnhanceResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiEnhanceResume(requestParameters: JobApiApiJobApiEnhanceResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiEnhanceResume(requestParameters.resumeBuilderId, requestParameters.versionNo, requestParameters.enhanceResumeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiEnhanceResumeJobFitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiEnhanceResumeJobFit(requestParameters: JobApiApiJobApiEnhanceResumeJobFitRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiEnhanceResumeJobFit(requestParameters.jobId, requestParameters.userResumeId, requestParameters.resumeJobFitEnhanceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiExternalApplyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiExternalApply(requestParameters: JobApiApiJobApiExternalApplyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalApplicationResponse> {
            return localVarFp.jobApiExternalApply(requestParameters.jobId, requestParameters.externalApplyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiExternalClickRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiExternalClick(requestParameters: JobApiApiJobApiExternalClickRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiExternalClick(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiFixJobFormattingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiFixJobFormatting(requestParameters: JobApiApiJobApiFixJobFormattingRequest, options?: RawAxiosRequestConfig): AxiosPromise<FixJobFormattingResponse> {
            return localVarFp.jobApiFixJobFormatting(requestParameters.fixJobFormattingBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGenerateAndAssociateJobChallengeQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGenerateAndAssociateJobChallengeQuestions(requestParameters: JobApiApiJobApiGenerateAndAssociateJobChallengeQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiGenerateAndAssociateJobChallengeQuestions(requestParameters.competitionId, requestParameters.jobId, requestParameters.generateAndAssociateJobChallengeQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGenerateQuestionsAndCreateJobCompetitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGenerateQuestionsAndCreateJobCompetition(requestParameters: JobApiApiJobApiGenerateQuestionsAndCreateJobCompetitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiGenerateQuestionsAndCreateJobCompetition(requestParameters.jobId, requestParameters.generateQuestionsAndCreateJobCompetitionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGenerateRecruiterMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGenerateRecruiterMessage(requestParameters: JobApiApiJobApiGenerateRecruiterMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiGenerateRecruiterMessage(requestParameters.jobId, requestParameters.generateRecruiterMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetActivityTypeCountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetActivityTypeCounts(requestParameters: JobApiApiJobApiGetActivityTypeCountsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetActivityTypeCountsResponse> {
            return localVarFp.jobApiGetActivityTypeCounts(requestParameters.days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAiDraftPayloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAiDraftPayload(requestParameters: JobApiApiJobApiGetAiDraftPayloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIDraftPayloadResponse> {
            return localVarFp.jobApiGetAiDraftPayload(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAiDraftedJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAiDraftedJobs(requestParameters: JobApiApiJobApiGetAiDraftedJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIDraftedJobsResponse> {
            return localVarFp.jobApiGetAiDraftedJobs(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAllActiveJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAllActiveJobs(requestParameters: JobApiApiJobApiGetAllActiveJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveJobsResponse> {
            return localVarFp.jobApiGetAllActiveJobs(requestParameters.activeJobBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAllActiveJobsPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAllActiveJobsPublic(requestParameters: JobApiApiJobApiGetAllActiveJobsPublicRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveJobsResponse> {
            return localVarFp.jobApiGetAllActiveJobsPublic(requestParameters.activeJobBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAllAppliedJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAllAppliedJobs(requestParameters: JobApiApiJobApiGetAllAppliedJobsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAppliedJobResponse> {
            return localVarFp.jobApiGetAllAppliedJobs(requestParameters.hiringStatus, requestParameters.page, requestParameters.pageSize, requestParameters.skillIds, requestParameters.status, requestParameters.userSearchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAndMarkJobProfileDownloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAndMarkJobProfileDownload(requestParameters: JobApiApiJobApiGetAndMarkJobProfileDownloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobProfileResponse> {
            return localVarFp.jobApiGetAndMarkJobProfileDownload(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, requestParameters.showContacts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetApplicantAiAccessStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantAiAccessStatus(requestParameters: JobApiApiJobApiGetApplicantAiAccessStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplicantAiAccessStatusResponse> {
            return localVarFp.jobApiGetApplicantAiAccessStatus(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetApplicantLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantLocation(requestParameters: JobApiApiJobApiGetApplicantLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobApplicantLocationResponse> {
            return localVarFp.jobApiGetApplicantLocation(requestParameters.jobId, requestParameters.orgId, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetApplicantResumeAnalysisByUserIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantResumeAnalysisByUserId(requestParameters: JobApiApiJobApiGetApplicantResumeAnalysisByUserIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobResumeAnalysis> {
            return localVarFp.jobApiGetApplicantResumeAnalysisByUserId(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetApplicantSkillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantSkills(requestParameters: JobApiApiJobApiGetApplicantSkillsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplicantsJobRoleAutocompleteResponse> {
            return localVarFp.jobApiGetApplicantSkills(requestParameters.jobId, requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetApplicantTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantTags(requestParameters: JobApiApiJobApiGetApplicantTagsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobApplicantTagResponse> {
            return localVarFp.jobApiGetApplicantTags(requestParameters.jobId, requestParameters.orgId, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetApplicantsDetailsByPageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetApplicantsDetailsByPage(requestParameters: JobApiApiJobApiGetApplicantsDetailsByPageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplicantDetailsPage> {
            return localVarFp.jobApiGetApplicantsDetailsByPage(requestParameters.jobId, requestParameters.orgId, requestParameters.applicantStatus, requestParameters.applicantTag, requestParameters.assessmentScreening, requestParameters.collegeIds, requestParameters.collegeTier, requestParameters.competitionData, requestParameters.countOnly, requestParameters.endDate, requestParameters.isApplicantSeen, requestParameters.isChatStarted, requestParameters.jobPreference, requestParameters.jobRoleIds, requestParameters.matchingBranch, requestParameters.matchingDegree, requestParameters.matchingLocations, requestParameters.matchingSkills, requestParameters.maxAssessmentScore, requestParameters.maxCurrentCtc, requestParameters.maxEducation, requestParameters.maxExperience, requestParameters.maxGrade, requestParameters.maxPassingYear, requestParameters.maxPercentile, requestParameters.maxRating, requestParameters.maxResumeAnalysisExperienceScore, requestParameters.maxResumeAnalysisOverallScore, requestParameters.maxResumeAnalysisSkillScore, requestParameters.maxWorkExperienceMonths, requestParameters.minAssessmentScore, requestParameters.minCurrentCtc, requestParameters.minEducation, requestParameters.minExperience, requestParameters.minGrade, requestParameters.minPassingYear, requestParameters.minPercentile, requestParameters.minRating, requestParameters.minReleventResumeExperienceMonths, requestParameters.minResumeAnalysisExperienceScore, requestParameters.minResumeAnalysisOverallScore, requestParameters.minResumeAnalysisSkillScore, requestParameters.minWorkExperienceMonths, requestParameters.missingSkills, requestParameters.noticePeriod, requestParameters.page, requestParameters.pageSize, requestParameters.requiredSkills, requestParameters.resumeUploaded, requestParameters.sortBy, requestParameters.sortByCompetitionData, requestParameters.sortOrder, requestParameters.startDate, requestParameters.userSearchQuery, requestParameters.usernames, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAppliedJobPopupDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAppliedJobPopupData(requestParameters: JobApiApiJobApiGetAppliedJobPopupDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<PopupDataResponseSub> {
            return localVarFp.jobApiGetAppliedJobPopupData(requestParameters.appliedJobPopupDataBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAppliedJobsSummary(options?: RawAxiosRequestConfig): AxiosPromise<AppliedJobsSummaryResponse> {
            return localVarFp.jobApiGetAppliedJobsSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAssessmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAssessment(requestParameters: JobApiApiJobApiGetAssessmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAssessmentResponse>> {
            return localVarFp.jobApiGetAssessment(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAssessmentFieldsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAssessmentFields(requestParameters: JobApiApiJobApiGetAssessmentFieldsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssessmentField>> {
            return localVarFp.jobApiGetAssessmentFields(requestParameters.assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAutocompleteCollegeApplicantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAutocompleteCollegeApplicants(requestParameters: JobApiApiJobApiGetAutocompleteCollegeApplicantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplicantsJobRoleAutocompleteResponse> {
            return localVarFp.jobApiGetAutocompleteCollegeApplicants(requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetAutocompleteJobRoleApplicantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetAutocompleteJobRoleApplicants(requestParameters: JobApiApiJobApiGetAutocompleteJobRoleApplicantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplicantsJobRoleAutocompleteResponse> {
            return localVarFp.jobApiGetAutocompleteJobRoleApplicants(requestParameters.jobId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetBestJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetBestJobs(requestParameters: JobApiApiJobApiGetBestJobsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<BestJobResponse> {
            return localVarFp.jobApiGetBestJobs(requestParameters.count, requestParameters.days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetBqCandidatesApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetBqCandidatesApi(requestParameters: JobApiApiJobApiGetBqCandidatesApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobGetCandidatesResponse> {
            return localVarFp.jobApiGetBqCandidatesApi(requestParameters.jobGetCandidatesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetBqCompaniesApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetBqCompaniesApi(requestParameters: JobApiApiJobApiGetBqCompaniesApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobGetCandidatesResponse> {
            return localVarFp.jobApiGetBqCompaniesApi(requestParameters.jobGetCandidatesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetBqFilterOptionsApi(options?: RawAxiosRequestConfig): AxiosPromise<BqFilterOptionsResponse> {
            return localVarFp.jobApiGetBqFilterOptionsApi(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetCandidateEvaluationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetCandidateEvaluation(requestParameters: JobApiApiJobApiGetCandidateEvaluationRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobEvaluationResponse> {
            return localVarFp.jobApiGetCandidateEvaluation(requestParameters.evaluationId, requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetCandidateMetaDetails(options?: RawAxiosRequestConfig): AxiosPromise<CandidateMetaDetails> {
            return localVarFp.jobApiGetCandidateMetaDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetChatUsersForApplicantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetChatUsersForApplicant(requestParameters: JobApiApiJobApiGetChatUsersForApplicantRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ChatForApplicant> {
            return localVarFp.jobApiGetChatUsersForApplicant(requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetChatUsersForEmployerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetChatUsersForEmployer(requestParameters: JobApiApiJobApiGetChatUsersForEmployerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatForEmployers> {
            return localVarFp.jobApiGetChatUsersForEmployer(requestParameters.jobId, requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetCompanyJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetCompanyJobs(requestParameters: JobApiApiJobApiGetCompanyJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveJobsResponse> {
            return localVarFp.jobApiGetCompanyJobs(requestParameters.companyAlias, requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetCompanyStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetCompanyStatistics(requestParameters: JobApiApiJobApiGetCompanyStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicCompanyStatisticsResponse> {
            return localVarFp.jobApiGetCompanyStatistics(requestParameters.companyAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetDbAccessStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetDbAccessStatus(requestParameters: JobApiApiJobApiGetDbAccessStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<DbAccessStatusResponse> {
            return localVarFp.jobApiGetDbAccessStatus(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetDegreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetDegree(requestParameters: JobApiApiJobApiGetDegreeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetDegreesResponse> {
            return localVarFp.jobApiGetDegree(requestParameters.approvalStatus, requestParameters.degreeId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.userSearchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobApplicantMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobApplicantMessage(requestParameters: JobApiApiJobApiGetJobApplicantMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetApplicantChatResponse> {
            return localVarFp.jobApiGetJobApplicantMessage(requestParameters.applicantId, requestParameters.jobId, requestParameters.cursor, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobApplicantsDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobApplicantsDetails(requestParameters: JobApiApiJobApiGetJobApplicantsDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplicantDetails> {
            return localVarFp.jobApiGetJobApplicantsDetails(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobApplicantsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobApplicantsList(requestParameters: JobApiApiJobApiGetJobApplicantsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<AllJobApplicantResponse> {
            return localVarFp.jobApiGetJobApplicantsList(requestParameters.jobId, requestParameters.orgId, requestParameters.applicantListParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobApplicantsMetaDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobApplicantsMetaData(requestParameters: JobApiApiJobApiGetJobApplicantsMetaDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobApplicantsMetaDataResponse> {
            return localVarFp.jobApiGetJobApplicantsMetaData(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobById(requestParameters: JobApiApiJobApiGetJobByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobByIdResponse> {
            return localVarFp.jobApiGetJobById(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobByIdForAppliedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobByIdForApplied(requestParameters: JobApiApiJobApiGetJobByIdForAppliedRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobByIdChandidate> {
            return localVarFp.jobApiGetJobByIdForApplied(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobByIdForCandidateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobByIdForCandidate(requestParameters: JobApiApiJobApiGetJobByIdForCandidateRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobByIdChandidate> {
            return localVarFp.jobApiGetJobByIdForCandidate(requestParameters.jobId, requestParameters.isSkillPopupRequired, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobByIdForCandidatePublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobByIdForCandidatePublic(requestParameters: JobApiApiJobApiGetJobByIdForCandidatePublicRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobByIdChandidateBase> {
            return localVarFp.jobApiGetJobByIdForCandidatePublic(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobByIdForEmployerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobByIdForEmployer(requestParameters: JobApiApiJobApiGetJobByIdForEmployerRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobByIdEmployer> {
            return localVarFp.jobApiGetJobByIdForEmployer(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobByIdSlimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobByIdSlim(requestParameters: JobApiApiJobApiGetJobByIdSlimRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobByIdSlim> {
            return localVarFp.jobApiGetJobByIdSlim(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobCandidateJourneyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobCandidateJourney(requestParameters: JobApiApiJobApiGetJobCandidateJourneyRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCandidateJourneyResponse> {
            return localVarFp.jobApiGetJobCandidateJourney(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobCompetitionAnsweredQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobCompetitionAnsweredQuestions(requestParameters: JobApiApiJobApiGetJobCompetitionAnsweredQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AnsweredQuestionResponse> {
            return localVarFp.jobApiGetJobCompetitionAnsweredQuestions(requestParameters.applicantUserId, requestParameters.competitionId, requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobCompetitionStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobCompetitionStatistics(requestParameters: JobApiApiJobApiGetJobCompetitionStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionStatistics> {
            return localVarFp.jobApiGetJobCompetitionStatistics(requestParameters.competitionId, requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobEmailPreferences(options?: RawAxiosRequestConfig): AxiosPromise<JobEmailPreferencesResponse> {
            return localVarFp.jobApiGetJobEmailPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobEvaluationCandidatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobEvaluationCandidates(requestParameters: JobApiApiJobApiGetJobEvaluationCandidatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobEvaluationCandidatesResponse> {
            return localVarFp.jobApiGetJobEvaluationCandidates(requestParameters.evaluationId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobEvaluationDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobEvaluationDetail(requestParameters: JobApiApiJobApiGetJobEvaluationDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobEvaluationResponse> {
            return localVarFp.jobApiGetJobEvaluationDetail(requestParameters.evaluationId, requestParameters.jobId, requestParameters.orgId, requestParameters.ensureCompetition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobMatchingEntitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobMatchingEntities(requestParameters: JobApiApiJobApiGetJobMatchingEntitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<MatchingProfilesResumeEntityResponse> {
            return localVarFp.jobApiGetJobMatchingEntities(requestParameters.jobId, requestParameters.autoApplyEnabled, requestParameters.endDate, requestParameters.hasApplied, requestParameters.jobRoleList, requestParameters.maxExperience, requestParameters.minExperience, requestParameters.notified, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.skillIds, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobMatchingUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobMatchingUsers(requestParameters: JobApiApiJobApiGetJobMatchingUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<MatchingProfilesUserResponse> {
            return localVarFp.jobApiGetJobMatchingUsers(requestParameters.jobId, requestParameters.autoApplyEnabled, requestParameters.endDate, requestParameters.hasApplied, requestParameters.jobRoleList, requestParameters.maxExperience, requestParameters.minExperience, requestParameters.notified, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.skillIds, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobPostedListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobPostedList(requestParameters: JobApiApiJobApiGetJobPostedListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<JobPostedResponse> {
            return localVarFp.jobApiGetJobPostedList(requestParameters.isArchieved, requestParameters.isCompetitive, requestParameters.isGptJob, requestParameters.jobStatus, requestParameters.orgId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.planTypeList, requestParameters.productType, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobProfileMatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobProfileMatch(requestParameters: JobApiApiJobApiGetJobProfileMatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileMatchResponse> {
            return localVarFp.jobApiGetJobProfileMatch(requestParameters.jobId, requestParameters.orgId, requestParameters.profileMatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobProfileMatchByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobProfileMatchById(requestParameters: JobApiApiJobApiGetJobProfileMatchByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobProfileResponse> {
            return localVarFp.jobApiGetJobProfileMatchById(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, requestParameters.showContacts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobProfileMilestone(options?: RawAxiosRequestConfig): AxiosPromise<JobProfileMilestone> {
            return localVarFp.jobApiGetJobProfileMilestone(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobRelatedMocktestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobRelatedMocktests(requestParameters: JobApiApiJobApiGetJobRelatedMocktestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetRelatedMockTestResponse> {
            return localVarFp.jobApiGetJobRelatedMocktests(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobReportsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobReports(requestParameters: JobApiApiJobApiGetJobReportsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobReportsResponse> {
            return localVarFp.jobApiGetJobReports(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobRoleSkillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobRoleSkills(requestParameters: JobApiApiJobApiGetJobRoleSkillsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillsListResponse> {
            return localVarFp.jobApiGetJobRoleSkills(requestParameters.jobRoleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobRoleSuggestions(options?: RawAxiosRequestConfig): AxiosPromise<JobRoleSuggestionsResponse> {
            return localVarFp.jobApiGetJobRoleSuggestions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobSkillSuggestions(options?: RawAxiosRequestConfig): AxiosPromise<JobSkillSuggestionsResponse> {
            return localVarFp.jobApiGetJobSkillSuggestions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobSkillsAutocompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobSkillsAutocomplete(requestParameters: JobApiApiJobApiGetJobSkillsAutocompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetJobRoleSkillsResponse> {
            return localVarFp.jobApiGetJobSkillsAutocomplete(requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.searchType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobStatistics(requestParameters: JobApiApiJobApiGetJobStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllJobStatisticsResponse> {
            return localVarFp.jobApiGetJobStatistics(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobSummary(requestParameters: JobApiApiJobApiGetJobSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllJobSummaryResponse> {
            return localVarFp.jobApiGetJobSummary(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobUnreadMessageCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobUnreadMessageCount(requestParameters: JobApiApiJobApiGetJobUnreadMessageCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobMessageUnreadCountResponse> {
            return localVarFp.jobApiGetJobUnreadMessageCount(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobsGoogleAdsMetadataCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobsGoogleAdsMetadataCsv(requestParameters: JobApiApiJobApiGetJobsGoogleAdsMetadataCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiGetJobsGoogleAdsMetadataCsv(requestParameters.getOrgCsvParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobsGroupPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobsGroupPublic(requestParameters: JobApiApiJobApiGetJobsGroupPublicRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetJobGroupResponse> {
            return localVarFp.jobApiGetJobsGroupPublic(requestParameters.jobRoleIds, requestParameters.locationName, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetJobsLocationsPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetJobsLocationsPublic(requestParameters: JobApiApiJobApiGetJobsLocationsPublicRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetlocationListResponse> {
            return localVarFp.jobApiGetJobsLocationsPublic(requestParameters.jobRoleIds, requestParameters.locationName, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetLatestResumeJobFitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetLatestResumeJobFit(requestParameters: JobApiApiJobApiGetLatestResumeJobFitRequest, options?: RawAxiosRequestConfig): AxiosPromise<LatestResumeJobFitResponse> {
            return localVarFp.jobApiGetLatestResumeJobFit(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetMatchingJobsDeckRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetMatchingJobsDeck(requestParameters: JobApiApiJobApiGetMatchingJobsDeckRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MatchingJobsResponse> {
            return localVarFp.jobApiGetMatchingJobsDeck(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetOrgApplicantChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetOrgApplicantChats(requestParameters: JobApiApiJobApiGetOrgApplicantChatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrgApplicantChats> {
            return localVarFp.jobApiGetOrgApplicantChats(requestParameters.orgId, requestParameters.jobRoleId, requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetOrgChatJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetOrgChatJobs(requestParameters: JobApiApiJobApiGetOrgChatJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrgChatJobs> {
            return localVarFp.jobApiGetOrgChatJobs(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetOrgJobIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetOrgJobIds(requestParameters: JobApiApiJobApiGetOrgJobIdsRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrgJobID> {
            return localVarFp.jobApiGetOrgJobIds(requestParameters.jobAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetPublicCompanyJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetPublicCompanyJobs(requestParameters: JobApiApiJobApiGetPublicCompanyJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveJobsResponse> {
            return localVarFp.jobApiGetPublicCompanyJobs(requestParameters.companyAlias, requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetPublicCompanyStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetPublicCompanyStatistics(requestParameters: JobApiApiJobApiGetPublicCompanyStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicCompanyStatisticsResponse> {
            return localVarFp.jobApiGetPublicCompanyStatistics(requestParameters.companyAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetRecruiterEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetRecruiterEmail(requestParameters: JobApiApiJobApiGetRecruiterEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetRecruiterEmailResponse> {
            return localVarFp.jobApiGetRecruiterEmail(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetResumeBuilderAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeBuilderAnalysis(requestParameters: JobApiApiJobApiGetResumeBuilderAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeBuilderAnalysis> {
            return localVarFp.jobApiGetResumeBuilderAnalysis(requestParameters.analysisId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeBuilderData(options?: RawAxiosRequestConfig): AxiosPromise<GetResumeBuilderResponse> {
            return localVarFp.jobApiGetResumeBuilderData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetResumeBuilderDataByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeBuilderDataById(requestParameters: JobApiApiJobApiGetResumeBuilderDataByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetResumeBuilderResponseById> {
            return localVarFp.jobApiGetResumeBuilderDataById(requestParameters.resumeBuilderId, requestParameters.versionNo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetResumeBuilderVersionsByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeBuilderVersionsById(requestParameters: JobApiApiJobApiGetResumeBuilderVersionsByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetResumeBuilderVersionsResponse> {
            return localVarFp.jobApiGetResumeBuilderVersionsById(requestParameters.resumeBuilderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetResumeJobFitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeJobFit(requestParameters: JobApiApiJobApiGetResumeJobFitRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeJobFitAnalysisResponse> {
            return localVarFp.jobApiGetResumeJobFit(requestParameters.jobId, requestParameters.userResumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetResumeJobFitQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetResumeJobFitQuestions(requestParameters: JobApiApiJobApiGetResumeJobFitQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeJobFitQuestionsResponse> {
            return localVarFp.jobApiGetResumeJobFitQuestions(requestParameters.jobId, requestParameters.userResumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetScreeningInsightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetScreeningInsights(requestParameters: JobApiApiJobApiGetScreeningInsightsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScreeningInsightsResponse> {
            return localVarFp.jobApiGetScreeningInsights(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetSimilarJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetSimilarJobs(requestParameters: JobApiApiJobApiGetSimilarJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSimilarJobsResponse> {
            return localVarFp.jobApiGetSimilarJobs(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetSitemapUrls(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiGetSitemapUrls(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetSpecializationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetSpecialization(requestParameters: JobApiApiJobApiGetSpecializationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetSpecializationsResponse> {
            return localVarFp.jobApiGetSpecialization(requestParameters.approvalStatus, requestParameters.degreeId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.specializationId, requestParameters.userSearchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetSpotlightOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetSpotlightOptions(requestParameters: JobApiApiJobApiGetSpotlightOptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpotlightOptionsResponse> {
            return localVarFp.jobApiGetSpotlightOptions(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetSystemActivityLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetSystemActivityLogs(requestParameters: JobApiApiJobApiGetSystemActivityLogsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetActivityResponse> {
            return localVarFp.jobApiGetSystemActivityLogs(requestParameters.activityTypeList, requestParameters.applicantId, requestParameters.jobIds, requestParameters.maxDate, requestParameters.minDate, requestParameters.orgIds, requestParameters.pageNo, requestParameters.pageSize, requestParameters.userId, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetUserActivityLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetUserActivityLogs(requestParameters: JobApiApiJobApiGetUserActivityLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActivityResponse> {
            return localVarFp.jobApiGetUserActivityLogs(requestParameters.orgId, requestParameters.activityType, requestParameters.applicantId, requestParameters.jobId, requestParameters.maxDate, requestParameters.minDate, requestParameters.pageNo, requestParameters.pageSize, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetUserActivityLogsDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetUserActivityLogsDetails(requestParameters: JobApiApiJobApiGetUserActivityLogsDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActivityDetailsResponse> {
            return localVarFp.jobApiGetUserActivityLogsDetails(requestParameters.activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiGetUserSkillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGetUserSkill(requestParameters: JobApiApiJobApiGetUserSkillRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetUserSkillResponse> {
            return localVarFp.jobApiGetUserSkill(requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiGovernorDryRun(options?: RawAxiosRequestConfig): AxiosPromise<GovernorRunResponse> {
            return localVarFp.jobApiGovernorDryRun(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiHighlightJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiHighlightJob(requestParameters: JobApiApiJobApiHighlightJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiHighlightJob(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiInitialiseJobData(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiInitialiseJobData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiInitialiseJobDataCompany(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiInitialiseJobDataCompany(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiInitiateJobApplicationPreAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiInitiateJobApplicationPreAnalysis(requestParameters: JobApiApiJobApiInitiateJobApplicationPreAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiInitiateJobApplicationPreAnalysis(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiInviteUsersJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiInviteUsersJob(requestParameters: JobApiApiJobApiInviteUsersJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobInvitationResponse> {
            return localVarFp.jobApiInviteUsersJob(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, requestParameters.jobInvitationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiJobApplicantChatMarkSeenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobApplicantChatMarkSeen(requestParameters: JobApiApiJobApiJobApplicantChatMarkSeenRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiJobApplicantChatMarkSeen(requestParameters.applicantId, requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiJobMatchEmailDailyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobMatchEmailDaily(requestParameters: JobApiApiJobApiJobMatchEmailDailyRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobMatchEmailDailyResponse> {
            return localVarFp.jobApiJobMatchEmailDaily(requestParameters.jobId, requestParameters.days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiJobMatchEmailPreflightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobMatchEmailPreflight(requestParameters: JobApiApiJobApiJobMatchEmailPreflightRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobMatchEmailPreflightResponse> {
            return localVarFp.jobApiJobMatchEmailPreflight(requestParameters.jobId, requestParameters.appliedActivityMode, requestParameters.appliedInLastDays, requestParameters.exactOnly, requestParameters.hardExperience, requestParameters.loginActivityMode, requestParameters.loginInLastDays, requestParameters.maxExperience, requestParameters.minExperience, requestParameters.neverOpenedOnly, requestParameters.savedBand, requestParameters.studentsOnly, requestParameters.withCeilings, requestParameters.withSendable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiJobMatchEmailReachRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobMatchEmailReach(requestParameters: JobApiApiJobApiJobMatchEmailReachRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobMatchEmailReachResponse> {
            return localVarFp.jobApiJobMatchEmailReach(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiJobMatchEmailStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobMatchEmailStats(requestParameters: JobApiApiJobApiJobMatchEmailStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobMatchEmailStatsResponse> {
            return localVarFp.jobApiJobMatchEmailStats(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiJobSpecializationAutoCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiJobSpecializationAutoComplete(requestParameters: JobApiApiJobApiJobSpecializationAutoCompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SpecializationAutocompleteResponse> {
            return localVarFp.jobApiJobSpecializationAutoComplete(requestParameters.degreeIds, requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, requestParameters.specializationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiListGovernorCandidatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiListGovernorCandidates(requestParameters: JobApiApiJobApiListGovernorCandidatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GovernorCandidateListResponse> {
            return localVarFp.jobApiListGovernorCandidates(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiListJobEvaluationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiListJobEvaluations(requestParameters: JobApiApiJobApiListJobEvaluationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobEvaluationsResponse> {
            return localVarFp.jobApiListJobEvaluations(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiListOrgEvaluationQuestionSourcesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiListOrgEvaluationQuestionSources(requestParameters: JobApiApiJobApiListOrgEvaluationQuestionSourcesRequest, options?: RawAxiosRequestConfig): AxiosPromise<EvaluationQuestionSourcesResponse> {
            return localVarFp.jobApiListOrgEvaluationQuestionSources(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiListResumeBuilderAnalysesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiListResumeBuilderAnalyses(requestParameters: JobApiApiJobApiListResumeBuilderAnalysesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeBuilderAnalysisListResponse> {
            return localVarFp.jobApiListResumeBuilderAnalyses(requestParameters.resumeBuilderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiLocationCountryBackfillRoute(options?: RawAxiosRequestConfig): AxiosPromise<LocationCountryBackfillResponse> {
            return localVarFp.jobApiLocationCountryBackfillRoute(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiLocationCountryHealthRoute(options?: RawAxiosRequestConfig): AxiosPromise<LocationCountryHealthResponse> {
            return localVarFp.jobApiLocationCountryHealthRoute(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiMarkJobAsNotInterestedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMarkJobAsNotInterested(requestParameters: JobApiApiJobApiMarkJobAsNotInterestedRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiMarkJobAsNotInterested(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiMarkJobSkippedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMarkJobSkipped(requestParameters: JobApiApiJobApiMarkJobSkippedRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiMarkJobSkipped(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMergeDuplicateCollegesCompanies(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiMergeDuplicateCollegesCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMigrateData(options?: RawAxiosRequestConfig): AxiosPromise<JobMigrateFilesResponse> {
            return localVarFp.jobApiMigrateData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMigrateDataCompany(options?: RawAxiosRequestConfig): AxiosPromise<JobMigrateFilesResponse> {
            return localVarFp.jobApiMigrateDataCompany(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMigrateDataCompanyTask(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiMigrateDataCompanyTask(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiMigrateDataTask(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiMigrateDataTask(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPopulateMissingApplicantMatchesForAllJobs(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiPopulateMissingApplicantMatchesForAllJobs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiPublicDegreeAutocompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPublicDegreeAutocomplete(requestParameters: JobApiApiJobApiPublicDegreeAutocompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DegreeAutocompleteResponse> {
            return localVarFp.jobApiPublicDegreeAutocomplete(requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * count — the location twin of /skill-suggestions and /role-suggestions.  Unauthenticated on purpose: it reports nothing the browse facets and the sitemap don\'t already publish. Device type changes the counts (external jobs are hidden from the native app), so it is resolved here and passed in — the controller is memoized, so it has to be part of the cache key rather than read from the request inside.
         * @summary Places the location filter can be set to, each with its live-posting
         * @param {JobApiApiJobApiPublicJobLocationSuggestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPublicJobLocationSuggestions(requestParameters: JobApiApiJobApiPublicJobLocationSuggestionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<JobLocationSuggestionsResponse> {
            return localVarFp.jobApiPublicJobLocationSuggestions(requestParameters.pageSize, requestParameters.searchQuery, requestParameters.workMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPublicJobRoleSuggestions(options?: RawAxiosRequestConfig): AxiosPromise<JobRoleSuggestionsResponse> {
            return localVarFp.jobApiPublicJobRoleSuggestions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPublicJobSkillSuggestions(options?: RawAxiosRequestConfig): AxiosPromise<JobSkillSuggestionsResponse> {
            return localVarFp.jobApiPublicJobSkillSuggestions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiPublishJobCompetitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiPublishJobCompetition(requestParameters: JobApiApiJobApiPublishJobCompetitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiPublishJobCompetition(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiReanalyzeApplicantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiReanalyzeApplicant(requestParameters: JobApiApiJobApiReanalyzeApplicantRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReanalyzeApplicantResponse> {
            return localVarFp.jobApiReanalyzeApplicant(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiRebuildMatchingProfilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRebuildMatchingProfiles(requestParameters: JobApiApiJobApiRebuildMatchingProfilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiRebuildMatchingProfiles(requestParameters.reBuildJobMatchingProfiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRefreshBqFacetCachesApi(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiRefreshBqFacetCachesApi(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiRegenerateJobChallengeQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRegenerateJobChallengeQuestion(requestParameters: JobApiApiJobApiRegenerateJobChallengeQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegenerateJobChallengeQuestionResponse> {
            return localVarFp.jobApiRegenerateJobChallengeQuestion(requestParameters.competitionId, requestParameters.jobId, requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiRejectJobInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRejectJobInvitation(requestParameters: JobApiApiJobApiRejectJobInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiRejectJobInvitation(requestParameters.jobId, requestParameters.userId, requestParameters.jobInviteRejectBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiRejectJobProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRejectJobProfile(requestParameters: JobApiApiJobApiRejectJobProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiRejectJobProfile(requestParameters.jobId, requestParameters.userResumeEntityList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiRejectJobProfileByEmployerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRejectJobProfileByEmployer(requestParameters: JobApiApiJobApiRejectJobProfileByEmployerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiRejectJobProfileByEmployer(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiReminderEmailAllMatchingJobProfilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiReminderEmailAllMatchingJobProfiles(requestParameters: JobApiApiJobApiReminderEmailAllMatchingJobProfilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiReminderEmailAllMatchingJobProfiles(requestParameters.jobId, requestParameters.userResumeEntityListRemainderCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiRemoveExternalApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRemoveExternalApplication(requestParameters: JobApiApiJobApiRemoveExternalApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiRemoveExternalApplication(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiRequestBulkAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRequestBulkAnalysis(requestParameters: JobApiApiJobApiRequestBulkAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkAnalysisResponse> {
            return localVarFp.jobApiRequestBulkAnalysis(requestParameters.jobId, requestParameters.orgId, requestParameters.getFilteredApplicantUserIdsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiRestoreResumeBuilderAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRestoreResumeBuilderAnalysis(requestParameters: JobApiApiJobApiRestoreResumeBuilderAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeBuilderRestoreResponse> {
            return localVarFp.jobApiRestoreResumeBuilderAnalysis(requestParameters.analysisId, requestParameters.resumeBuilderRestoreBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiResumePdfBuilder(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiResumePdfBuilder(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiReviewJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiReviewJobs(requestParameters: JobApiApiJobApiReviewJobsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReviewJobResponse> {
            return localVarFp.jobApiReviewJobs(requestParameters.reviewJobParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiRewriteResumeSnippetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiRewriteResumeSnippet(requestParameters: JobApiApiJobApiRewriteResumeSnippetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RewriteSnippetResponse> {
            return localVarFp.jobApiRewriteResumeSnippet(requestParameters.rewriteSnippetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiSendAssessmentMessageToApplicantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSendAssessmentMessageToApplicants(requestParameters: JobApiApiJobApiSendAssessmentMessageToApplicantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiSendAssessmentMessageToApplicants(requestParameters.jobId, requestParameters.orgId, requestParameters.sendAssessmentMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiSendBqEmailsApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSendBqEmailsApi(requestParameters: JobApiApiJobApiSendBqEmailsApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobGetCandidatesResponse> {
            return localVarFp.jobApiSendBqEmailsApi(requestParameters.bqSendEmailsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiSendJobMatchEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSendJobMatchEmails(requestParameters: JobApiApiJobApiSendJobMatchEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobMatchEmailSendResponse> {
            return localVarFp.jobApiSendJobMatchEmails(requestParameters.jobId, requestParameters.jobMatchEmailSendBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiSendJobMatchTestEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSendJobMatchTestEmail(requestParameters: JobApiApiJobApiSendJobMatchTestEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobMatchEmailTestResponse> {
            return localVarFp.jobApiSendJobMatchTestEmail(requestParameters.jobId, requestParameters.jobMatchEmailTestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiSetAssessmentResponseScoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSetAssessmentResponseScore(requestParameters: JobApiApiJobApiSetAssessmentResponseScoreRequest, options?: RawAxiosRequestConfig): AxiosPromise<InsertAssessmentScoreResponse> {
            return localVarFp.jobApiSetAssessmentResponseScore(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.insertAssessmentScoreBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiSetEvaluationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSetEvaluationStatus(requestParameters: JobApiApiJobApiSetEvaluationStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobEvaluationResponse> {
            return localVarFp.jobApiSetEvaluationStatus(requestParameters.evaluationId, requestParameters.jobId, requestParameters.orgId, requestParameters.evaluationStatusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSetupBqTablesApi(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiSetupBqTablesApi(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiSpecializationAutoCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSpecializationAutoComplete(requestParameters: JobApiApiJobApiSpecializationAutoCompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SpecializationAutocompleteResponse> {
            return localVarFp.jobApiSpecializationAutoComplete(requestParameters.degreeId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, requestParameters.specializationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiSubmitEvaluationAssignmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSubmitEvaluationAssignment(requestParameters: JobApiApiJobApiSubmitEvaluationAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiSubmitEvaluationAssignment(requestParameters.jobEvaluationId, requestParameters.jobId, requestParameters.submitEvaluationAssignmentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiSubmitJobAssessmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiSubmitJobAssessment(requestParameters: JobApiApiJobApiSubmitJobAssessmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiSubmitJobAssessment(requestParameters.jobId, requestParameters.jobAssessmentSubmitBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiTestSpotlightWhatsapp(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.jobApiTestSpotlightWhatsapp(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUnlockApplicantAiScoresRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUnlockApplicantAiScores(requestParameters: JobApiApiJobApiUnlockApplicantAiScoresRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplicantAiUnlockResponse> {
            return localVarFp.jobApiUnlockApplicantAiScores(requestParameters.jobId, requestParameters.orgId, requestParameters.expectedCost, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUnlockDbAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUnlockDbAccess(requestParameters: JobApiApiJobApiUnlockDbAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<DbAccessUnlockResponse> {
            return localVarFp.jobApiUnlockDbAccess(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUnlockInviteProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUnlockInviteProfile(requestParameters: JobApiApiJobApiUnlockInviteProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnlockInviteProfileResponse> {
            return localVarFp.jobApiUnlockInviteProfile(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateApplicantNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateApplicantNote(requestParameters: JobApiApiJobApiUpdateApplicantNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<JobNotesResponse>> {
            return localVarFp.jobApiUpdateApplicantNote(requestParameters.jobId, requestParameters.noteId, requestParameters.orgId, requestParameters.createApplicantNoteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateApplicantRatingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateApplicantRating(requestParameters: JobApiApiJobApiUpdateApplicantRatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplicantRating> {
            return localVarFp.jobApiUpdateApplicantRating(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.ratingValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateAssessmentFieldRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateAssessmentField(requestParameters: JobApiApiJobApiUpdateAssessmentFieldRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentField> {
            return localVarFp.jobApiUpdateAssessmentField(requestParameters.assessmentId, requestParameters.fieldId, requestParameters.createAssessmentFieldBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateAssessmentResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateAssessmentResponse(requestParameters: JobApiApiJobApiUpdateAssessmentResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentResponseResponse> {
            return localVarFp.jobApiUpdateAssessmentResponse(requestParameters.assessmentResponseId, requestParameters.createAssessmentResponsedBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateDegreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateDegree(requestParameters: JobApiApiJobApiUpdateDegreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateDegreeResponse> {
            return localVarFp.jobApiUpdateDegree(requestParameters.updateDegreeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateExternalApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateExternalApplication(requestParameters: JobApiApiJobApiUpdateExternalApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalApplicationResponse> {
            return localVarFp.jobApiUpdateExternalApplication(requestParameters.jobId, requestParameters.externalApplicationStatusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateFieldPositionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateFieldPosition(requestParameters: JobApiApiJobApiUpdateFieldPositionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiUpdateFieldPosition(requestParameters.assessmentId, requestParameters.updateFieldPositionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateGptJobAnalysisStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateGptJobAnalysisStatus(requestParameters: JobApiApiJobApiUpdateGptJobAnalysisStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiUpdateGptJobAnalysisStatus(requestParameters.jobId, requestParameters.updateJobAnalysisStatusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateHiringStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateHiringStatus(requestParameters: JobApiApiJobApiUpdateHiringStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobApplicantResponse> {
            return localVarFp.jobApiUpdateHiringStatus(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.updateHiringStatusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJob(requestParameters: JobApiApiJobApiUpdateJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobResponse> {
            return localVarFp.jobApiUpdateJob(requestParameters.jobId, requestParameters.orgId, requestParameters.updateJobBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateJobAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobAdmin(requestParameters: JobApiApiJobApiUpdateJobAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobResponse> {
            return localVarFp.jobApiUpdateJobAdmin(requestParameters.adminUpdateJobBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateJobApplicantMsgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobApplicantMsg(requestParameters: JobApiApiJobApiUpdateJobApplicantMsgRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddApplicantMsgResponse> {
            return localVarFp.jobApiUpdateJobApplicantMsg(requestParameters.chatId, requestParameters.jobId, requestParameters.addApplicantMessageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateJobApplicantTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobApplicantTag(requestParameters: JobApiApiJobApiUpdateJobApplicantTagRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiUpdateJobApplicantTag(requestParameters.jobId, requestParameters.orgId, requestParameters.updateJobApplicantTagBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateJobBookmarkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobBookmark(requestParameters: JobApiApiJobApiUpdateJobBookmarkRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateJobBookmark> {
            return localVarFp.jobApiUpdateJobBookmark(requestParameters.jobId, requestParameters.bookmark, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateJobEmailPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobEmailPreferences(requestParameters: JobApiApiJobApiUpdateJobEmailPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobEmailPreferencesResponse> {
            return localVarFp.jobApiUpdateJobEmailPreferences(requestParameters.jobEmailPreferenceUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateJobEvaluationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobEvaluation(requestParameters: JobApiApiJobApiUpdateJobEvaluationRequest, options?: RawAxiosRequestConfig): AxiosPromise<JobEvaluationResponse> {
            return localVarFp.jobApiUpdateJobEvaluation(requestParameters.evaluationId, requestParameters.jobId, requestParameters.orgId, requestParameters.jobEvaluationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateJobProfileSkillBuilderScoresRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateJobProfileSkillBuilderScores(requestParameters: JobApiApiJobApiUpdateJobProfileSkillBuilderScoresRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.jobApiUpdateJobProfileSkillBuilderScores(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateReactionMsgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateReactionMsg(requestParameters: JobApiApiJobApiUpdateReactionMsgRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddReactionMsgResponse> {
            return localVarFp.jobApiUpdateReactionMsg(requestParameters.chatId, requestParameters.chatReactionId, requestParameters.jobId, requestParameters.message, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateResumeBuilderDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateResumeBuilderDetails(requestParameters: JobApiApiJobApiUpdateResumeBuilderDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetResumeBuilderResponseById> {
            return localVarFp.jobApiUpdateResumeBuilderDetails(requestParameters.resumeBuilderId, requestParameters.versionNo, requestParameters.updateResumeBuilderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateSkillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateSkill(requestParameters: JobApiApiJobApiUpdateSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSkillResponse> {
            return localVarFp.jobApiUpdateSkill(requestParameters.skillId, requestParameters.updateSkillBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpdateSpecializationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpdateSpecialization(requestParameters: JobApiApiJobApiUpdateSpecializationRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSpecializationResponse> {
            return localVarFp.jobApiUpdateSpecialization(requestParameters.updateSpecializationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpsertCandidateMetaDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpsertCandidateMetaDetails(requestParameters: JobApiApiJobApiUpsertCandidateMetaDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpsertCandidateDetails> {
            return localVarFp.jobApiUpsertCandidateMetaDetails(requestParameters.upsertCandidateDetailsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiUpsertGovernorPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiUpsertGovernorPlans(requestParameters: JobApiApiJobApiUpsertGovernorPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<GovernorPlanWriteResponse> {
            return localVarFp.jobApiUpsertGovernorPlans(requestParameters.governorPlanBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobApiApiJobApiWithdrawJobApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobApiWithdrawJobApplication(requestParameters: JobApiApiJobApiWithdrawJobApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Message> {
            return localVarFp.jobApiWithdrawJobApplication(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for jobApiAddJobApplicantMsg operation in JobApiApi.
 */
export interface JobApiApiJobApiAddJobApplicantMsgRequest {
    readonly jobId: string

    readonly addApplicantMessageBody: AddApplicantMessageBody
}

/**
 * Request parameters for jobApiAddJobItemsToCart operation in JobApiApi.
 */
export interface JobApiApiJobApiAddJobItemsToCartRequest {
    readonly orgId: string

    readonly bulkAddJobItemToCartBody: BulkAddJobItemToCartBody
}

/**
 * Request parameters for jobApiAddJobProfile operation in JobApiApi.
 */
export interface JobApiApiJobApiAddJobProfileRequest {
    readonly jobId: string

    readonly jobProfileMatchList: JobProfileMatchList
}

/**
 * Request parameters for jobApiAddReactionMsg operation in JobApiApi.
 */
export interface JobApiApiJobApiAddReactionMsgRequest {
    readonly chatId: string

    readonly jobId: string

    readonly addReactionMessageBody: AddReactionMessageBody
}

/**
 * Request parameters for jobApiAddResumeBuilderDetails operation in JobApiApi.
 */
export interface JobApiApiJobApiAddResumeBuilderDetailsRequest {
    readonly resumeBuilderBody: ResumeBuilderBody
}

/**
 * Request parameters for jobApiAdminCreateJobApplicant operation in JobApiApi.
 */
export interface JobApiApiJobApiAdminCreateJobApplicantRequest {
    readonly jobId: string

    readonly adminJobApplyBody: AdminJobApplyBody
}

/**
 * Request parameters for jobApiAdminGetJobSkills operation in JobApiApi.
 */
export interface JobApiApiJobApiAdminGetJobSkillsRequest {
    readonly name?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly showJobAssociatedSkills?: boolean

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly status?: string
}

/**
 * Request parameters for jobApiAdminReprocessStuckResumes operation in JobApiApi.
 */
export interface JobApiApiJobApiAdminReprocessStuckResumesRequest {
    readonly reprocessStuckResumesBody: ReprocessStuckResumesBody
}

/**
 * Request parameters for jobApiAdminWithdrawJobApplication operation in JobApiApi.
 */
export interface JobApiApiJobApiAdminWithdrawJobApplicationRequest {
    readonly jobId: string

    readonly iDMail: IDMail
}

/**
 * Request parameters for jobApiAiDraftAnalyze operation in JobApiApi.
 */
export interface JobApiApiJobApiAiDraftAnalyzeRequest {
    readonly orgId: string

    readonly aIPromptAnalysisBody: AIPromptAnalysisBody
}

/**
 * Request parameters for jobApiAiDraftQuestions operation in JobApiApi.
 */
export interface JobApiApiJobApiAiDraftQuestionsRequest {
    readonly orgId: string

    readonly aIScreeningQuestionsBody: AIScreeningQuestionsBody
}

/**
 * Request parameters for jobApiAiDraftRegenerateJd operation in JobApiApi.
 */
export interface JobApiApiJobApiAiDraftRegenerateJdRequest {
    readonly orgId: string

    readonly aIRegenerateJDBody: AIRegenerateJDBody
}

/**
 * Request parameters for jobApiAiDraftStream operation in JobApiApi.
 */
export interface JobApiApiJobApiAiDraftStreamRequest {
    readonly orgId: string

    readonly aIDraftPromptBody: AIDraftPromptBody
}

/**
 * Request parameters for jobApiAiDraftTranslate operation in JobApiApi.
 */
export interface JobApiApiJobApiAiDraftTranslateRequest {
    readonly orgId: string

    readonly aITranslateBody: AITranslateBody
}

/**
 * Request parameters for jobApiAnalyzeResume operation in JobApiApi.
 */
export interface JobApiApiJobApiAnalyzeResumeRequest {
    readonly resumeBuilderId: string

    readonly versionNo: string
}

/**
 * Request parameters for jobApiAnalyzeResumeBuilder operation in JobApiApi.
 */
export interface JobApiApiJobApiAnalyzeResumeBuilderRequest {
    readonly resumeBuilderId: string

    readonly versionNo: string

    readonly resumeBuilderAnalyseBody: ResumeBuilderAnalyseBody
}

/**
 * Request parameters for jobApiAnalyzeResumeJobFit operation in JobApiApi.
 */
export interface JobApiApiJobApiAnalyzeResumeJobFitRequest {
    readonly jobId: string

    readonly userResumeId: string

    readonly resumeJobFitAnalyseBody: ResumeJobFitAnalyseBody
}

/**
 * Request parameters for jobApiApplySpotlightBoost operation in JobApiApi.
 */
export interface JobApiApiJobApiApplySpotlightBoostRequest {
    readonly jobId: string

    readonly spotlightBoostBody: SpotlightBoostBody
}

/**
 * Request parameters for jobApiApplyWithJobFitResume operation in JobApiApi.
 */
export interface JobApiApiJobApiApplyWithJobFitResumeRequest {
    readonly jobId: string

    readonly userResumeId: string

    readonly resumeJobFitApplyBody: ResumeJobFitApplyBody
}

/**
 * Request parameters for jobApiAssociateJobWithCompetition operation in JobApiApi.
 */
export interface JobApiApiJobApiAssociateJobWithCompetitionRequest {
    readonly competitionId: string

    readonly jobId: string
}

/**
 * Request parameters for jobApiBqAudienceCountApi operation in JobApiApi.
 */
export interface JobApiApiJobApiBqAudienceCountApiRequest {
    readonly categories?: Array<string>

    readonly companies?: Array<string>

    readonly countries?: Array<string>

    readonly excludeCategories?: Array<string>

    readonly excludeCompanies?: Array<string>

    readonly excludeCountries?: Array<string>

    readonly excludeLocationKeywords?: Array<string>

    readonly excludePositionKeywords?: Array<string>

    readonly excludeScrapers?: Array<string>

    readonly excludeTags?: Array<string>

    readonly excludeTitleKeywords?: Array<string>

    readonly isEmailCorporate?: boolean | null

    readonly locationKeywords?: Array<string>

    readonly positionKeywords?: Array<string>

    readonly scrapers?: Array<string>

    readonly tags?: Array<string>

    readonly titleKeywords?: Array<string>
}

/**
 * Request parameters for jobApiBqAudienceExportApi operation in JobApiApi.
 */
export interface JobApiApiJobApiBqAudienceExportApiRequest {
    readonly categories?: Array<string>

    readonly companies?: Array<string>

    readonly countries?: Array<string>

    readonly excludeCategories?: Array<string>

    readonly excludeCompanies?: Array<string>

    readonly excludeCountries?: Array<string>

    readonly excludeLocationKeywords?: Array<string>

    readonly excludePositionKeywords?: Array<string>

    readonly excludeScrapers?: Array<string>

    readonly excludeTags?: Array<string>

    readonly excludeTitleKeywords?: Array<string>

    readonly format?: JobApiBqAudienceExportApiFormatEnum

    readonly isEmailCorporate?: boolean | null

    readonly limit?: number

    readonly locationKeywords?: Array<string>

    readonly offset?: number

    readonly positionKeywords?: Array<string>

    readonly scrapers?: Array<string>

    readonly tags?: Array<string>

    readonly titleKeywords?: Array<string>
}

/**
 * Request parameters for jobApiBqAutocompleteApi operation in JobApiApi.
 */
export interface JobApiApiJobApiBqAutocompleteApiRequest {
    readonly field: JobApiBqAutocompleteApiFieldEnum

    readonly categories?: Array<string>

    readonly companies?: Array<string>

    readonly countries?: Array<string>

    readonly excludeCategories?: Array<string>

    readonly excludeCompanies?: Array<string>

    readonly excludeCountries?: Array<string>

    readonly excludeLocationKeywords?: Array<string>

    readonly excludePositionKeywords?: Array<string>

    readonly excludeScrapers?: Array<string>

    readonly excludeTags?: Array<string>

    readonly excludeTitleKeywords?: Array<string>

    readonly isEmailCorporate?: boolean | null

    readonly locationKeywords?: Array<string>

    readonly positionKeywords?: Array<string>

    readonly q?: string

    readonly scrapers?: Array<string>

    readonly tags?: Array<string>

    readonly titleKeywords?: Array<string>
}

/**
 * Request parameters for jobApiBulkActionOnApplicants operation in JobApiApi.
 */
export interface JobApiApiJobApiBulkActionOnApplicantsRequest {
    readonly jobId: string

    readonly orgId: string

    readonly bulkApplicantActionBody: BulkApplicantActionBody
}

/**
 * Request parameters for jobApiBulkAddJobApplicantMessage operation in JobApiApi.
 */
export interface JobApiApiJobApiBulkAddJobApplicantMessageRequest {
    readonly jobId: string

    readonly orgId: string

    readonly bulkAddJobApplicantMessageBody: BulkAddJobApplicantMessageBody
}

/**
 * Request parameters for jobApiBulkJobStatusUpdate operation in JobApiApi.
 */
export interface JobApiApiJobApiBulkJobStatusUpdateRequest {
    readonly bulkStatusUpdateBody: BulkStatusUpdateBody
}

/**
 * Request parameters for jobApiCandidateOnboarding operation in JobApiApi.
 */
export interface JobApiApiJobApiCandidateOnboardingRequest {
    readonly candidateBoardingBody: CandidateBoardingBody
}

/**
 * Request parameters for jobApiCandidateShowcase operation in JobApiApi.
 */
export interface JobApiApiJobApiCandidateShowcaseRequest {
    readonly role?: string | null
}

/**
 * Request parameters for jobApiCheckDuplicateJob operation in JobApiApi.
 */
export interface JobApiApiJobApiCheckDuplicateJobRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiCompleteJobProfile operation in JobApiApi.
 */
export interface JobApiApiJobApiCompleteJobProfileRequest {
    readonly jobProfileBody: JobProfileBody
}

/**
 * Request parameters for jobApiCopyEvaluationQuestions operation in JobApiApi.
 */
export interface JobApiApiJobApiCopyEvaluationQuestionsRequest {
    readonly evaluationId: string

    readonly jobId: string

    readonly orgId: string

    readonly copyEvaluationQuestionsBody: CopyEvaluationQuestionsBody
}

/**
 * Request parameters for jobApiCreateApplicantNote operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateApplicantNoteRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string

    readonly createApplicantNoteBody: CreateApplicantNoteBody
}

/**
 * Request parameters for jobApiCreateAssessment operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateAssessmentRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiCreateAssessmentDuplicate operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateAssessmentDuplicateRequest {
    readonly createAssessmentDuplicateBody: CreateAssessmentDuplicateBody
}

/**
 * Request parameters for jobApiCreateAssessmentField operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateAssessmentFieldRequest {
    readonly assessmentId: string

    readonly createAssessmentFieldBody: CreateAssessmentFieldBody
}

/**
 * Request parameters for jobApiCreateBulkJobsApplicants operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateBulkJobsApplicantsRequest {
    readonly bulkJobApplyBody: BulkJobApplyBody
}

/**
 * Request parameters for jobApiCreateDegree operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateDegreeRequest {
    readonly createDegreeBody: Array<CreateDegreeBody>
}

/**
 * Request parameters for jobApiCreateJob operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateJobRequest {
    readonly orgId: string

    readonly createJobBody: CreateJobBody
}

/**
 * Request parameters for jobApiCreateJobApplicants operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateJobApplicantsRequest {
    readonly jobId: string

    readonly jobApplyAssessmentBody: JobApplyAssessmentBody
}

/**
 * Request parameters for jobApiCreateJobCandidateCsv operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateJobCandidateCsvRequest {
    readonly jobId: string

    readonly orgId: string

    readonly getFilteredApplicantUserIdsBody: GetFilteredApplicantUserIdsBody
}

/**
 * Request parameters for jobApiCreateJobEvaluation operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateJobEvaluationRequest {
    readonly jobId: string

    readonly orgId: string

    readonly jobEvaluationBody: JobEvaluationBody
}

/**
 * Request parameters for jobApiCreateJobReport operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateJobReportRequest {
    readonly jobReportBody: JobReportBody
}

/**
 * Request parameters for jobApiCreateSkillBulk operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateSkillBulkRequest {
    readonly createSkillBody: CreateSkillBody
}

/**
 * Request parameters for jobApiCreateSpecialization operation in JobApiApi.
 */
export interface JobApiApiJobApiCreateSpecializationRequest {
    readonly createSpecializationBody: Array<CreateSpecializationBody>
}

/**
 * Request parameters for jobApiDegreeAutoComplete operation in JobApiApi.
 */
export interface JobApiApiJobApiDegreeAutoCompleteRequest {
    readonly degreeId?: string

    readonly pageNo?: string

    readonly pageSize?: string

    readonly query?: string
}

/**
 * Request parameters for jobApiDeleteApplicantNote operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteApplicantNoteRequest {
    readonly jobId: string

    readonly noteId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiDeleteAssessment operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteAssessmentRequest {
    readonly assessmentId: string
}

/**
 * Request parameters for jobApiDeleteAssessmentField operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteAssessmentFieldRequest {
    readonly assessmentId: string

    readonly fieldId: string
}

/**
 * Request parameters for jobApiDeleteAssessmentResponse operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteAssessmentResponseRequest {
    readonly assessmentId: string

    readonly responseId: string
}

/**
 * Request parameters for jobApiDeleteDegree operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteDegreeRequest {
    readonly degreeId: string
}

/**
 * Request parameters for jobApiDeleteJob operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteJobRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiDeleteJobApplicantMsg operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteJobApplicantMsgRequest {
    readonly chatId: string

    readonly jobId: string
}

/**
 * Request parameters for jobApiDeleteJobCompletely operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteJobCompletelyRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiDeleteReactionMsg operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteReactionMsgRequest {
    readonly chatId: string

    readonly chatReactionId: string

    readonly jobId: string
}

/**
 * Request parameters for jobApiDeleteResumeBuilderDetails operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteResumeBuilderDetailsRequest {
    readonly resumeBuilderId: string

    readonly versionNo?: string
}

/**
 * Request parameters for jobApiDeleteResumeJobApplicant operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteResumeJobApplicantRequest {
    readonly jobId: string

    readonly orgId: string

    readonly deleteJobApplicantBody: DeleteJobApplicantBody
}

/**
 * Request parameters for jobApiDeleteSkill operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteSkillRequest {
    readonly iDList: IDList
}

/**
 * Request parameters for jobApiDeleteSpecialization operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteSpecializationRequest {
    readonly specializationId: string
}

/**
 * Request parameters for jobApiDeleteUserSkill operation in JobApiApi.
 */
export interface JobApiApiJobApiDeleteUserSkillRequest {
    readonly skillId: string
}

/**
 * Request parameters for jobApiDownloadJobProfileMatchById operation in JobApiApi.
 */
export interface JobApiApiJobApiDownloadJobProfileMatchByIdRequest {
    readonly jobId: string

    readonly orgId: string

    readonly profileId: string
}

/**
 * Request parameters for jobApiDownloadResumeJobFit operation in JobApiApi.
 */
export interface JobApiApiJobApiDownloadResumeJobFitRequest {
    readonly jobId: string

    readonly userResumeId: string

    readonly resumeJobFitDownloadBody: ResumeJobFitDownloadBody
}

/**
 * Request parameters for jobApiEmailAllMatchingJobProfiles operation in JobApiApi.
 */
export interface JobApiApiJobApiEmailAllMatchingJobProfilesRequest {
    readonly jobId: string

    readonly userResumeEntityList: UserResumeEntityList
}

/**
 * Request parameters for jobApiEmployerBulkJobStatusUpdate operation in JobApiApi.
 */
export interface JobApiApiJobApiEmployerBulkJobStatusUpdateRequest {
    readonly orgId: string

    readonly employerBulkStatusUpdateBody: EmployerBulkStatusUpdateBody
}

/**
 * Request parameters for jobApiEnhanceResume operation in JobApiApi.
 */
export interface JobApiApiJobApiEnhanceResumeRequest {
    readonly resumeBuilderId: string

    readonly versionNo: string

    readonly enhanceResumeBody: EnhanceResumeBody
}

/**
 * Request parameters for jobApiEnhanceResumeJobFit operation in JobApiApi.
 */
export interface JobApiApiJobApiEnhanceResumeJobFitRequest {
    readonly jobId: string

    readonly userResumeId: string

    readonly resumeJobFitEnhanceBody: ResumeJobFitEnhanceBody
}

/**
 * Request parameters for jobApiExternalApply operation in JobApiApi.
 */
export interface JobApiApiJobApiExternalApplyRequest {
    readonly jobId: string

    readonly externalApplyBody: ExternalApplyBody
}

/**
 * Request parameters for jobApiExternalClick operation in JobApiApi.
 */
export interface JobApiApiJobApiExternalClickRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiFixJobFormatting operation in JobApiApi.
 */
export interface JobApiApiJobApiFixJobFormattingRequest {
    readonly fixJobFormattingBody: FixJobFormattingBody
}

/**
 * Request parameters for jobApiGenerateAndAssociateJobChallengeQuestions operation in JobApiApi.
 */
export interface JobApiApiJobApiGenerateAndAssociateJobChallengeQuestionsRequest {
    readonly competitionId: string

    readonly jobId: string

    readonly generateAndAssociateJobChallengeQuestionsBody: GenerateAndAssociateJobChallengeQuestionsBody
}

/**
 * Request parameters for jobApiGenerateQuestionsAndCreateJobCompetition operation in JobApiApi.
 */
export interface JobApiApiJobApiGenerateQuestionsAndCreateJobCompetitionRequest {
    readonly jobId: string

    readonly generateQuestionsAndCreateJobCompetitionBody: GenerateQuestionsAndCreateJobCompetitionBody
}

/**
 * Request parameters for jobApiGenerateRecruiterMessage operation in JobApiApi.
 */
export interface JobApiApiJobApiGenerateRecruiterMessageRequest {
    readonly jobId: string

    readonly generateRecruiterMessageBody: GenerateRecruiterMessageBody
}

/**
 * Request parameters for jobApiGetActivityTypeCounts operation in JobApiApi.
 */
export interface JobApiApiJobApiGetActivityTypeCountsRequest {
    readonly days?: number
}

/**
 * Request parameters for jobApiGetAiDraftPayload operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAiDraftPayloadRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiGetAiDraftedJobs operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAiDraftedJobsRequest {
    readonly orgId: string
}

/**
 * Request parameters for jobApiGetAllActiveJobs operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAllActiveJobsRequest {
    readonly activeJobBody: ActiveJobBody
}

/**
 * Request parameters for jobApiGetAllActiveJobsPublic operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAllActiveJobsPublicRequest {
    readonly activeJobBody: ActiveJobBody
}

/**
 * Request parameters for jobApiGetAllAppliedJobs operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAllAppliedJobsRequest {
    readonly hiringStatus?: Array<string> | null

    readonly page?: number

    readonly pageSize?: number

    readonly skillIds?: Array<string> | null

    readonly status?: Array<string> | null

    readonly userSearchQuery?: string
}

/**
 * Request parameters for jobApiGetAndMarkJobProfileDownload operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAndMarkJobProfileDownloadRequest {
    readonly jobId: string

    readonly orgId: string

    readonly profileId: string

    readonly showContacts?: boolean
}

/**
 * Request parameters for jobApiGetApplicantAiAccessStatus operation in JobApiApi.
 */
export interface JobApiApiJobApiGetApplicantAiAccessStatusRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiGetApplicantLocation operation in JobApiApi.
 */
export interface JobApiApiJobApiGetApplicantLocationRequest {
    readonly jobId: string

    readonly orgId: string

    readonly searchQuery?: string
}

/**
 * Request parameters for jobApiGetApplicantResumeAnalysisByUserId operation in JobApiApi.
 */
export interface JobApiApiJobApiGetApplicantResumeAnalysisByUserIdRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiGetApplicantSkills operation in JobApiApi.
 */
export interface JobApiApiJobApiGetApplicantSkillsRequest {
    readonly jobId: string

    readonly orgId: string

    readonly page?: number

    readonly pageSize?: number

    readonly searchQuery?: string
}

/**
 * Request parameters for jobApiGetApplicantTags operation in JobApiApi.
 */
export interface JobApiApiJobApiGetApplicantTagsRequest {
    readonly jobId: string

    readonly orgId: string

    readonly searchQuery?: string
}

/**
 * Request parameters for jobApiGetApplicantsDetailsByPage operation in JobApiApi.
 */
export interface JobApiApiJobApiGetApplicantsDetailsByPageRequest {
    readonly jobId: string

    readonly orgId: string

    readonly applicantStatus?: Array<string>

    readonly applicantTag?: Array<string>

    readonly assessmentScreening?: Array<AssessmentScreeningFilter>

    readonly collegeIds?: Array<string>

    readonly collegeTier?: Array<string>

    readonly competitionData?: CompetitionData

    readonly countOnly?: boolean

    readonly endDate?: string

    readonly isApplicantSeen?: boolean | null

    readonly isChatStarted?: boolean

    readonly jobPreference?: string

    readonly jobRoleIds?: Array<string>

    readonly matchingBranch?: Array<string>

    readonly matchingDegree?: Array<string>

    readonly matchingLocations?: Array<string>

    readonly matchingSkills?: Array<string>

    readonly maxAssessmentScore?: number

    readonly maxCurrentCtc?: number

    readonly maxEducation?: number

    readonly maxExperience?: number

    readonly maxGrade?: number

    readonly maxPassingYear?: number

    readonly maxPercentile?: number

    readonly maxRating?: number

    readonly maxResumeAnalysisExperienceScore?: number

    readonly maxResumeAnalysisOverallScore?: number

    readonly maxResumeAnalysisSkillScore?: number

    readonly maxWorkExperienceMonths?: number

    readonly minAssessmentScore?: number

    readonly minCurrentCtc?: number

    readonly minEducation?: number

    readonly minExperience?: number

    readonly minGrade?: number

    readonly minPassingYear?: number

    readonly minPercentile?: number

    readonly minRating?: number

    readonly minReleventResumeExperienceMonths?: number

    readonly minResumeAnalysisExperienceScore?: number

    readonly minResumeAnalysisOverallScore?: number

    readonly minResumeAnalysisSkillScore?: number

    readonly minWorkExperienceMonths?: number

    readonly missingSkills?: Array<string>

    readonly noticePeriod?: number

    readonly page?: number

    readonly pageSize?: number

    readonly requiredSkills?: Array<RequiredSkillsFilter>

    readonly resumeUploaded?: boolean

    readonly sortBy?: string

    readonly sortByCompetitionData?: SortBy

    readonly sortOrder?: string

    readonly startDate?: string

    readonly userSearchQuery?: string

    readonly usernames?: Array<string>
}

/**
 * Request parameters for jobApiGetAppliedJobPopupData operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAppliedJobPopupDataRequest {
    readonly appliedJobPopupDataBody: AppliedJobPopupDataBody
}

/**
 * Request parameters for jobApiGetAssessment operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAssessmentRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetAssessmentFields operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAssessmentFieldsRequest {
    readonly assessmentId: string
}

/**
 * Request parameters for jobApiGetAutocompleteCollegeApplicants operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAutocompleteCollegeApplicantsRequest {
    readonly jobId: string

    readonly page?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for jobApiGetAutocompleteJobRoleApplicants operation in JobApiApi.
 */
export interface JobApiApiJobApiGetAutocompleteJobRoleApplicantsRequest {
    readonly jobId: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for jobApiGetBestJobs operation in JobApiApi.
 */
export interface JobApiApiJobApiGetBestJobsRequest {
    readonly count?: number

    readonly days?: number
}

/**
 * Request parameters for jobApiGetBqCandidatesApi operation in JobApiApi.
 */
export interface JobApiApiJobApiGetBqCandidatesApiRequest {
    readonly jobGetCandidatesBody: JobGetCandidatesBody
}

/**
 * Request parameters for jobApiGetBqCompaniesApi operation in JobApiApi.
 */
export interface JobApiApiJobApiGetBqCompaniesApiRequest {
    readonly jobGetCandidatesBody: JobGetCandidatesBody
}

/**
 * Request parameters for jobApiGetCandidateEvaluation operation in JobApiApi.
 */
export interface JobApiApiJobApiGetCandidateEvaluationRequest {
    readonly evaluationId: string

    readonly jobId: string
}

/**
 * Request parameters for jobApiGetChatUsersForApplicant operation in JobApiApi.
 */
export interface JobApiApiJobApiGetChatUsersForApplicantRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for jobApiGetChatUsersForEmployer operation in JobApiApi.
 */
export interface JobApiApiJobApiGetChatUsersForEmployerRequest {
    readonly jobId: string

    readonly orgId: string

    readonly page?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for jobApiGetCompanyJobs operation in JobApiApi.
 */
export interface JobApiApiJobApiGetCompanyJobsRequest {
    readonly companyAlias: string

    readonly page?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for jobApiGetCompanyStatistics operation in JobApiApi.
 */
export interface JobApiApiJobApiGetCompanyStatisticsRequest {
    readonly companyAlias: string
}

/**
 * Request parameters for jobApiGetDbAccessStatus operation in JobApiApi.
 */
export interface JobApiApiJobApiGetDbAccessStatusRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiGetDegree operation in JobApiApi.
 */
export interface JobApiApiJobApiGetDegreeRequest {
    readonly approvalStatus?: string

    readonly degreeId?: string

    readonly pageNo?: string

    readonly pageSize?: string

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly userSearchQuery?: string
}

/**
 * Request parameters for jobApiGetJobApplicantMessage operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobApplicantMessageRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly cursor?: string

    readonly pageSize?: number
}

/**
 * Request parameters for jobApiGetJobApplicantsDetails operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobApplicantsDetailsRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiGetJobApplicantsList operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobApplicantsListRequest {
    readonly jobId: string

    readonly orgId: string

    readonly applicantListParam: ApplicantListParam
}

/**
 * Request parameters for jobApiGetJobApplicantsMetaData operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobApplicantsMetaDataRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiGetJobById operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobByIdRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiGetJobByIdForApplied operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobByIdForAppliedRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetJobByIdForCandidate operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobByIdForCandidateRequest {
    readonly jobId: string

    readonly isSkillPopupRequired?: boolean
}

/**
 * Request parameters for jobApiGetJobByIdForCandidatePublic operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobByIdForCandidatePublicRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetJobByIdForEmployer operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobByIdForEmployerRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetJobByIdSlim operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobByIdSlimRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetJobCandidateJourney operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobCandidateJourneyRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiGetJobCompetitionAnsweredQuestions operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobCompetitionAnsweredQuestionsRequest {
    readonly applicantUserId: string

    readonly competitionId: string

    readonly jobId: string

    readonly page?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for jobApiGetJobCompetitionStatistics operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobCompetitionStatisticsRequest {
    readonly competitionId: string

    readonly jobId: string
}

/**
 * Request parameters for jobApiGetJobEvaluationCandidates operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobEvaluationCandidatesRequest {
    readonly evaluationId: string

    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiGetJobEvaluationDetail operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobEvaluationDetailRequest {
    readonly evaluationId: string

    readonly jobId: string

    readonly orgId: string

    readonly ensureCompetition?: boolean
}

/**
 * Request parameters for jobApiGetJobMatchingEntities operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobMatchingEntitiesRequest {
    readonly jobId: string

    readonly autoApplyEnabled?: boolean | null

    readonly endDate?: string

    readonly hasApplied?: boolean | null

    readonly jobRoleList?: Array<string>

    readonly maxExperience?: number | null

    readonly minExperience?: number | null

    readonly notified?: boolean

    readonly pageNo?: number

    readonly pageSize?: number

    readonly searchQuery?: string

    readonly skillIds?: Array<string>

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly startDate?: string
}

/**
 * Request parameters for jobApiGetJobMatchingUsers operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobMatchingUsersRequest {
    readonly jobId: string

    readonly autoApplyEnabled?: boolean | null

    readonly endDate?: string

    readonly hasApplied?: boolean | null

    readonly jobRoleList?: Array<string>

    readonly maxExperience?: number | null

    readonly minExperience?: number | null

    readonly notified?: boolean

    readonly pageNo?: number

    readonly pageSize?: number

    readonly searchQuery?: string

    readonly skillIds?: Array<string>

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly startDate?: string
}

/**
 * Request parameters for jobApiGetJobPostedList operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobPostedListRequest {
    readonly isArchieved?: boolean | null

    readonly isCompetitive?: boolean | null

    readonly isGptJob?: boolean | null

    readonly jobStatus?: string

    readonly orgId?: string

    readonly pageNo?: number | null

    readonly pageSize?: number | null

    readonly planTypeList?: Array<string>

    readonly productType?: string

    readonly query?: string
}

/**
 * Request parameters for jobApiGetJobProfileMatch operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobProfileMatchRequest {
    readonly jobId: string

    readonly orgId: string

    readonly profileMatchParam: ProfileMatchParam
}

/**
 * Request parameters for jobApiGetJobProfileMatchById operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobProfileMatchByIdRequest {
    readonly jobId: string

    readonly orgId: string

    readonly profileId: string

    readonly showContacts?: boolean
}

/**
 * Request parameters for jobApiGetJobRelatedMocktests operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobRelatedMocktestsRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetJobReports operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobReportsRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetJobRoleSkills operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobRoleSkillsRequest {
    readonly jobRoleId: string
}

/**
 * Request parameters for jobApiGetJobSkillsAutocomplete operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobSkillsAutocompleteRequest {
    readonly pageNo?: number

    readonly pageSize?: number

    readonly searchQuery?: string

    readonly searchType?: string
}

/**
 * Request parameters for jobApiGetJobStatistics operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobStatisticsRequest {
    readonly orgId: string
}

/**
 * Request parameters for jobApiGetJobSummary operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobSummaryRequest {
    readonly orgId: string
}

/**
 * Request parameters for jobApiGetJobUnreadMessageCount operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobUnreadMessageCountRequest {
    readonly orgId: string
}

/**
 * Request parameters for jobApiGetJobsGoogleAdsMetadataCsv operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobsGoogleAdsMetadataCsvRequest {
    readonly getOrgCsvParam: GetOrgCsvParam
}

/**
 * Request parameters for jobApiGetJobsGroupPublic operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobsGroupPublicRequest {
    readonly jobRoleIds?: Array<string>

    readonly locationName?: string

    readonly pageNo?: number

    readonly pageSize?: number
}

/**
 * Request parameters for jobApiGetJobsLocationsPublic operation in JobApiApi.
 */
export interface JobApiApiJobApiGetJobsLocationsPublicRequest {
    readonly jobRoleIds?: Array<string>

    readonly locationName?: string

    readonly pageNo?: number

    readonly pageSize?: number
}

/**
 * Request parameters for jobApiGetLatestResumeJobFit operation in JobApiApi.
 */
export interface JobApiApiJobApiGetLatestResumeJobFitRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetMatchingJobsDeck operation in JobApiApi.
 */
export interface JobApiApiJobApiGetMatchingJobsDeckRequest {
    readonly jobId?: string | null
}

/**
 * Request parameters for jobApiGetOrgApplicantChats operation in JobApiApi.
 */
export interface JobApiApiJobApiGetOrgApplicantChatsRequest {
    readonly orgId: string

    readonly jobRoleId?: string

    readonly page?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for jobApiGetOrgChatJobs operation in JobApiApi.
 */
export interface JobApiApiJobApiGetOrgChatJobsRequest {
    readonly orgId: string
}

/**
 * Request parameters for jobApiGetOrgJobIds operation in JobApiApi.
 */
export interface JobApiApiJobApiGetOrgJobIdsRequest {
    readonly jobAlias: string
}

/**
 * Request parameters for jobApiGetPublicCompanyJobs operation in JobApiApi.
 */
export interface JobApiApiJobApiGetPublicCompanyJobsRequest {
    readonly companyAlias: string

    readonly page?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for jobApiGetPublicCompanyStatistics operation in JobApiApi.
 */
export interface JobApiApiJobApiGetPublicCompanyStatisticsRequest {
    readonly companyAlias: string
}

/**
 * Request parameters for jobApiGetRecruiterEmail operation in JobApiApi.
 */
export interface JobApiApiJobApiGetRecruiterEmailRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetResumeBuilderAnalysis operation in JobApiApi.
 */
export interface JobApiApiJobApiGetResumeBuilderAnalysisRequest {
    readonly analysisId: string
}

/**
 * Request parameters for jobApiGetResumeBuilderDataById operation in JobApiApi.
 */
export interface JobApiApiJobApiGetResumeBuilderDataByIdRequest {
    readonly resumeBuilderId: string

    readonly versionNo?: string
}

/**
 * Request parameters for jobApiGetResumeBuilderVersionsById operation in JobApiApi.
 */
export interface JobApiApiJobApiGetResumeBuilderVersionsByIdRequest {
    readonly resumeBuilderId: string
}

/**
 * Request parameters for jobApiGetResumeJobFit operation in JobApiApi.
 */
export interface JobApiApiJobApiGetResumeJobFitRequest {
    readonly jobId: string

    readonly userResumeId: string
}

/**
 * Request parameters for jobApiGetResumeJobFitQuestions operation in JobApiApi.
 */
export interface JobApiApiJobApiGetResumeJobFitQuestionsRequest {
    readonly jobId: string

    readonly userResumeId: string
}

/**
 * Request parameters for jobApiGetScreeningInsights operation in JobApiApi.
 */
export interface JobApiApiJobApiGetScreeningInsightsRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetSimilarJobs operation in JobApiApi.
 */
export interface JobApiApiJobApiGetSimilarJobsRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetSpecialization operation in JobApiApi.
 */
export interface JobApiApiJobApiGetSpecializationRequest {
    readonly approvalStatus?: string

    readonly degreeId?: string | null

    readonly pageNo?: string

    readonly pageSize?: string

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly specializationId?: string

    readonly userSearchQuery?: string
}

/**
 * Request parameters for jobApiGetSpotlightOptions operation in JobApiApi.
 */
export interface JobApiApiJobApiGetSpotlightOptionsRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiGetSystemActivityLogs operation in JobApiApi.
 */
export interface JobApiApiJobApiGetSystemActivityLogsRequest {
    readonly activityTypeList?: Array<string>

    readonly applicantId?: string

    readonly jobIds?: Array<string>

    readonly maxDate?: string

    readonly minDate?: string

    readonly orgIds?: Array<string>

    readonly pageNo?: number

    readonly pageSize?: number

    readonly userId?: string

    readonly userType?: string
}

/**
 * Request parameters for jobApiGetUserActivityLogs operation in JobApiApi.
 */
export interface JobApiApiJobApiGetUserActivityLogsRequest {
    readonly orgId: string

    readonly activityType?: string

    readonly applicantId?: string

    readonly jobId?: string

    readonly maxDate?: string

    readonly minDate?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly userId?: string
}

/**
 * Request parameters for jobApiGetUserActivityLogsDetails operation in JobApiApi.
 */
export interface JobApiApiJobApiGetUserActivityLogsDetailsRequest {
    readonly activityId: string
}

/**
 * Request parameters for jobApiGetUserSkill operation in JobApiApi.
 */
export interface JobApiApiJobApiGetUserSkillRequest {
    readonly pageNo?: number

    readonly pageSize?: number

    readonly query?: string
}

/**
 * Request parameters for jobApiHighlightJob operation in JobApiApi.
 */
export interface JobApiApiJobApiHighlightJobRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiInitiateJobApplicationPreAnalysis operation in JobApiApi.
 */
export interface JobApiApiJobApiInitiateJobApplicationPreAnalysisRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiInviteUsersJob operation in JobApiApi.
 */
export interface JobApiApiJobApiInviteUsersJobRequest {
    readonly jobId: string

    readonly orgId: string

    readonly profileId: string

    readonly jobInvitationBody: JobInvitationBody
}

/**
 * Request parameters for jobApiJobApplicantChatMarkSeen operation in JobApiApi.
 */
export interface JobApiApiJobApiJobApplicantChatMarkSeenRequest {
    readonly applicantId: string

    readonly jobId: string
}

/**
 * Request parameters for jobApiJobMatchEmailDaily operation in JobApiApi.
 */
export interface JobApiApiJobApiJobMatchEmailDailyRequest {
    readonly jobId: string

    readonly days?: number
}

/**
 * Request parameters for jobApiJobMatchEmailPreflight operation in JobApiApi.
 */
export interface JobApiApiJobApiJobMatchEmailPreflightRequest {
    readonly jobId: string

    readonly appliedActivityMode?: JobApiJobMatchEmailPreflightAppliedActivityModeEnum

    readonly appliedInLastDays?: number | null

    readonly exactOnly?: boolean | null

    readonly hardExperience?: boolean | null

    readonly loginActivityMode?: JobApiJobMatchEmailPreflightLoginActivityModeEnum

    readonly loginInLastDays?: number | null

    readonly maxExperience?: number | null

    readonly minExperience?: number | null

    readonly neverOpenedOnly?: boolean | null

    readonly savedBand?: boolean | null

    readonly studentsOnly?: boolean | null

    readonly withCeilings?: boolean | null

    readonly withSendable?: boolean | null
}

/**
 * Request parameters for jobApiJobMatchEmailReach operation in JobApiApi.
 */
export interface JobApiApiJobApiJobMatchEmailReachRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiJobMatchEmailStats operation in JobApiApi.
 */
export interface JobApiApiJobApiJobMatchEmailStatsRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiJobSpecializationAutoComplete operation in JobApiApi.
 */
export interface JobApiApiJobApiJobSpecializationAutoCompleteRequest {
    readonly degreeIds?: Array<string>

    readonly pageNo?: string

    readonly pageSize?: string

    readonly query?: string

    readonly specializationId?: string
}

/**
 * Request parameters for jobApiListGovernorCandidates operation in JobApiApi.
 */
export interface JobApiApiJobApiListGovernorCandidatesRequest {
    readonly limit?: number | null
}

/**
 * Request parameters for jobApiListJobEvaluations operation in JobApiApi.
 */
export interface JobApiApiJobApiListJobEvaluationsRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiListOrgEvaluationQuestionSources operation in JobApiApi.
 */
export interface JobApiApiJobApiListOrgEvaluationQuestionSourcesRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiListResumeBuilderAnalyses operation in JobApiApi.
 */
export interface JobApiApiJobApiListResumeBuilderAnalysesRequest {
    readonly resumeBuilderId: string
}

/**
 * Request parameters for jobApiMarkJobAsNotInterested operation in JobApiApi.
 */
export interface JobApiApiJobApiMarkJobAsNotInterestedRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiMarkJobSkipped operation in JobApiApi.
 */
export interface JobApiApiJobApiMarkJobSkippedRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiPublicDegreeAutocomplete operation in JobApiApi.
 */
export interface JobApiApiJobApiPublicDegreeAutocompleteRequest {
    readonly pageNo?: number

    readonly pageSize?: number

    readonly searchQuery?: string
}

/**
 * Request parameters for jobApiPublicJobLocationSuggestions operation in JobApiApi.
 */
export interface JobApiApiJobApiPublicJobLocationSuggestionsRequest {
    readonly pageSize?: number

    readonly searchQuery?: string | null

    readonly workMode?: JobApiPublicJobLocationSuggestionsWorkModeEnum
}

/**
 * Request parameters for jobApiPublishJobCompetition operation in JobApiApi.
 */
export interface JobApiApiJobApiPublishJobCompetitionRequest {
    readonly competitionId: string
}

/**
 * Request parameters for jobApiReanalyzeApplicant operation in JobApiApi.
 */
export interface JobApiApiJobApiReanalyzeApplicantRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiRebuildMatchingProfiles operation in JobApiApi.
 */
export interface JobApiApiJobApiRebuildMatchingProfilesRequest {
    readonly reBuildJobMatchingProfiles: ReBuildJobMatchingProfiles
}

/**
 * Request parameters for jobApiRegenerateJobChallengeQuestion operation in JobApiApi.
 */
export interface JobApiApiJobApiRegenerateJobChallengeQuestionRequest {
    readonly competitionId: string

    readonly jobId: string

    readonly questionId: string
}

/**
 * Request parameters for jobApiRejectJobInvitation operation in JobApiApi.
 */
export interface JobApiApiJobApiRejectJobInvitationRequest {
    readonly jobId: string

    readonly userId: string

    readonly jobInviteRejectBody: JobInviteRejectBody
}

/**
 * Request parameters for jobApiRejectJobProfile operation in JobApiApi.
 */
export interface JobApiApiJobApiRejectJobProfileRequest {
    readonly jobId: string

    readonly userResumeEntityList: UserResumeEntityList
}

/**
 * Request parameters for jobApiRejectJobProfileByEmployer operation in JobApiApi.
 */
export interface JobApiApiJobApiRejectJobProfileByEmployerRequest {
    readonly jobId: string

    readonly orgId: string

    readonly profileId: string
}

/**
 * Request parameters for jobApiReminderEmailAllMatchingJobProfiles operation in JobApiApi.
 */
export interface JobApiApiJobApiReminderEmailAllMatchingJobProfilesRequest {
    readonly jobId: string

    readonly userResumeEntityListRemainderCount: UserResumeEntityListRemainderCount
}

/**
 * Request parameters for jobApiRemoveExternalApplication operation in JobApiApi.
 */
export interface JobApiApiJobApiRemoveExternalApplicationRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiRequestBulkAnalysis operation in JobApiApi.
 */
export interface JobApiApiJobApiRequestBulkAnalysisRequest {
    readonly jobId: string

    readonly orgId: string

    readonly getFilteredApplicantUserIdsBody: GetFilteredApplicantUserIdsBody
}

/**
 * Request parameters for jobApiRestoreResumeBuilderAnalysis operation in JobApiApi.
 */
export interface JobApiApiJobApiRestoreResumeBuilderAnalysisRequest {
    readonly analysisId: string

    readonly resumeBuilderRestoreBody: ResumeBuilderRestoreBody
}

/**
 * Request parameters for jobApiReviewJobs operation in JobApiApi.
 */
export interface JobApiApiJobApiReviewJobsRequest {
    readonly reviewJobParam: ReviewJobParam
}

/**
 * Request parameters for jobApiRewriteResumeSnippet operation in JobApiApi.
 */
export interface JobApiApiJobApiRewriteResumeSnippetRequest {
    readonly rewriteSnippetBody: RewriteSnippetBody
}

/**
 * Request parameters for jobApiSendAssessmentMessageToApplicants operation in JobApiApi.
 */
export interface JobApiApiJobApiSendAssessmentMessageToApplicantsRequest {
    readonly jobId: string

    readonly orgId: string

    readonly sendAssessmentMessageBody: SendAssessmentMessageBody
}

/**
 * Request parameters for jobApiSendBqEmailsApi operation in JobApiApi.
 */
export interface JobApiApiJobApiSendBqEmailsApiRequest {
    readonly bqSendEmailsBody: BqSendEmailsBody
}

/**
 * Request parameters for jobApiSendJobMatchEmails operation in JobApiApi.
 */
export interface JobApiApiJobApiSendJobMatchEmailsRequest {
    readonly jobId: string

    readonly jobMatchEmailSendBody: JobMatchEmailSendBody
}

/**
 * Request parameters for jobApiSendJobMatchTestEmail operation in JobApiApi.
 */
export interface JobApiApiJobApiSendJobMatchTestEmailRequest {
    readonly jobId: string

    readonly jobMatchEmailTestBody: JobMatchEmailTestBody
}

/**
 * Request parameters for jobApiSetAssessmentResponseScore operation in JobApiApi.
 */
export interface JobApiApiJobApiSetAssessmentResponseScoreRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string

    readonly insertAssessmentScoreBody: Array<InsertAssessmentScoreBody>
}

/**
 * Request parameters for jobApiSetEvaluationStatus operation in JobApiApi.
 */
export interface JobApiApiJobApiSetEvaluationStatusRequest {
    readonly evaluationId: string

    readonly jobId: string

    readonly orgId: string

    readonly evaluationStatusBody: EvaluationStatusBody
}

/**
 * Request parameters for jobApiSpecializationAutoComplete operation in JobApiApi.
 */
export interface JobApiApiJobApiSpecializationAutoCompleteRequest {
    readonly degreeId?: string | null

    readonly pageNo?: string

    readonly pageSize?: string

    readonly query?: string

    readonly specializationId?: string
}

/**
 * Request parameters for jobApiSubmitEvaluationAssignment operation in JobApiApi.
 */
export interface JobApiApiJobApiSubmitEvaluationAssignmentRequest {
    readonly jobEvaluationId: string

    readonly jobId: string

    readonly submitEvaluationAssignmentBody: SubmitEvaluationAssignmentBody
}

/**
 * Request parameters for jobApiSubmitJobAssessment operation in JobApiApi.
 */
export interface JobApiApiJobApiSubmitJobAssessmentRequest {
    readonly jobId: string

    readonly jobAssessmentSubmitBase: JobAssessmentSubmitBase
}

/**
 * Request parameters for jobApiUnlockApplicantAiScores operation in JobApiApi.
 */
export interface JobApiApiJobApiUnlockApplicantAiScoresRequest {
    readonly jobId: string

    readonly orgId: string

    readonly expectedCost?: number
}

/**
 * Request parameters for jobApiUnlockDbAccess operation in JobApiApi.
 */
export interface JobApiApiJobApiUnlockDbAccessRequest {
    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for jobApiUnlockInviteProfile operation in JobApiApi.
 */
export interface JobApiApiJobApiUnlockInviteProfileRequest {
    readonly jobId: string

    readonly orgId: string

    readonly profileId: string
}

/**
 * Request parameters for jobApiUpdateApplicantNote operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateApplicantNoteRequest {
    readonly jobId: string

    readonly noteId: string

    readonly orgId: string

    readonly createApplicantNoteBody: CreateApplicantNoteBody
}

/**
 * Request parameters for jobApiUpdateApplicantRating operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateApplicantRatingRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string

    readonly ratingValue: string
}

/**
 * Request parameters for jobApiUpdateAssessmentField operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateAssessmentFieldRequest {
    readonly assessmentId: string

    readonly fieldId: string

    readonly createAssessmentFieldBody: CreateAssessmentFieldBody
}

/**
 * Request parameters for jobApiUpdateAssessmentResponse operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateAssessmentResponseRequest {
    readonly assessmentResponseId: string

    readonly createAssessmentResponsedBody: CreateAssessmentResponsedBody
}

/**
 * Request parameters for jobApiUpdateDegree operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateDegreeRequest {
    readonly updateDegreeBody: UpdateDegreeBody
}

/**
 * Request parameters for jobApiUpdateExternalApplication operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateExternalApplicationRequest {
    readonly jobId: string

    readonly externalApplicationStatusBody: ExternalApplicationStatusBody
}

/**
 * Request parameters for jobApiUpdateFieldPosition operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateFieldPositionRequest {
    readonly assessmentId: string

    readonly updateFieldPositionBody: Array<UpdateFieldPositionBody>
}

/**
 * Request parameters for jobApiUpdateGptJobAnalysisStatus operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateGptJobAnalysisStatusRequest {
    readonly jobId: string

    readonly updateJobAnalysisStatusBody: UpdateJobAnalysisStatusBody
}

/**
 * Request parameters for jobApiUpdateHiringStatus operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateHiringStatusRequest {
    readonly applicantId: string

    readonly jobId: string

    readonly orgId: string

    readonly updateHiringStatusBody: UpdateHiringStatusBody
}

/**
 * Request parameters for jobApiUpdateJob operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateJobRequest {
    readonly jobId: string

    readonly orgId: string

    readonly updateJobBody: UpdateJobBody
}

/**
 * Request parameters for jobApiUpdateJobAdmin operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateJobAdminRequest {
    readonly adminUpdateJobBody: AdminUpdateJobBody
}

/**
 * Request parameters for jobApiUpdateJobApplicantMsg operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateJobApplicantMsgRequest {
    readonly chatId: string

    readonly jobId: string

    readonly addApplicantMessageBody: AddApplicantMessageBody
}

/**
 * Request parameters for jobApiUpdateJobApplicantTag operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateJobApplicantTagRequest {
    readonly jobId: string

    readonly orgId: string

    readonly updateJobApplicantTagBody: Array<UpdateJobApplicantTagBody>
}

/**
 * Request parameters for jobApiUpdateJobBookmark operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateJobBookmarkRequest {
    readonly jobId: string

    readonly bookmark?: string
}

/**
 * Request parameters for jobApiUpdateJobEmailPreferences operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateJobEmailPreferencesRequest {
    readonly jobEmailPreferenceUpdateBody: JobEmailPreferenceUpdateBody
}

/**
 * Request parameters for jobApiUpdateJobEvaluation operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateJobEvaluationRequest {
    readonly evaluationId: string

    readonly jobId: string

    readonly orgId: string

    readonly jobEvaluationBody: JobEvaluationBody
}

/**
 * Request parameters for jobApiUpdateJobProfileSkillBuilderScores operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateJobProfileSkillBuilderScoresRequest {
    readonly jobId: string
}

/**
 * Request parameters for jobApiUpdateReactionMsg operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateReactionMsgRequest {
    readonly chatId: string

    readonly chatReactionId: string

    readonly jobId: string

    readonly message: string
}

/**
 * Request parameters for jobApiUpdateResumeBuilderDetails operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateResumeBuilderDetailsRequest {
    readonly resumeBuilderId: string

    readonly versionNo: string

    readonly updateResumeBuilderBody: UpdateResumeBuilderBody
}

/**
 * Request parameters for jobApiUpdateSkill operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateSkillRequest {
    readonly skillId: string

    readonly updateSkillBody: UpdateSkillBody
}

/**
 * Request parameters for jobApiUpdateSpecialization operation in JobApiApi.
 */
export interface JobApiApiJobApiUpdateSpecializationRequest {
    readonly updateSpecializationBody: UpdateSpecializationBody
}

/**
 * Request parameters for jobApiUpsertCandidateMetaDetails operation in JobApiApi.
 */
export interface JobApiApiJobApiUpsertCandidateMetaDetailsRequest {
    readonly upsertCandidateDetailsBody: UpsertCandidateDetailsBody
}

/**
 * Request parameters for jobApiUpsertGovernorPlans operation in JobApiApi.
 */
export interface JobApiApiJobApiUpsertGovernorPlansRequest {
    readonly governorPlanBody: GovernorPlanBody
}

/**
 * Request parameters for jobApiWithdrawJobApplication operation in JobApiApi.
 */
export interface JobApiApiJobApiWithdrawJobApplicationRequest {
    readonly jobId: string
}

/**
 * JobApiApi - object-oriented interface
 */
export class JobApiApi extends BaseAPI {
    /**
     * 
     * @param {JobApiApiJobApiAddJobApplicantMsgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAddJobApplicantMsg(requestParameters: JobApiApiJobApiAddJobApplicantMsgRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAddJobApplicantMsg(requestParameters.jobId, requestParameters.addApplicantMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAddJobItemsToCartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAddJobItemsToCart(requestParameters: JobApiApiJobApiAddJobItemsToCartRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAddJobItemsToCart(requestParameters.orgId, requestParameters.bulkAddJobItemToCartBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAddJobProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAddJobProfile(requestParameters: JobApiApiJobApiAddJobProfileRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAddJobProfile(requestParameters.jobId, requestParameters.jobProfileMatchList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAddReactionMsgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAddReactionMsg(requestParameters: JobApiApiJobApiAddReactionMsgRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAddReactionMsg(requestParameters.chatId, requestParameters.jobId, requestParameters.addReactionMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAddResumeBuilderDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAddResumeBuilderDetails(requestParameters: JobApiApiJobApiAddResumeBuilderDetailsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAddResumeBuilderDetails(requestParameters.resumeBuilderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAdminCreateJobApplicantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAdminCreateJobApplicant(requestParameters: JobApiApiJobApiAdminCreateJobApplicantRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAdminCreateJobApplicant(requestParameters.jobId, requestParameters.adminJobApplyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAdminGetJobSkillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAdminGetJobSkills(requestParameters: JobApiApiJobApiAdminGetJobSkillsRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAdminGetJobSkills(requestParameters.name, requestParameters.pageNo, requestParameters.pageSize, requestParameters.showJobAssociatedSkills, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAdminReprocessStuckResumesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAdminReprocessStuckResumes(requestParameters: JobApiApiJobApiAdminReprocessStuckResumesRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAdminReprocessStuckResumes(requestParameters.reprocessStuckResumesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAdminWithdrawJobApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAdminWithdrawJobApplication(requestParameters: JobApiApiJobApiAdminWithdrawJobApplicationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAdminWithdrawJobApplication(requestParameters.jobId, requestParameters.iDMail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAiDraftAnalyzeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAiDraftAnalyze(requestParameters: JobApiApiJobApiAiDraftAnalyzeRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAiDraftAnalyze(requestParameters.orgId, requestParameters.aIPromptAnalysisBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAiDraftQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAiDraftQuestions(requestParameters: JobApiApiJobApiAiDraftQuestionsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAiDraftQuestions(requestParameters.orgId, requestParameters.aIScreeningQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAiDraftRegenerateJdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAiDraftRegenerateJd(requestParameters: JobApiApiJobApiAiDraftRegenerateJdRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAiDraftRegenerateJd(requestParameters.orgId, requestParameters.aIRegenerateJDBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAiDraftStreamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAiDraftStream(requestParameters: JobApiApiJobApiAiDraftStreamRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAiDraftStream(requestParameters.orgId, requestParameters.aIDraftPromptBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAiDraftTranslateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAiDraftTranslate(requestParameters: JobApiApiJobApiAiDraftTranslateRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAiDraftTranslate(requestParameters.orgId, requestParameters.aITranslateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAnalyseIsolatedUserResumes(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAnalyseIsolatedUserResumes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAnalyzeResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAnalyzeResume(requestParameters: JobApiApiJobApiAnalyzeResumeRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAnalyzeResume(requestParameters.resumeBuilderId, requestParameters.versionNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAnalyzeResumeBuilderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAnalyzeResumeBuilder(requestParameters: JobApiApiJobApiAnalyzeResumeBuilderRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAnalyzeResumeBuilder(requestParameters.resumeBuilderId, requestParameters.versionNo, requestParameters.resumeBuilderAnalyseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAnalyzeResumeJobFitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAnalyzeResumeJobFit(requestParameters: JobApiApiJobApiAnalyzeResumeJobFitRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAnalyzeResumeJobFit(requestParameters.jobId, requestParameters.userResumeId, requestParameters.resumeJobFitAnalyseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiApplySpotlightBoostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiApplySpotlightBoost(requestParameters: JobApiApiJobApiApplySpotlightBoostRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiApplySpotlightBoost(requestParameters.jobId, requestParameters.spotlightBoostBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiApplyWithJobFitResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiApplyWithJobFitResume(requestParameters: JobApiApiJobApiApplyWithJobFitResumeRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiApplyWithJobFitResume(requestParameters.jobId, requestParameters.userResumeId, requestParameters.resumeJobFitApplyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiAssociateJobWithCompetitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiAssociateJobWithCompetition(requestParameters: JobApiApiJobApiAssociateJobWithCompetitionRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiAssociateJobWithCompetition(requestParameters.competitionId, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiBqAudienceCountApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiBqAudienceCountApi(requestParameters: JobApiApiJobApiBqAudienceCountApiRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiBqAudienceCountApi(requestParameters.categories, requestParameters.companies, requestParameters.countries, requestParameters.excludeCategories, requestParameters.excludeCompanies, requestParameters.excludeCountries, requestParameters.excludeLocationKeywords, requestParameters.excludePositionKeywords, requestParameters.excludeScrapers, requestParameters.excludeTags, requestParameters.excludeTitleKeywords, requestParameters.isEmailCorporate, requestParameters.locationKeywords, requestParameters.positionKeywords, requestParameters.scrapers, requestParameters.tags, requestParameters.titleKeywords, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiBqAudienceExportApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiBqAudienceExportApi(requestParameters: JobApiApiJobApiBqAudienceExportApiRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiBqAudienceExportApi(requestParameters.categories, requestParameters.companies, requestParameters.countries, requestParameters.excludeCategories, requestParameters.excludeCompanies, requestParameters.excludeCountries, requestParameters.excludeLocationKeywords, requestParameters.excludePositionKeywords, requestParameters.excludeScrapers, requestParameters.excludeTags, requestParameters.excludeTitleKeywords, requestParameters.format, requestParameters.isEmailCorporate, requestParameters.limit, requestParameters.locationKeywords, requestParameters.offset, requestParameters.positionKeywords, requestParameters.scrapers, requestParameters.tags, requestParameters.titleKeywords, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiBqAutocompleteApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiBqAutocompleteApi(requestParameters: JobApiApiJobApiBqAutocompleteApiRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiBqAutocompleteApi(requestParameters.field, requestParameters.categories, requestParameters.companies, requestParameters.countries, requestParameters.excludeCategories, requestParameters.excludeCompanies, requestParameters.excludeCountries, requestParameters.excludeLocationKeywords, requestParameters.excludePositionKeywords, requestParameters.excludeScrapers, requestParameters.excludeTags, requestParameters.excludeTitleKeywords, requestParameters.isEmailCorporate, requestParameters.locationKeywords, requestParameters.positionKeywords, requestParameters.q, requestParameters.scrapers, requestParameters.tags, requestParameters.titleKeywords, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiBulkActionOnApplicantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiBulkActionOnApplicants(requestParameters: JobApiApiJobApiBulkActionOnApplicantsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiBulkActionOnApplicants(requestParameters.jobId, requestParameters.orgId, requestParameters.bulkApplicantActionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiBulkAddJobApplicantMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiBulkAddJobApplicantMessage(requestParameters: JobApiApiJobApiBulkAddJobApplicantMessageRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiBulkAddJobApplicantMessage(requestParameters.jobId, requestParameters.orgId, requestParameters.bulkAddJobApplicantMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiBulkJobStatusUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiBulkJobStatusUpdate(requestParameters: JobApiApiJobApiBulkJobStatusUpdateRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiBulkJobStatusUpdate(requestParameters.bulkStatusUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCandidateOnboardingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCandidateOnboarding(requestParameters: JobApiApiJobApiCandidateOnboardingRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCandidateOnboarding(requestParameters.candidateBoardingBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCandidateShowcaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCandidateShowcase(requestParameters: JobApiApiJobApiCandidateShowcaseRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCandidateShowcase(requestParameters.role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCheckDuplicateJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCheckDuplicateJob(requestParameters: JobApiApiJobApiCheckDuplicateJobRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCheckDuplicateJob(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCompleteJobProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCompleteJobProfile(requestParameters: JobApiApiJobApiCompleteJobProfileRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCompleteJobProfile(requestParameters.jobProfileBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCopyEvaluationQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCopyEvaluationQuestions(requestParameters: JobApiApiJobApiCopyEvaluationQuestionsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCopyEvaluationQuestions(requestParameters.evaluationId, requestParameters.jobId, requestParameters.orgId, requestParameters.copyEvaluationQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateApplicantNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateApplicantNote(requestParameters: JobApiApiJobApiCreateApplicantNoteRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateApplicantNote(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.createApplicantNoteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateAssessmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateAssessment(requestParameters: JobApiApiJobApiCreateAssessmentRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateAssessment(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateAssessmentDuplicateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateAssessmentDuplicate(requestParameters: JobApiApiJobApiCreateAssessmentDuplicateRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateAssessmentDuplicate(requestParameters.createAssessmentDuplicateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateAssessmentFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateAssessmentField(requestParameters: JobApiApiJobApiCreateAssessmentFieldRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateAssessmentField(requestParameters.assessmentId, requestParameters.createAssessmentFieldBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateBulkJobsApplicantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateBulkJobsApplicants(requestParameters: JobApiApiJobApiCreateBulkJobsApplicantsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateBulkJobsApplicants(requestParameters.bulkJobApplyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateCompanyXml(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateCompanyXml(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateDegreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateDegree(requestParameters: JobApiApiJobApiCreateDegreeRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateDegree(requestParameters.createDegreeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateJob(requestParameters: JobApiApiJobApiCreateJobRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateJob(requestParameters.orgId, requestParameters.createJobBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateJobApplicantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateJobApplicants(requestParameters: JobApiApiJobApiCreateJobApplicantsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateJobApplicants(requestParameters.jobId, requestParameters.jobApplyAssessmentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateJobCandidateCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateJobCandidateCsv(requestParameters: JobApiApiJobApiCreateJobCandidateCsvRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateJobCandidateCsv(requestParameters.jobId, requestParameters.orgId, requestParameters.getFilteredApplicantUserIdsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateJobEvaluationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateJobEvaluation(requestParameters: JobApiApiJobApiCreateJobEvaluationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateJobEvaluation(requestParameters.jobId, requestParameters.orgId, requestParameters.jobEvaluationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateJobLocationXml(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateJobLocationXml(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateJobReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateJobReport(requestParameters: JobApiApiJobApiCreateJobReportRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateJobReport(requestParameters.jobReportBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateJobRoleXml(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateJobRoleXml(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateJobsXml(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateJobsXml(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateSitemapOfSitemapsXml(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateSitemapOfSitemapsXml(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateSkillBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateSkillBulk(requestParameters: JobApiApiJobApiCreateSkillBulkRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateSkillBulk(requestParameters.createSkillBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiCreateSpecializationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiCreateSpecialization(requestParameters: JobApiApiJobApiCreateSpecializationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiCreateSpecialization(requestParameters.createSpecializationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDegreeAutoCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDegreeAutoComplete(requestParameters: JobApiApiJobApiDegreeAutoCompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDegreeAutoComplete(requestParameters.degreeId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteApplicantNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteApplicantNote(requestParameters: JobApiApiJobApiDeleteApplicantNoteRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteApplicantNote(requestParameters.jobId, requestParameters.noteId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteAssessmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteAssessment(requestParameters: JobApiApiJobApiDeleteAssessmentRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteAssessment(requestParameters.assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteAssessmentFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteAssessmentField(requestParameters: JobApiApiJobApiDeleteAssessmentFieldRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteAssessmentField(requestParameters.assessmentId, requestParameters.fieldId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteAssessmentResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteAssessmentResponse(requestParameters: JobApiApiJobApiDeleteAssessmentResponseRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteAssessmentResponse(requestParameters.assessmentId, requestParameters.responseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteDegreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteDegree(requestParameters: JobApiApiJobApiDeleteDegreeRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteDegree(requestParameters.degreeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteJob(requestParameters: JobApiApiJobApiDeleteJobRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteJob(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteJobApplicantMsgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteJobApplicantMsg(requestParameters: JobApiApiJobApiDeleteJobApplicantMsgRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteJobApplicantMsg(requestParameters.chatId, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteJobCompletelyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteJobCompletely(requestParameters: JobApiApiJobApiDeleteJobCompletelyRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteJobCompletely(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteReactionMsgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteReactionMsg(requestParameters: JobApiApiJobApiDeleteReactionMsgRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteReactionMsg(requestParameters.chatId, requestParameters.chatReactionId, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteResumeBuilderDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteResumeBuilderDetails(requestParameters: JobApiApiJobApiDeleteResumeBuilderDetailsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteResumeBuilderDetails(requestParameters.resumeBuilderId, requestParameters.versionNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteResumeJobApplicantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteResumeJobApplicant(requestParameters: JobApiApiJobApiDeleteResumeJobApplicantRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteResumeJobApplicant(requestParameters.jobId, requestParameters.orgId, requestParameters.deleteJobApplicantBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteSkillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteSkill(requestParameters: JobApiApiJobApiDeleteSkillRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteSkill(requestParameters.iDList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteSpecializationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteSpecialization(requestParameters: JobApiApiJobApiDeleteSpecializationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteSpecialization(requestParameters.specializationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDeleteUserSkillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDeleteUserSkill(requestParameters: JobApiApiJobApiDeleteUserSkillRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDeleteUserSkill(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDisableAutoJobApply(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDisableAutoJobApply(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDownloadJobProfileMatchByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDownloadJobProfileMatchById(requestParameters: JobApiApiJobApiDownloadJobProfileMatchByIdRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDownloadJobProfileMatchById(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiDownloadResumeJobFitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiDownloadResumeJobFit(requestParameters: JobApiApiJobApiDownloadResumeJobFitRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiDownloadResumeJobFit(requestParameters.jobId, requestParameters.userResumeId, requestParameters.resumeJobFitDownloadBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiEmailAllMatchingJobProfilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiEmailAllMatchingJobProfiles(requestParameters: JobApiApiJobApiEmailAllMatchingJobProfilesRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiEmailAllMatchingJobProfiles(requestParameters.jobId, requestParameters.userResumeEntityList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiEmployerBulkJobStatusUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiEmployerBulkJobStatusUpdate(requestParameters: JobApiApiJobApiEmployerBulkJobStatusUpdateRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiEmployerBulkJobStatusUpdate(requestParameters.orgId, requestParameters.employerBulkStatusUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiEnableAutoJobApply(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiEnableAutoJobApply(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiEnhanceResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiEnhanceResume(requestParameters: JobApiApiJobApiEnhanceResumeRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiEnhanceResume(requestParameters.resumeBuilderId, requestParameters.versionNo, requestParameters.enhanceResumeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiEnhanceResumeJobFitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiEnhanceResumeJobFit(requestParameters: JobApiApiJobApiEnhanceResumeJobFitRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiEnhanceResumeJobFit(requestParameters.jobId, requestParameters.userResumeId, requestParameters.resumeJobFitEnhanceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiExternalApplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiExternalApply(requestParameters: JobApiApiJobApiExternalApplyRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiExternalApply(requestParameters.jobId, requestParameters.externalApplyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiExternalClickRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiExternalClick(requestParameters: JobApiApiJobApiExternalClickRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiExternalClick(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiFixJobFormattingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiFixJobFormatting(requestParameters: JobApiApiJobApiFixJobFormattingRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiFixJobFormatting(requestParameters.fixJobFormattingBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGenerateAndAssociateJobChallengeQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGenerateAndAssociateJobChallengeQuestions(requestParameters: JobApiApiJobApiGenerateAndAssociateJobChallengeQuestionsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGenerateAndAssociateJobChallengeQuestions(requestParameters.competitionId, requestParameters.jobId, requestParameters.generateAndAssociateJobChallengeQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGenerateQuestionsAndCreateJobCompetitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGenerateQuestionsAndCreateJobCompetition(requestParameters: JobApiApiJobApiGenerateQuestionsAndCreateJobCompetitionRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGenerateQuestionsAndCreateJobCompetition(requestParameters.jobId, requestParameters.generateQuestionsAndCreateJobCompetitionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGenerateRecruiterMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGenerateRecruiterMessage(requestParameters: JobApiApiJobApiGenerateRecruiterMessageRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGenerateRecruiterMessage(requestParameters.jobId, requestParameters.generateRecruiterMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetActivityTypeCountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetActivityTypeCounts(requestParameters: JobApiApiJobApiGetActivityTypeCountsRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetActivityTypeCounts(requestParameters.days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAiDraftPayloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAiDraftPayload(requestParameters: JobApiApiJobApiGetAiDraftPayloadRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAiDraftPayload(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAiDraftedJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAiDraftedJobs(requestParameters: JobApiApiJobApiGetAiDraftedJobsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAiDraftedJobs(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAllActiveJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAllActiveJobs(requestParameters: JobApiApiJobApiGetAllActiveJobsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAllActiveJobs(requestParameters.activeJobBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAllActiveJobsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAllActiveJobsPublic(requestParameters: JobApiApiJobApiGetAllActiveJobsPublicRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAllActiveJobsPublic(requestParameters.activeJobBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAllAppliedJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAllAppliedJobs(requestParameters: JobApiApiJobApiGetAllAppliedJobsRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAllAppliedJobs(requestParameters.hiringStatus, requestParameters.page, requestParameters.pageSize, requestParameters.skillIds, requestParameters.status, requestParameters.userSearchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAndMarkJobProfileDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAndMarkJobProfileDownload(requestParameters: JobApiApiJobApiGetAndMarkJobProfileDownloadRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAndMarkJobProfileDownload(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, requestParameters.showContacts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetApplicantAiAccessStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetApplicantAiAccessStatus(requestParameters: JobApiApiJobApiGetApplicantAiAccessStatusRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetApplicantAiAccessStatus(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetApplicantLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetApplicantLocation(requestParameters: JobApiApiJobApiGetApplicantLocationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetApplicantLocation(requestParameters.jobId, requestParameters.orgId, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetApplicantResumeAnalysisByUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetApplicantResumeAnalysisByUserId(requestParameters: JobApiApiJobApiGetApplicantResumeAnalysisByUserIdRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetApplicantResumeAnalysisByUserId(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetApplicantSkillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetApplicantSkills(requestParameters: JobApiApiJobApiGetApplicantSkillsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetApplicantSkills(requestParameters.jobId, requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetApplicantTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetApplicantTags(requestParameters: JobApiApiJobApiGetApplicantTagsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetApplicantTags(requestParameters.jobId, requestParameters.orgId, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetApplicantsDetailsByPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetApplicantsDetailsByPage(requestParameters: JobApiApiJobApiGetApplicantsDetailsByPageRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetApplicantsDetailsByPage(requestParameters.jobId, requestParameters.orgId, requestParameters.applicantStatus, requestParameters.applicantTag, requestParameters.assessmentScreening, requestParameters.collegeIds, requestParameters.collegeTier, requestParameters.competitionData, requestParameters.countOnly, requestParameters.endDate, requestParameters.isApplicantSeen, requestParameters.isChatStarted, requestParameters.jobPreference, requestParameters.jobRoleIds, requestParameters.matchingBranch, requestParameters.matchingDegree, requestParameters.matchingLocations, requestParameters.matchingSkills, requestParameters.maxAssessmentScore, requestParameters.maxCurrentCtc, requestParameters.maxEducation, requestParameters.maxExperience, requestParameters.maxGrade, requestParameters.maxPassingYear, requestParameters.maxPercentile, requestParameters.maxRating, requestParameters.maxResumeAnalysisExperienceScore, requestParameters.maxResumeAnalysisOverallScore, requestParameters.maxResumeAnalysisSkillScore, requestParameters.maxWorkExperienceMonths, requestParameters.minAssessmentScore, requestParameters.minCurrentCtc, requestParameters.minEducation, requestParameters.minExperience, requestParameters.minGrade, requestParameters.minPassingYear, requestParameters.minPercentile, requestParameters.minRating, requestParameters.minReleventResumeExperienceMonths, requestParameters.minResumeAnalysisExperienceScore, requestParameters.minResumeAnalysisOverallScore, requestParameters.minResumeAnalysisSkillScore, requestParameters.minWorkExperienceMonths, requestParameters.missingSkills, requestParameters.noticePeriod, requestParameters.page, requestParameters.pageSize, requestParameters.requiredSkills, requestParameters.resumeUploaded, requestParameters.sortBy, requestParameters.sortByCompetitionData, requestParameters.sortOrder, requestParameters.startDate, requestParameters.userSearchQuery, requestParameters.usernames, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAppliedJobPopupDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAppliedJobPopupData(requestParameters: JobApiApiJobApiGetAppliedJobPopupDataRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAppliedJobPopupData(requestParameters.appliedJobPopupDataBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAppliedJobsSummary(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAppliedJobsSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAssessmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAssessment(requestParameters: JobApiApiJobApiGetAssessmentRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAssessment(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAssessmentFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAssessmentFields(requestParameters: JobApiApiJobApiGetAssessmentFieldsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAssessmentFields(requestParameters.assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAutocompleteCollegeApplicantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAutocompleteCollegeApplicants(requestParameters: JobApiApiJobApiGetAutocompleteCollegeApplicantsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAutocompleteCollegeApplicants(requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetAutocompleteJobRoleApplicantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetAutocompleteJobRoleApplicants(requestParameters: JobApiApiJobApiGetAutocompleteJobRoleApplicantsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetAutocompleteJobRoleApplicants(requestParameters.jobId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetBestJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetBestJobs(requestParameters: JobApiApiJobApiGetBestJobsRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetBestJobs(requestParameters.count, requestParameters.days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetBqCandidatesApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetBqCandidatesApi(requestParameters: JobApiApiJobApiGetBqCandidatesApiRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetBqCandidatesApi(requestParameters.jobGetCandidatesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetBqCompaniesApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetBqCompaniesApi(requestParameters: JobApiApiJobApiGetBqCompaniesApiRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetBqCompaniesApi(requestParameters.jobGetCandidatesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetBqFilterOptionsApi(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetBqFilterOptionsApi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetCandidateEvaluationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetCandidateEvaluation(requestParameters: JobApiApiJobApiGetCandidateEvaluationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetCandidateEvaluation(requestParameters.evaluationId, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetCandidateMetaDetails(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetCandidateMetaDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetChatUsersForApplicantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetChatUsersForApplicant(requestParameters: JobApiApiJobApiGetChatUsersForApplicantRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetChatUsersForApplicant(requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetChatUsersForEmployerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetChatUsersForEmployer(requestParameters: JobApiApiJobApiGetChatUsersForEmployerRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetChatUsersForEmployer(requestParameters.jobId, requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetCompanyJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetCompanyJobs(requestParameters: JobApiApiJobApiGetCompanyJobsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetCompanyJobs(requestParameters.companyAlias, requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetCompanyStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetCompanyStatistics(requestParameters: JobApiApiJobApiGetCompanyStatisticsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetCompanyStatistics(requestParameters.companyAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetDbAccessStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetDbAccessStatus(requestParameters: JobApiApiJobApiGetDbAccessStatusRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetDbAccessStatus(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetDegreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetDegree(requestParameters: JobApiApiJobApiGetDegreeRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetDegree(requestParameters.approvalStatus, requestParameters.degreeId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.userSearchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobApplicantMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobApplicantMessage(requestParameters: JobApiApiJobApiGetJobApplicantMessageRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobApplicantMessage(requestParameters.applicantId, requestParameters.jobId, requestParameters.cursor, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobApplicantsDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobApplicantsDetails(requestParameters: JobApiApiJobApiGetJobApplicantsDetailsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobApplicantsDetails(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobApplicantsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobApplicantsList(requestParameters: JobApiApiJobApiGetJobApplicantsListRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobApplicantsList(requestParameters.jobId, requestParameters.orgId, requestParameters.applicantListParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobApplicantsMetaDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobApplicantsMetaData(requestParameters: JobApiApiJobApiGetJobApplicantsMetaDataRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobApplicantsMetaData(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobById(requestParameters: JobApiApiJobApiGetJobByIdRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobById(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobByIdForAppliedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobByIdForApplied(requestParameters: JobApiApiJobApiGetJobByIdForAppliedRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobByIdForApplied(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobByIdForCandidateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobByIdForCandidate(requestParameters: JobApiApiJobApiGetJobByIdForCandidateRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobByIdForCandidate(requestParameters.jobId, requestParameters.isSkillPopupRequired, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobByIdForCandidatePublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobByIdForCandidatePublic(requestParameters: JobApiApiJobApiGetJobByIdForCandidatePublicRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobByIdForCandidatePublic(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobByIdForEmployerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobByIdForEmployer(requestParameters: JobApiApiJobApiGetJobByIdForEmployerRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobByIdForEmployer(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobByIdSlimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobByIdSlim(requestParameters: JobApiApiJobApiGetJobByIdSlimRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobByIdSlim(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobCandidateJourneyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobCandidateJourney(requestParameters: JobApiApiJobApiGetJobCandidateJourneyRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobCandidateJourney(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobCompetitionAnsweredQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobCompetitionAnsweredQuestions(requestParameters: JobApiApiJobApiGetJobCompetitionAnsweredQuestionsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobCompetitionAnsweredQuestions(requestParameters.applicantUserId, requestParameters.competitionId, requestParameters.jobId, requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobCompetitionStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobCompetitionStatistics(requestParameters: JobApiApiJobApiGetJobCompetitionStatisticsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobCompetitionStatistics(requestParameters.competitionId, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobEmailPreferences(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobEmailPreferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobEvaluationCandidatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobEvaluationCandidates(requestParameters: JobApiApiJobApiGetJobEvaluationCandidatesRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobEvaluationCandidates(requestParameters.evaluationId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobEvaluationDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobEvaluationDetail(requestParameters: JobApiApiJobApiGetJobEvaluationDetailRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobEvaluationDetail(requestParameters.evaluationId, requestParameters.jobId, requestParameters.orgId, requestParameters.ensureCompetition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobMatchingEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobMatchingEntities(requestParameters: JobApiApiJobApiGetJobMatchingEntitiesRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobMatchingEntities(requestParameters.jobId, requestParameters.autoApplyEnabled, requestParameters.endDate, requestParameters.hasApplied, requestParameters.jobRoleList, requestParameters.maxExperience, requestParameters.minExperience, requestParameters.notified, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.skillIds, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobMatchingUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobMatchingUsers(requestParameters: JobApiApiJobApiGetJobMatchingUsersRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobMatchingUsers(requestParameters.jobId, requestParameters.autoApplyEnabled, requestParameters.endDate, requestParameters.hasApplied, requestParameters.jobRoleList, requestParameters.maxExperience, requestParameters.minExperience, requestParameters.notified, requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.skillIds, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobPostedListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobPostedList(requestParameters: JobApiApiJobApiGetJobPostedListRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobPostedList(requestParameters.isArchieved, requestParameters.isCompetitive, requestParameters.isGptJob, requestParameters.jobStatus, requestParameters.orgId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.planTypeList, requestParameters.productType, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobProfileMatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobProfileMatch(requestParameters: JobApiApiJobApiGetJobProfileMatchRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobProfileMatch(requestParameters.jobId, requestParameters.orgId, requestParameters.profileMatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobProfileMatchByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobProfileMatchById(requestParameters: JobApiApiJobApiGetJobProfileMatchByIdRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobProfileMatchById(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, requestParameters.showContacts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobProfileMilestone(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobProfileMilestone(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobRelatedMocktestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobRelatedMocktests(requestParameters: JobApiApiJobApiGetJobRelatedMocktestsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobRelatedMocktests(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobReports(requestParameters: JobApiApiJobApiGetJobReportsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobReports(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobRoleSkillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobRoleSkills(requestParameters: JobApiApiJobApiGetJobRoleSkillsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobRoleSkills(requestParameters.jobRoleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobRoleSuggestions(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobRoleSuggestions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobSkillSuggestions(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobSkillSuggestions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobSkillsAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobSkillsAutocomplete(requestParameters: JobApiApiJobApiGetJobSkillsAutocompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobSkillsAutocomplete(requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.searchType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobStatistics(requestParameters: JobApiApiJobApiGetJobStatisticsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobStatistics(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobSummary(requestParameters: JobApiApiJobApiGetJobSummaryRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobSummary(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobUnreadMessageCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobUnreadMessageCount(requestParameters: JobApiApiJobApiGetJobUnreadMessageCountRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobUnreadMessageCount(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobsGoogleAdsMetadataCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobsGoogleAdsMetadataCsv(requestParameters: JobApiApiJobApiGetJobsGoogleAdsMetadataCsvRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobsGoogleAdsMetadataCsv(requestParameters.getOrgCsvParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobsGroupPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobsGroupPublic(requestParameters: JobApiApiJobApiGetJobsGroupPublicRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobsGroupPublic(requestParameters.jobRoleIds, requestParameters.locationName, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetJobsLocationsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetJobsLocationsPublic(requestParameters: JobApiApiJobApiGetJobsLocationsPublicRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetJobsLocationsPublic(requestParameters.jobRoleIds, requestParameters.locationName, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetLatestResumeJobFitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetLatestResumeJobFit(requestParameters: JobApiApiJobApiGetLatestResumeJobFitRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetLatestResumeJobFit(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetMatchingJobsDeckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetMatchingJobsDeck(requestParameters: JobApiApiJobApiGetMatchingJobsDeckRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetMatchingJobsDeck(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetOrgApplicantChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetOrgApplicantChats(requestParameters: JobApiApiJobApiGetOrgApplicantChatsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetOrgApplicantChats(requestParameters.orgId, requestParameters.jobRoleId, requestParameters.page, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetOrgChatJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetOrgChatJobs(requestParameters: JobApiApiJobApiGetOrgChatJobsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetOrgChatJobs(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetOrgJobIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetOrgJobIds(requestParameters: JobApiApiJobApiGetOrgJobIdsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetOrgJobIds(requestParameters.jobAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetPublicCompanyJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetPublicCompanyJobs(requestParameters: JobApiApiJobApiGetPublicCompanyJobsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetPublicCompanyJobs(requestParameters.companyAlias, requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetPublicCompanyStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetPublicCompanyStatistics(requestParameters: JobApiApiJobApiGetPublicCompanyStatisticsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetPublicCompanyStatistics(requestParameters.companyAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetRecruiterEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetRecruiterEmail(requestParameters: JobApiApiJobApiGetRecruiterEmailRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetRecruiterEmail(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetResumeBuilderAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetResumeBuilderAnalysis(requestParameters: JobApiApiJobApiGetResumeBuilderAnalysisRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetResumeBuilderAnalysis(requestParameters.analysisId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetResumeBuilderData(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetResumeBuilderData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetResumeBuilderDataByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetResumeBuilderDataById(requestParameters: JobApiApiJobApiGetResumeBuilderDataByIdRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetResumeBuilderDataById(requestParameters.resumeBuilderId, requestParameters.versionNo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetResumeBuilderVersionsByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetResumeBuilderVersionsById(requestParameters: JobApiApiJobApiGetResumeBuilderVersionsByIdRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetResumeBuilderVersionsById(requestParameters.resumeBuilderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetResumeJobFitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetResumeJobFit(requestParameters: JobApiApiJobApiGetResumeJobFitRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetResumeJobFit(requestParameters.jobId, requestParameters.userResumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetResumeJobFitQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetResumeJobFitQuestions(requestParameters: JobApiApiJobApiGetResumeJobFitQuestionsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetResumeJobFitQuestions(requestParameters.jobId, requestParameters.userResumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetScreeningInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetScreeningInsights(requestParameters: JobApiApiJobApiGetScreeningInsightsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetScreeningInsights(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetSimilarJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetSimilarJobs(requestParameters: JobApiApiJobApiGetSimilarJobsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetSimilarJobs(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetSitemapUrls(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetSitemapUrls(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetSpecializationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetSpecialization(requestParameters: JobApiApiJobApiGetSpecializationRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetSpecialization(requestParameters.approvalStatus, requestParameters.degreeId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.specializationId, requestParameters.userSearchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetSpotlightOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetSpotlightOptions(requestParameters: JobApiApiJobApiGetSpotlightOptionsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetSpotlightOptions(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetSystemActivityLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetSystemActivityLogs(requestParameters: JobApiApiJobApiGetSystemActivityLogsRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetSystemActivityLogs(requestParameters.activityTypeList, requestParameters.applicantId, requestParameters.jobIds, requestParameters.maxDate, requestParameters.minDate, requestParameters.orgIds, requestParameters.pageNo, requestParameters.pageSize, requestParameters.userId, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetUserActivityLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetUserActivityLogs(requestParameters: JobApiApiJobApiGetUserActivityLogsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetUserActivityLogs(requestParameters.orgId, requestParameters.activityType, requestParameters.applicantId, requestParameters.jobId, requestParameters.maxDate, requestParameters.minDate, requestParameters.pageNo, requestParameters.pageSize, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetUserActivityLogsDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetUserActivityLogsDetails(requestParameters: JobApiApiJobApiGetUserActivityLogsDetailsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetUserActivityLogsDetails(requestParameters.activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiGetUserSkillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGetUserSkill(requestParameters: JobApiApiJobApiGetUserSkillRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGetUserSkill(requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiGovernorDryRun(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiGovernorDryRun(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiHighlightJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiHighlightJob(requestParameters: JobApiApiJobApiHighlightJobRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiHighlightJob(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiInitialiseJobData(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiInitialiseJobData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiInitialiseJobDataCompany(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiInitialiseJobDataCompany(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiInitiateJobApplicationPreAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiInitiateJobApplicationPreAnalysis(requestParameters: JobApiApiJobApiInitiateJobApplicationPreAnalysisRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiInitiateJobApplicationPreAnalysis(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiInviteUsersJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiInviteUsersJob(requestParameters: JobApiApiJobApiInviteUsersJobRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiInviteUsersJob(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, requestParameters.jobInvitationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiJobApplicantChatMarkSeenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiJobApplicantChatMarkSeen(requestParameters: JobApiApiJobApiJobApplicantChatMarkSeenRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiJobApplicantChatMarkSeen(requestParameters.applicantId, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiJobMatchEmailDailyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiJobMatchEmailDaily(requestParameters: JobApiApiJobApiJobMatchEmailDailyRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiJobMatchEmailDaily(requestParameters.jobId, requestParameters.days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiJobMatchEmailPreflightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiJobMatchEmailPreflight(requestParameters: JobApiApiJobApiJobMatchEmailPreflightRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiJobMatchEmailPreflight(requestParameters.jobId, requestParameters.appliedActivityMode, requestParameters.appliedInLastDays, requestParameters.exactOnly, requestParameters.hardExperience, requestParameters.loginActivityMode, requestParameters.loginInLastDays, requestParameters.maxExperience, requestParameters.minExperience, requestParameters.neverOpenedOnly, requestParameters.savedBand, requestParameters.studentsOnly, requestParameters.withCeilings, requestParameters.withSendable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiJobMatchEmailReachRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiJobMatchEmailReach(requestParameters: JobApiApiJobApiJobMatchEmailReachRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiJobMatchEmailReach(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiJobMatchEmailStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiJobMatchEmailStats(requestParameters: JobApiApiJobApiJobMatchEmailStatsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiJobMatchEmailStats(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiJobSpecializationAutoCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiJobSpecializationAutoComplete(requestParameters: JobApiApiJobApiJobSpecializationAutoCompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiJobSpecializationAutoComplete(requestParameters.degreeIds, requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, requestParameters.specializationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiListGovernorCandidatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiListGovernorCandidates(requestParameters: JobApiApiJobApiListGovernorCandidatesRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiListGovernorCandidates(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiListJobEvaluationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiListJobEvaluations(requestParameters: JobApiApiJobApiListJobEvaluationsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiListJobEvaluations(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiListOrgEvaluationQuestionSourcesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiListOrgEvaluationQuestionSources(requestParameters: JobApiApiJobApiListOrgEvaluationQuestionSourcesRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiListOrgEvaluationQuestionSources(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiListResumeBuilderAnalysesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiListResumeBuilderAnalyses(requestParameters: JobApiApiJobApiListResumeBuilderAnalysesRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiListResumeBuilderAnalyses(requestParameters.resumeBuilderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiLocationCountryBackfillRoute(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiLocationCountryBackfillRoute(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiLocationCountryHealthRoute(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiLocationCountryHealthRoute(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiMarkJobAsNotInterestedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiMarkJobAsNotInterested(requestParameters: JobApiApiJobApiMarkJobAsNotInterestedRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiMarkJobAsNotInterested(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiMarkJobSkippedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiMarkJobSkipped(requestParameters: JobApiApiJobApiMarkJobSkippedRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiMarkJobSkipped(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiMergeDuplicateCollegesCompanies(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiMergeDuplicateCollegesCompanies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiMigrateData(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiMigrateData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiMigrateDataCompany(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiMigrateDataCompany(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiMigrateDataCompanyTask(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiMigrateDataCompanyTask(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiMigrateDataTask(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiMigrateDataTask(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiPopulateMissingApplicantMatchesForAllJobs(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiPopulateMissingApplicantMatchesForAllJobs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiPublicDegreeAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiPublicDegreeAutocomplete(requestParameters: JobApiApiJobApiPublicDegreeAutocompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiPublicDegreeAutocomplete(requestParameters.pageNo, requestParameters.pageSize, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * count — the location twin of /skill-suggestions and /role-suggestions.  Unauthenticated on purpose: it reports nothing the browse facets and the sitemap don\'t already publish. Device type changes the counts (external jobs are hidden from the native app), so it is resolved here and passed in — the controller is memoized, so it has to be part of the cache key rather than read from the request inside.
     * @summary Places the location filter can be set to, each with its live-posting
     * @param {JobApiApiJobApiPublicJobLocationSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiPublicJobLocationSuggestions(requestParameters: JobApiApiJobApiPublicJobLocationSuggestionsRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiPublicJobLocationSuggestions(requestParameters.pageSize, requestParameters.searchQuery, requestParameters.workMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiPublicJobRoleSuggestions(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiPublicJobRoleSuggestions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiPublicJobSkillSuggestions(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiPublicJobSkillSuggestions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiPublishJobCompetitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiPublishJobCompetition(requestParameters: JobApiApiJobApiPublishJobCompetitionRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiPublishJobCompetition(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiReanalyzeApplicantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiReanalyzeApplicant(requestParameters: JobApiApiJobApiReanalyzeApplicantRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiReanalyzeApplicant(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiRebuildMatchingProfilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiRebuildMatchingProfiles(requestParameters: JobApiApiJobApiRebuildMatchingProfilesRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiRebuildMatchingProfiles(requestParameters.reBuildJobMatchingProfiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiRefreshBqFacetCachesApi(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiRefreshBqFacetCachesApi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiRegenerateJobChallengeQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiRegenerateJobChallengeQuestion(requestParameters: JobApiApiJobApiRegenerateJobChallengeQuestionRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiRegenerateJobChallengeQuestion(requestParameters.competitionId, requestParameters.jobId, requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiRejectJobInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiRejectJobInvitation(requestParameters: JobApiApiJobApiRejectJobInvitationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiRejectJobInvitation(requestParameters.jobId, requestParameters.userId, requestParameters.jobInviteRejectBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiRejectJobProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiRejectJobProfile(requestParameters: JobApiApiJobApiRejectJobProfileRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiRejectJobProfile(requestParameters.jobId, requestParameters.userResumeEntityList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiRejectJobProfileByEmployerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiRejectJobProfileByEmployer(requestParameters: JobApiApiJobApiRejectJobProfileByEmployerRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiRejectJobProfileByEmployer(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiReminderEmailAllMatchingJobProfilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiReminderEmailAllMatchingJobProfiles(requestParameters: JobApiApiJobApiReminderEmailAllMatchingJobProfilesRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiReminderEmailAllMatchingJobProfiles(requestParameters.jobId, requestParameters.userResumeEntityListRemainderCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiRemoveExternalApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiRemoveExternalApplication(requestParameters: JobApiApiJobApiRemoveExternalApplicationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiRemoveExternalApplication(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiRequestBulkAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiRequestBulkAnalysis(requestParameters: JobApiApiJobApiRequestBulkAnalysisRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiRequestBulkAnalysis(requestParameters.jobId, requestParameters.orgId, requestParameters.getFilteredApplicantUserIdsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiRestoreResumeBuilderAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiRestoreResumeBuilderAnalysis(requestParameters: JobApiApiJobApiRestoreResumeBuilderAnalysisRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiRestoreResumeBuilderAnalysis(requestParameters.analysisId, requestParameters.resumeBuilderRestoreBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiResumePdfBuilder(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiResumePdfBuilder(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiReviewJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiReviewJobs(requestParameters: JobApiApiJobApiReviewJobsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiReviewJobs(requestParameters.reviewJobParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiRewriteResumeSnippetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiRewriteResumeSnippet(requestParameters: JobApiApiJobApiRewriteResumeSnippetRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiRewriteResumeSnippet(requestParameters.rewriteSnippetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiSendAssessmentMessageToApplicantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiSendAssessmentMessageToApplicants(requestParameters: JobApiApiJobApiSendAssessmentMessageToApplicantsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiSendAssessmentMessageToApplicants(requestParameters.jobId, requestParameters.orgId, requestParameters.sendAssessmentMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiSendBqEmailsApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiSendBqEmailsApi(requestParameters: JobApiApiJobApiSendBqEmailsApiRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiSendBqEmailsApi(requestParameters.bqSendEmailsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiSendJobMatchEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiSendJobMatchEmails(requestParameters: JobApiApiJobApiSendJobMatchEmailsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiSendJobMatchEmails(requestParameters.jobId, requestParameters.jobMatchEmailSendBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiSendJobMatchTestEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiSendJobMatchTestEmail(requestParameters: JobApiApiJobApiSendJobMatchTestEmailRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiSendJobMatchTestEmail(requestParameters.jobId, requestParameters.jobMatchEmailTestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiSetAssessmentResponseScoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiSetAssessmentResponseScore(requestParameters: JobApiApiJobApiSetAssessmentResponseScoreRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiSetAssessmentResponseScore(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.insertAssessmentScoreBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiSetEvaluationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiSetEvaluationStatus(requestParameters: JobApiApiJobApiSetEvaluationStatusRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiSetEvaluationStatus(requestParameters.evaluationId, requestParameters.jobId, requestParameters.orgId, requestParameters.evaluationStatusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiSetupBqTablesApi(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiSetupBqTablesApi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiSpecializationAutoCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiSpecializationAutoComplete(requestParameters: JobApiApiJobApiSpecializationAutoCompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiSpecializationAutoComplete(requestParameters.degreeId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.query, requestParameters.specializationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiSubmitEvaluationAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiSubmitEvaluationAssignment(requestParameters: JobApiApiJobApiSubmitEvaluationAssignmentRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiSubmitEvaluationAssignment(requestParameters.jobEvaluationId, requestParameters.jobId, requestParameters.submitEvaluationAssignmentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiSubmitJobAssessmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiSubmitJobAssessment(requestParameters: JobApiApiJobApiSubmitJobAssessmentRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiSubmitJobAssessment(requestParameters.jobId, requestParameters.jobAssessmentSubmitBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiTestSpotlightWhatsapp(options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiTestSpotlightWhatsapp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUnlockApplicantAiScoresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUnlockApplicantAiScores(requestParameters: JobApiApiJobApiUnlockApplicantAiScoresRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUnlockApplicantAiScores(requestParameters.jobId, requestParameters.orgId, requestParameters.expectedCost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUnlockDbAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUnlockDbAccess(requestParameters: JobApiApiJobApiUnlockDbAccessRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUnlockDbAccess(requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUnlockInviteProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUnlockInviteProfile(requestParameters: JobApiApiJobApiUnlockInviteProfileRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUnlockInviteProfile(requestParameters.jobId, requestParameters.orgId, requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateApplicantNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateApplicantNote(requestParameters: JobApiApiJobApiUpdateApplicantNoteRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateApplicantNote(requestParameters.jobId, requestParameters.noteId, requestParameters.orgId, requestParameters.createApplicantNoteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateApplicantRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateApplicantRating(requestParameters: JobApiApiJobApiUpdateApplicantRatingRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateApplicantRating(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.ratingValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateAssessmentFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateAssessmentField(requestParameters: JobApiApiJobApiUpdateAssessmentFieldRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateAssessmentField(requestParameters.assessmentId, requestParameters.fieldId, requestParameters.createAssessmentFieldBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateAssessmentResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateAssessmentResponse(requestParameters: JobApiApiJobApiUpdateAssessmentResponseRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateAssessmentResponse(requestParameters.assessmentResponseId, requestParameters.createAssessmentResponsedBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateDegreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateDegree(requestParameters: JobApiApiJobApiUpdateDegreeRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateDegree(requestParameters.updateDegreeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateExternalApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateExternalApplication(requestParameters: JobApiApiJobApiUpdateExternalApplicationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateExternalApplication(requestParameters.jobId, requestParameters.externalApplicationStatusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateFieldPositionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateFieldPosition(requestParameters: JobApiApiJobApiUpdateFieldPositionRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateFieldPosition(requestParameters.assessmentId, requestParameters.updateFieldPositionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateGptJobAnalysisStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateGptJobAnalysisStatus(requestParameters: JobApiApiJobApiUpdateGptJobAnalysisStatusRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateGptJobAnalysisStatus(requestParameters.jobId, requestParameters.updateJobAnalysisStatusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateHiringStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateHiringStatus(requestParameters: JobApiApiJobApiUpdateHiringStatusRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateHiringStatus(requestParameters.applicantId, requestParameters.jobId, requestParameters.orgId, requestParameters.updateHiringStatusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateJob(requestParameters: JobApiApiJobApiUpdateJobRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateJob(requestParameters.jobId, requestParameters.orgId, requestParameters.updateJobBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateJobAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateJobAdmin(requestParameters: JobApiApiJobApiUpdateJobAdminRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateJobAdmin(requestParameters.adminUpdateJobBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateJobApplicantMsgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateJobApplicantMsg(requestParameters: JobApiApiJobApiUpdateJobApplicantMsgRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateJobApplicantMsg(requestParameters.chatId, requestParameters.jobId, requestParameters.addApplicantMessageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateJobApplicantTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateJobApplicantTag(requestParameters: JobApiApiJobApiUpdateJobApplicantTagRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateJobApplicantTag(requestParameters.jobId, requestParameters.orgId, requestParameters.updateJobApplicantTagBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateJobBookmarkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateJobBookmark(requestParameters: JobApiApiJobApiUpdateJobBookmarkRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateJobBookmark(requestParameters.jobId, requestParameters.bookmark, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateJobEmailPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateJobEmailPreferences(requestParameters: JobApiApiJobApiUpdateJobEmailPreferencesRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateJobEmailPreferences(requestParameters.jobEmailPreferenceUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateJobEvaluationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateJobEvaluation(requestParameters: JobApiApiJobApiUpdateJobEvaluationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateJobEvaluation(requestParameters.evaluationId, requestParameters.jobId, requestParameters.orgId, requestParameters.jobEvaluationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateJobProfileSkillBuilderScoresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateJobProfileSkillBuilderScores(requestParameters: JobApiApiJobApiUpdateJobProfileSkillBuilderScoresRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateJobProfileSkillBuilderScores(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateReactionMsgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateReactionMsg(requestParameters: JobApiApiJobApiUpdateReactionMsgRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateReactionMsg(requestParameters.chatId, requestParameters.chatReactionId, requestParameters.jobId, requestParameters.message, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateResumeBuilderDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateResumeBuilderDetails(requestParameters: JobApiApiJobApiUpdateResumeBuilderDetailsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateResumeBuilderDetails(requestParameters.resumeBuilderId, requestParameters.versionNo, requestParameters.updateResumeBuilderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateSkillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateSkill(requestParameters: JobApiApiJobApiUpdateSkillRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateSkill(requestParameters.skillId, requestParameters.updateSkillBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpdateSpecializationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpdateSpecialization(requestParameters: JobApiApiJobApiUpdateSpecializationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpdateSpecialization(requestParameters.updateSpecializationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpsertCandidateMetaDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpsertCandidateMetaDetails(requestParameters: JobApiApiJobApiUpsertCandidateMetaDetailsRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpsertCandidateMetaDetails(requestParameters.upsertCandidateDetailsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiUpsertGovernorPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiUpsertGovernorPlans(requestParameters: JobApiApiJobApiUpsertGovernorPlansRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiUpsertGovernorPlans(requestParameters.governorPlanBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobApiApiJobApiWithdrawJobApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public jobApiWithdrawJobApplication(requestParameters: JobApiApiJobApiWithdrawJobApplicationRequest, options?: RawAxiosRequestConfig) {
        return JobApiApiFp(this.configuration).jobApiWithdrawJobApplication(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const JobApiBqAudienceExportApiFormatEnum = {
    Csv: 'csv',
    Json: 'json',
} as const;
export type JobApiBqAudienceExportApiFormatEnum = typeof JobApiBqAudienceExportApiFormatEnum[keyof typeof JobApiBqAudienceExportApiFormatEnum];
export const JobApiBqAutocompleteApiFieldEnum = {
    Position: 'position',
    Title: 'title',
    Location: 'location',
    Country: 'country',
    Category: 'category',
    Company: 'company',
    Scraper: 'scraper',
    Tag: 'tag',
} as const;
export type JobApiBqAutocompleteApiFieldEnum = typeof JobApiBqAutocompleteApiFieldEnum[keyof typeof JobApiBqAutocompleteApiFieldEnum];
export const JobApiJobMatchEmailPreflightAppliedActivityModeEnum = {
    Applied: 'applied',
    NotApplied: 'not_applied',
} as const;
export type JobApiJobMatchEmailPreflightAppliedActivityModeEnum = typeof JobApiJobMatchEmailPreflightAppliedActivityModeEnum[keyof typeof JobApiJobMatchEmailPreflightAppliedActivityModeEnum];
export const JobApiJobMatchEmailPreflightLoginActivityModeEnum = {
    LoggedIn: 'logged_in',
    NotLoggedIn: 'not_logged_in',
} as const;
export type JobApiJobMatchEmailPreflightLoginActivityModeEnum = typeof JobApiJobMatchEmailPreflightLoginActivityModeEnum[keyof typeof JobApiJobMatchEmailPreflightLoginActivityModeEnum];
export const JobApiPublicJobLocationSuggestionsWorkModeEnum = {
    Remote: 'Remote',
    OnSite: 'OnSite',
    Hybrid: 'Hybrid',
} as const;
export type JobApiPublicJobLocationSuggestionsWorkModeEnum = typeof JobApiPublicJobLocationSuggestionsWorkModeEnum[keyof typeof JobApiPublicJobLocationSuggestionsWorkModeEnum];
